<template>
  <div>
    <SidebarVue ref="sidebar" />
    <NavgatorDk
      ref="navgator"
      :barraTitulo="' Informações do Cliente'"
      :titulo="'atendimento '"
    />

    <!--Bloco dados do cliente-->
    <div class="card-container">
      <div class="card">
        <div class="row g-2 p-2">
          <h5 class="section-title linha">
            <i class="bi bi-file-earmark-text me-2 icon-text-form-title"></i
            >Informações do Atendimento
          </h5>
        </div>
        <form @submit.prevent="onSubmit" class="p-3">
          <!-- Seção: Informações da Proposta -->
          <div class="mb-4">
            <div class="row g-2">
              <!-- Nº Proposta -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="id_proposta"
                    disabled
                  />
                  <label class="">Nº Atendimento</label>
                </div>
              </div>

              <!-- Atendente -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="recepcionista"
                    disabled
                  />
                  <label>Atendente</label>
                </div>
              </div>

              <!-- Vendedor -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="vendedor_info"
                    disabled
                  />
                  <label>Vendedor</label>
                </div>
              </div>

              <!-- Mídia -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="midia_informada"
                    disabled
                  />
                  <label>Mídia</label>
                </div>
              </div>

              <!-- Venda Direta -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="cliente_pcd"
                    disabled
                  />
                  <label>Venda Direta</label>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
            <!-- Botões de Ação - Mobile (apenas ícones) -->
            <div class="d-flex d-md-none gap-2">
              <button
                type="button"
                class="btn round-btn d-flex align-items-center justify-content-center"
                data-bs-toggle="modal"
                data-bs-target="#ModalTrocarMidia"
                @click="retrieveMidia"
              >
                <i class="bi bi-megaphone" title="Alterar Mídia"></i>
              </button>
              <button
                type="button"
                class="btn round-btn d-flex align-items-center justify-content-center"
                style="width: 44px; height: 44px"
                @click="habilitar_cadastro"
              >
                <i class="bi bi-toggle-on" title="Habilitar Cadastro"></i>
              </button>
            </div>

            <!-- Botões de Ação - Tablet (768px - 991px) -->
            <div class="d-none d-md-flex d-lg-none gap-2">
              <button
                type="button"
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                data-bs-toggle="modal"
                data-bs-target="#ModalTrocarMidia"
                @click="retrieveMidia"
              >
                <i class="bi bi-megaphone me-1" style="font-size: 0.9rem"></i>
                <span>Alterar Mídia</span>
              </button>
              <button
                type="button"
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                @click="habilitar_cadastro"
              >
                <i class="bi bi-toggle-on me-1" style="font-size: 0.9rem"></i>
                <span>Habilitar Cadastro</span>
              </button>
            </div>

            <!-- Botões de Ação - Desktop (≥ 992px) -->
            <div class="d-none d-lg-flex gap-2">
              <button
                type="button"
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                data-bs-toggle="modal"
                data-bs-target="#ModalTrocarMidia"
                @click="retrieveMidia"
              >
                <i class="bi bi-megaphone me-2"></i>
                <span>Alterar Mídia</span>
              </button>
              <button
                type="button"
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                @click="habilitar_cadastro"
              >
                <i class="bi bi-toggle-on me-2"></i>
                <span>Habilitar Cadastro</span>
              </button>
            </div>
          </div>

          <!-- Seção: Dados Pessoais -->
          <div class="mb-4">
            <h6 class="section-title mb-2">
              <i class="bi bi-person-vcard me-2 icon-text-form-title"></i>Dados
              Pessoais
            </h6>
            <div class="row g-2">
              <!-- CPF/CNPJ -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="cpfCnpj"
                    :style="{ 'border-color': cnpjBorderColor }"
                    :disabled="input_cliente"
                    required
                    @blur="vData"
                  />
                  <label>CPF/CNPJ</label>
                </div>
              </div>

              <!-- Nome do Cliente -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-4">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="cliente"
                    :style="{ 'border-color': nomeBorderColor }"
                    :disabled="input_cliente"
                    required
                  />
                  <label>Nome do Cliente</label>
                </div>
              </div>

              <!-- Data Nascimento -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating">
                  <input
                    type="date"
                    class="form-control txt-form-input"
                    v-model="dataNascimento"
                    :style="{ 'border-color': dataNascimentoBorderColor }"
                    :disabled="input_cliente"
                    autocomplete="off"
                  />
                  <label>Data Nascimento</label>
                </div>
              </div>

              <!-- Email -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-4">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="email"
                    @blur="validateEmail(email)"
                    :style="{ 'border-color': emailBorderColor }"
                    :disabled="input_cliente"
                  />
                  <label>Email</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Seção: Endereço -->
          <div class="mb-4">
            <h6 class="section-title mb-2">
              <i class="bi bi-house-door me-2 icon-text-form-title"></i>Endereço
            </h6>
            <div class="row g-3">
              <!-- Endereço -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-4">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="endereco"
                    :style="{ 'border-color': enderecoBorderColor }"
                    :disabled="input_cliente"
                    required
                    autocomplete="off"
                  />
                  <label>Endereço</label>
                </div>
              </div>

              <!-- Complemento -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="complemento"
                    :style="{ 'border-color': complementoBorderColor }"
                    :disabled="input_cliente"
                    autocomplete="off"
                  />
                  <label>Complemento</label>
                </div>
              </div>

              <!-- UF -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-1">
                <div class="form-floating">
                  <input
                    v-model="uf"
                    class="form-control txt-form-input"
                    :style="{ 'border-color': ufBorderColor }"
                    :disabled="input_cliente"
                    list="datalistOptions"
                    id="estado"
                    required
                    autocomplete="off"
                  />
                  <label>UF</label>
                  <datalist id="datalistOptions">
                    <option
                      v-for="opt in estados"
                      :data-value="opt.id"
                      :value="opt.sigla"
                      :key="opt.id"
                    ></option>
                  </datalist>
                </div>
              </div>

              <!-- Cidade -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating">
                  <input
                    v-model="cidade"
                    class="form-control txt-form-input"
                    :style="{ 'border-color': cidadeBorderColor }"
                    :disabled="input_cliente"
                    list="datalistCidades"
                    id="cidade"
                    required
                    autocomplete="off"
                  />
                  <label>Cidade</label>
                  <datalist id="datalistCidades">
                    <option
                      v-for="opt in cidades"
                      :data-value="opt.id"
                      :value="opt.nome"
                      :key="opt.id"
                    ></option>
                  </datalist>
                </div>
              </div>

              <!-- Bairro -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="bairro"
                    :style="{ 'border-color': bairroBorderColor }"
                    :disabled="input_cliente"
                    autocomplete="off"
                    required
                  />
                  <label>Bairro</label>
                </div>
              </div>

              <!-- CEP -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-1">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="cep"
                    :style="{ 'border-color': cepBorderColor }"
                    :disabled="input_cliente"
                    autocomplete="off"
                    required
                  />
                  <label>CEP</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Seção: Contatos -->
          <div class="mb-4">
            <h6 class="section-title mb-2">
              <i class="bi bi-telephone me-2 icon-text-form-title"></i>Contatos
            </h6>
            <div class="row g-3">
              <!-- Telefone 1 -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="tel"
                    :style="{ 'border-color': telBorderColor }"
                    :disabled="input_cliente"
                    required
                    @blur="vTel"
                  />
                  <label>Telefone</label>
                </div>
              </div>

              <!-- Telefone 2 -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="cel"
                    :style="{ 'border-color': celBorderColor }"
                    :disabled="input_cliente"
                    @blur="vTel2"
                  />
                  <label>Telefone 2</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Seção: Ações -->
          <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
            <!-- Botões de Ação - Mobile (apenas ícones) -->
            <div class="d-flex d-md-none gap-2">
              <button
                type="button"
                class="btn round-btn d-flex align-items-center justify-content-center"
                data-bs-target="#ModalHistoricoCliente"
                data-bs-toggle="modal"
                @click="habilitar_historico_cliente"
              >
                <i class="bi bi-clock-history" title="Histórico Cliente"></i>
              </button>
              <button
                type="button"
                class="btn round-btn d-flex align-items-center justify-content-center"
                style="width: 44px; height: 44px"
                :disabled="input_cliente || cliente_update_disabled"
                @click="atualizar_cliente()"
              >
                <i class="bi bi-arrow-clockwise" title="Atualizar"></i>
              </button>
            </div>
            <!-- Botões de Ação - Tablet (768px - 991px) -->
            <div class="d-none d-md-flex d-lg-none gap-2">
              <button
                type="button"
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                data-bs-target="#ModalHistoricoCliente"
                data-bs-toggle="modal"
                @click="habilitar_historico_cliente"
              >
                <i
                  class="bi bi-clock-history me-2"
                  style="font-size: 0.9rem"
                ></i>
                <span>Histórico</span>
              </button>
              <button
                type="button"
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                :disabled="input_cliente || cliente_update_disabled"
                @click="atualizar_cliente()"
              >
                <span>Atualizar</span>
              </button>
            </div>
            <!-- Botões de Ação - Desktop (≥ 992px) -->
            <div class="d-none d-lg-flex gap-2">
              <button
                type="button"
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                data-bs-target="#ModalHistoricoCliente"
                data-bs-toggle="modal"
                @click="habilitar_historico_cliente"
              >
                <i class="bi bi-clock-history me-2"></i>
                <span>Histórico</span>
              </button>
              <button
                type="button"
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                :disabled="input_cliente || cliente_update_disabled"
                @click="atualizar_cliente()"
              >
                <span>Atualizar</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!--Bloco Veiculos-->
    <div class="card-container">
      <div class="card">
        <div class="row g-2 p-2">
          <h6 class="section-title mb-3 linha">
            <i class="bi bi-car-front-fill me-2 icon-text-form-title"></i>
            Informações do Veículo
          </h6>
        </div>
        <!--Veículos para compra-->
        <form @submit.prevent="onSubmitVeiculo" class="p-3">
          <div class="mb-4">
            <div class="row g-3">
              <!--Chassi-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="chassi_proposta"
                    :disabled="true"
                  />
                  <label>Chassi</label>
                </div>
              </div>
              <!--Marca-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="marca_proposta"
                    :disabled="true"
                  />
                  <label>Marca</label>
                </div>
              </div>
              <!--Modelo-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-4">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="modelo_proposta"
                    :disabled="true"
                  />
                  <label>Modelo</label>
                </div>
              </div>
              <!--Cor-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-4">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="cor_proposta"
                    :disabled="true"
                  />
                  <label>Cor</label>
                </div>
              </div>
              <!--Ano Fabricação-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="anoFabricacao_proposta"
                    :disabled="true"
                  />
                  <label>Ano Fabricação</label>
                </div>
              </div>
              <!--Ano Modelo-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="anoModelo_proposta"
                    :disabled="true"
                  />
                  <label>Ano Modelo</label>
                </div>
              </div>
              <!--Combustivel-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="combustivel_proposta"
                    :disabled="true"
                  />
                  <label>Combustível</label>
                </div>
              </div>
            </div>
            <!--Venda Futura-->
            <div class="row g-3 mt-1">
              <div
                class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2"
                v-if="venda_Futura"
              >
                <div class="form-floating">
                  <select
                    class="form-select rf_bg_form rf_texto"
                    v-model="selected_familia_veiculo_escolhido"
                    @change="vendaFutura"
                  >
                    <option
                      v-for="item in familia_veiculo_escolhido"
                      :value="item.id"
                      :key="item.id"
                    >
                      {{ item.descricao }}
                    </option>
                  </select>
                  <label class="rf_texto">Família</label>
                </div>
              </div>
              <div
                class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2"
                v-if="venda_Futura"
              >
                <div class="form-floating">
                  <select
                    class="form-select rf_bg_form rf_texto"
                    v-model="selected_modelo_veiculo_escolhido"
                    @change="cor_modelo()"
                  >
                    <option
                      v-for="item in modelo_veiculo_escolhido"
                      :value="item.id"
                      :key="item.id"
                    >
                      {{ item.descricao }}
                    </option>
                  </select>
                  <label class="rf_texto">Modelo</label>
                </div>
              </div>
              <div
                class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2"
                v-if="venda_Futura"
              >
                <div class="form-floating">
                  <select
                    class="form-select rf_bg_form rf_texto"
                    v-model="selected_cor_veiculo_escolhido"
                    @change="
                      completar_modelo(selected_modelo_veiculo_escolhido)
                    "
                  >
                    <option
                      v-for="item in cor_veiculo_escolhido"
                      :value="item.descricao"
                      :key="item.id"
                    >
                      {{ item.descricao }}
                    </option>
                  </select>
                  <label class="rf_texto">Cor</label>
                </div>
              </div>
            </div>
          </div>

          <!-- Seção: Ações -->
          <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
            <!-- Botões de Ação - Mobile (apenas ícones) -->
            <div class="d-flex d-md-none gap-2">
              <button
                type="submit"
                class="btn round-btn d-flex align-items-center justify-content-center"
                data-bs-toggle="modal"
                data-bs-target="#ModalVeiculoEstoque"
                :disabled="inserir_veiculo"
                @click="habilitar_veiculo"
              >
                <i class="bi bi-plus-circle" title="Inserir"></i>
              </button>
              <div class="icon-toggle-wrapper">
                <input
                  type="checkbox"
                  v-model="venda_Futura"
                  @click="select_familia"
                  id="iconToggle"
                  hidden
                />
                <label for="iconToggle" class="icon-toggle-btn">
                  <i
                    class="bi"
                    title="Venda Futura"
                    :class="
                      venda_Futura
                        ? 'bi bi-toggles text-white'
                        : 'bi bi-toggles'
                    "
                  ></i>
                </label>
              </div>
            </div>
            <!-- Botões de Ação - Tablet (768px - 991px) -->
            <div class="d-none d-md-flex d-lg-none gap-2">
              <div class="d-flex align-items-center gap-2">
                <label
                  class="form-check-label mb-0 text-nowrap"
                  style="text-transform: uppercase"
                  for="formToggle"
                >
                  Venda Futura
                </label>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="formToggle"
                    v-model="venda_Futura"
                    @click="select_familia"
                  />
                </div>
              </div>
              <button
                type="button"
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                data-bs-toggle="modal"
                data-bs-target="#ModalVeiculoEstoque"
                :disabled="inserir_veiculo"
                @click="habilitar_veiculo"
              >
                <span>Inserir</span>
              </button>
            </div>
            <!-- Botões de Ação - Desktop (≥ 992px) -->
            <div class="d-none d-lg-flex gap-2">
              <div class="d-flex align-items-center gap-2">
                <label
                  class="form-check-label mb-0 text-nowrap"
                  style="text-transform: uppercase"
                  for="formToggle"
                >
                  Venda Futura
                </label>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="formToggle"
                    v-model="venda_Futura"
                    @click="select_familia"
                  />
                </div>
              </div>
              <button
                type="button"
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                data-bs-toggle="modal"
                data-bs-target="#ModalVeiculoEstoque"
                :disabled="inserir_veiculo"
                @click="habilitar_veiculo"
              >
                <span>Inserir</span>
              </button>
            </div>
          </div>
        </form>
        <div
          v-if="mesmo_veiculo"
          class="d-flex justify-content-center align-items-center flex-column"
        >
          <div class="alert alert-warning text-center" role="alert">
            <span><strong>Veículo encontra-se finalizado!</strong></span
            ><br />
            {{ msg_conteudo }}
            <br />
            <span
              ><strong
                >Deseja inserir o veículo nesse atendimento?</strong
              ></span
            ><br />

            <div class="row justify-content-center mt-3">
              <div class="col text-center">
                <button
                  class="btn btn-lg btn-desk-filtro"
                  @click="propostaMesmoVeiculo()"
                >
                  <span class="rf_texto_btn">Sim</span>
                </button>
              </div>
              <div class="col text-center">
                <button
                  class="btn btn-lg btn-desk-filtro"
                  @click="atualizarPagina"
                >
                  <span class="rf_texto_btn">Não</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Acessórios e Cortesia-->
    <div class="card-container">
      <div class="card">
        <div class="row g-2 p-2">
          <h6 class="section-title mb-3 linha">
            <i class="bi bi-shop me-2 icon-text-form-title"></i>Cortesias
          </h6>
          <div class="card-table-txt">
            <div class="d-md-none">
              <div
                v-for="item in itens_cortesias"
                :key="item.descricao"
                class="accordion mb-2"
              >
                <div class="accordion-item">
                  <button
                    class="accordion-button collapsed card-table-txt"
                    data-bs-toggle="collapse"
                    :data-bs-target="'#row-' + item.id"
                  >
                    {{ item.descricao }}
                  </button>
                  <div
                    :id="'row-' + item.id"
                    class="accordion-collapse collapse"
                  >
                    <div class="accordion-body">
                      <p>
                        <strong>R$ Valor:</strong>
                        {{ item.valor }}
                      </p>
                      <p>
                        <strong>R$ Custo:</strong>
                        {{ item.custo }}
                      </p>
                      <p>
                        <strong>Cortesia ?:</strong>
                        {{ item.cortesia }}
                      </p>

                      <button
                        type="button"
                        class="btn btn-lg btn-table align-self-end"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        @click="editar_acessorio(item)"
                      >
                        <i class="bi bi-pencil-square"></i> Editar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-none d-md-block">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Descrição</th>
                    <th scope="col">R$ Valor</th>
                    <th scope="col">R$ Custo</th>
                    <th scope="col">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in itens_cortesias"
                    :key="item.descricao"
                    class="card-table-item"
                  >
                    <td>{{ item.descricao }}</td>
                    <td>{{ item.valor }}</td>
                    <td>{{ item.custo }}</td>
                    <td>
                      <button
                        type="button"
                        class="dropdown-toggle-icon"
                        @click="excluir_item_ac(item)"
                      >
                        <i class="bi bi-trash"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>Total</td>
                    <td>{{ this.Valor_Itens_Acessorios }}</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Seção: Ações -->
            <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
              <!-- Botões de Ação - Mobile (apenas ícones) -->
              <div class="d-flex d-md-none gap-2">
                <button
                  type="button"
                  class="btn round-btn d-flex align-items-center justify-content-center"
                  data-bs-target="#ModalItensAcessorios"
                  data-bs-toggle="modal"
                  :disabled="inserir_cortesia"
                  @click="habilitar_itens_acessorios"
                >
                  <i class="bi bi-plus-circle" title="Inserir no Acessório"></i>
                </button>
              </div>
              <!-- Botões de Ação - Tablet (768px - 991px) -->
              <div class="d-none d-md-flex d-lg-none gap-2">
                <button
                  type="button"
                  class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                  style="font-size: 0.875rem; white-space: nowrap"
                  data-bs-target="#ModalItensAcessorios"
                  data-bs-toggle="modal"
                  :disabled="inserir_acessorios"
                  @click="habilitar_itens_acessorios"
                >
                  <span>Inserir</span>
                </button>
              </div>
              <!-- Botões de Ação - Desktop (≥ 992px) -->
              <div class="d-none d-lg-flex gap-2">
                <button
                  type="button"
                  class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                  style="font-size: 0.875rem; white-space: nowrap"
                  data-bs-target="#ModalItensAcessorios"
                  data-bs-toggle="modal"
                  :disabled="inserir_acessorios"
                  @click="habilitar_itens_acessorios"
                >
                  <span>Inserir</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Veículos de Entrada-->
    <div class="card-container">
      <div class="card">
        <div class="row g-2 p-2">
          <h6 class="section-title mb-3 linha">
            <i class="bi bi-clipboard-check me-2 icon-text-form-title"></i
            >Veículos de Entrada
          </h6>
          <div class="card-table-txt">
            <!-- Mobile (acordeão) -->
            <div class="d-md-none">
              <div
                v-for="item in veiculos_avaliados"
                :key="item.descricao"
                class="accordion mb-2"
              >
                <div class="accordion-item">
                  <button
                    class="accordion-button collapsed card-table-txt"
                    data-bs-toggle="collapse"
                    :data-bs-target="'#row-' + item.id"
                  >
                    {{ item.modelo }}
                  </button>
                  <div
                    :id="'row-' + item.id"
                    class="accordion-collapse collapse"
                  >
                    <div class="accordion-body">
                      <p><strong>Marca:</strong> {{ item.marca }}</p>
                      <p><strong>Placa:</strong> {{ item.placa }}</p>
                      <p><strong>Ano Modelo:</strong> {{ item.ano_mod }}</p>
                      <p><strong>Cor:</strong> {{ item.cor }}</p>
                      <p>
                        <strong>KM:</strong> {{ formatarKM(item.kilometragem) }}
                      </p>
                      <p>
                        <strong>R$ Avaliado:</strong> {{ item.preco_avaliado }}
                      </p>
                      <div class="row g-2 p-2">
                        <div
                          class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2 d-flex justify-content-center align-items-center"
                        >
                          <button
                            type="button"
                            class="btn round-btn"
                            @click="excluir_veiculo_av(item)"
                          >
                            <i class="bi bi-trash" title="Excluir"></i>
                          </button>
                          <button
                            type="button"
                            class="btn round-btn"
                            data-bs-target="#ModalAvaliacaoVeiculo"
                            data-bs-toggle="modal"
                            :disabled="hab_avaliacao"
                            @click="verificar_avaliacoes_placa(item)"
                          >
                            <i
                              class="bi bi-car-front-fill"
                              title="Histórico de Avaliações"
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end gap-3 mt-4">
                <button
                  type="button"
                  class="btn round-btn"
                  data-bs-target="#ModalVeiculoAvaliacao"
                  data-bs-toggle="modal"
                  @click="habilitar_itens_avaliacao"
                >
                  <i class="bi bi-plus-circle" title="Inserir no Veículo"></i>
                </button>
              </div>
            </div>

            <!-- Tablet (768px - 991px) - Tabela ultra compacta -->
            <div class="d-none d-md-block d-lg-none">
              <div class="table-responsive-lg">
                <table class="table table-sm table-hover mb-1">
                  <thead class="table-light">
                    <tr>
                      <th
                        scope="col"
                        class="text-nowrap"
                        style="font-size: 0.8rem; padding: 4px 6px"
                      >
                        Marca
                      </th>
                      <th
                        scope="col"
                        class="text-nowrap"
                        style="font-size: 0.8rem; padding: 4px 6px"
                      >
                        Modelo
                      </th>
                      <th
                        scope="col"
                        class="text-nowrap"
                        style="font-size: 0.8rem; padding: 4px 6px"
                      >
                        Placa
                      </th>
                      <th
                        scope="col"
                        class="text-nowrap"
                        style="font-size: 0.8rem; padding: 4px 6px"
                      >
                        R$ Av.
                      </th>
                      <th
                        scope="col"
                        class="text-nowrap"
                        style="font-size: 0.8rem; padding: 4px 6px"
                      >
                        R$ Qt.
                      </th>
                      <th
                        scope="col"
                        class="text-nowrap"
                        style="font-size: 0.8rem; padding: 4px 6px; width: 70px"
                      >
                        Ações
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in veiculos_avaliados"
                      :key="item.descricao"
                      class="card-table-item"
                    >
                      <td
                        class="text-nowrap"
                        style="font-size: 0.8rem; padding: 4px 6px"
                      >
                        {{ item.marca }}
                      </td>
                      <td
                        class="text-nowrap"
                        style="font-size: 0.8rem; padding: 4px 6px"
                      >
                        {{ item.modelo }}
                      </td>
                      <td
                        class="text-nowrap"
                        style="font-size: 0.8rem; padding: 4px 6px"
                      >
                        {{ item.placa }}
                      </td>
                      <!-- <td class="text-nowrap" style="font-size: 0.8rem; padding: 4px 6px;">{{ formatarKM(item.kilometragem) }}</td> -->
                      <td
                        class="text-nowrap"
                        style="font-size: 0.8rem; padding: 4px 6px"
                      >
                        {{ item.preco_avaliado }}
                      </td>
                      <td
                        class="text-nowrap"
                        style="font-size: 0.8rem; padding: 4px 6px"
                      >
                        {{ item.preco_quitacao }}
                      </td>
                      <td style="padding: 4px 6px">
                        <div class="d-flex gap-1 justify-content-center">
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-danger d-flex align-items-center justify-content-center"
                            style="
                              width: 26px;
                              height: 26px;
                              padding: 0;
                              min-width: 26px;
                            "
                            @click="excluir_veiculo_av(item)"
                            title="Excluir"
                          >
                            <i
                              class="bi bi-trash"
                              style="font-size: 0.7rem"
                            ></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-danger d-flex align-items-center justify-content-center"
                            style="
                              width: 26px;
                              height: 26px;
                              padding: 0;
                              min-width: 26px;
                            "
                            data-bs-target="#ModalAvaliacaoVeiculo"
                            data-bs-toggle="modal"
                            :disabled="hab_avaliacao"
                            @click="verificar_avaliacoes_placa(item)"
                            title="Histórico"
                          >
                            <i
                              class="bi bi-car-front-fill"
                              style="font-size: 0.7rem"
                            ></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                    <!-- Linha de total -->
                    <tr class="table-active">
                      <td colspan="4" style="padding: 4px 6px"></td>
                      <td class="fw-bold text-nowrap" style="padding: 4px 6px">
                        Total:
                      </td>
                      <td class="fw-bold" style="padding: 4px 6px">
                        {{ currency(this.valor_avaliacao) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Botão de ação para tablet -->
              <div class="d-flex justify-content-end gap-3 mt-4">
                <!-- Desktop Actions -->
                <div class="d-none d-md-flex gap-2">
                  <div class="mb-2 mx-1">
                    <button
                      type="button"
                      class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                      style="font-size: 0.875rem; white-space: nowrap"
                      @click="habilitar_itens_avaliacao"
                    >
                      <span>Inserir</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Desktop (≥ 992px) - Tabela completa -->
            <div class="d-none d-lg-block">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead class="table-light">
                    <tr>
                      <th scope="col" class="text-nowrap">Marca</th>
                      <th scope="col" class="text-nowrap">Modelo</th>
                      <th scope="col" class="text-nowrap">Placa</th>
                      <th scope="col" class="text-nowrap">Ano Modelo</th>
                      <th scope="col" class="text-nowrap">Cor</th>
                      <th scope="col" class="text-nowrap">KM</th>
                      <th scope="col" class="text-nowrap">R$ Avaliado</th>
                      <th scope="col" class="text-nowrap">R$ Quitação</th>
                      <th scope="col" class="text-nowrap">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in veiculos_avaliados"
                      :key="item.descricao"
                      class="card-table-item"
                    >
                      <td>{{ item.marca }}</td>
                      <td>{{ item.modelo }}</td>
                      <td>{{ item.placa }}</td>
                      <td>{{ item.ano_mod }}</td>
                      <td>{{ item.cor }}</td>
                      <td>{{ formatarKM(item.kilometragem) }}</td>
                      <td>{{ item.preco_avaliado }}</td>
                      <td>{{ item.preco_quitacao }}</td>
                      <td>
                        <div class="d-flex gap-2">
                          <button
                            type="button"
                            class="btn btn-outline-danger btn-sm"
                            @click="excluir_veiculo_av(item)"
                            title="Excluir"
                          >
                            <i class="bi bi-trash"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-outline-danger btn-sm"
                            data-bs-target="#ModalAvaliacaoVeiculo"
                            data-bs-toggle="modal"
                            :disabled="hab_avaliacao"
                            @click="verificar_avaliacoes_placa(item)"
                            title="Histórico de Avaliações"
                          >
                            <i class="bi bi-car-front-fill"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                    <!-- Linha de total -->
                    <tr class="table-active">
                      <td colspan="6"></td>
                      <td class="fw-bold">Total:</td>
                      <td class="fw-bold">
                        {{ currency(this.valor_avaliacao) }}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Botão de ação para desktop -->
              <div class="d-flex justify-content-end gap-3 mt-4">
                <!-- Desktop Actions -->
                <div class="d-none d-md-flex gap-2">
                  <div class="mb-2 mx-1">
                    <button
                      type="button"
                      class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                      style="font-size: 0.875rem; white-space: nowrap"
                      @click="habilitar_itens_avaliacao"
                    >
                      <span>Inserir</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Bloco Resumo da Proposta-->
    <div class="card-container">
      <div class="card">
        <div class="row g-2">
          <h6 class="section-title mb-4 linha">
            <i class="bi bi-card-checklist me-2 icon-text-form-title"></i>Resumo
            do Atendimento
          </h6>
        </div>
        <div class="mb-4">
          <h6 class="section-title">
            <i class="bi bi-cash-stack me-2 icon-text-form-title"></i>Valores do
            Veículo
          </h6>
          <!--Valores do Veículo-->
          <div class="row g-2">
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="Valor_Sugerido"
                  :disabled="true"
                />
                <label for="valid_descricao" class="rf_texto"
                  >Valor Sugerido de Venda</label
                >
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="Valor_Custo_variaveis"
                  :disabled="true"
                />
                <label for="valid_descricao" class="rf_texto"
                  >Valor Custos Variáveis (+)</label
                >
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="Valor_Itens_Acessorios"
                  :disabled="true"
                />
                <label for="valid_descricao" class="rf_texto"
                  >Valor das Cortesias</label
                >
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="desconto"
                  v-on:blur="inserir_desconto"
                  @input="desconto = formatarValor(desconto)"
                  :disabled="bloquear_entrada_botoes"
                />
                <label for="valid_descricao" class="rf_texto">Desconto</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="adicional"
                  v-on:blur="inserir_acrescimo"
                  @input="adicional = formatarValor(adicional)"
                  :disabled="bloquear_entrada_botoes"
                />
                <label for="valid_descricao" class="rf_texto">Acréscimo</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="Valor_Total_Venda"
                  :disabled="true"
                />
                <label for="valid_descricao" class="rf_texto"
                  >Valor Total Veículo Venda</label
                >
              </div>
            </div>
          </div>
        </div>
        <!--Avaliação do veículo-->
        <div class="mb-4">
          <h6 class="section-title">
            <i class="bi bi-clipboard-check me-2 icon-text-form-title"></i
            >Avaliação do Veículo
          </h6>
          <div class="row g-2">
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="Valor_Avaliado"
                  :disabled="true"
                />
                <label for="valid_descricao" class="rf_texto"
                  >Valor Avaliação</label
                >
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="Valor_Itens_Avaliacao_db"
                  :disabled="true"
                />
                <label for="valid_descricao" class="rf_texto"
                  >Valor itens Avaliados DB(-)</label
                >
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="Valor_Itens_Avaliacao_cr"
                  :disabled="true"
                />
                <label for="valid_descricao" class="rf_texto"
                  >Valor itens Avaliados CR(2)</label
                >
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="Valor_Avaliacao_Final"
                  :disabled="true"
                />
                <label for="valid_descricao" class="rf_texto"
                  >Valor Avaliação Final</label
                >
              </div>
            </div>
          </div>
        </div>
        <!--Informações do financiamento-->
        <div v-if="venda_financiamento" class="mb-4">
          <h6 class="section-title">
            <i class="bi bi-currency-dollar me-2 icon-text-form-title"></i
            >Informações sobre o Financiamento
          </h6>
          <div class="row g-2">
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="Valor_Entrada"
                  :disabled="true"
                />
                <label for="valid_descricao" class="rf_texto"
                  >Valor Entrada</label
                >
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="Valor_Financiado"
                  :disabled="true"
                />
                <label for="valid_descricao" class="rf_texto"
                  >Valor Financiado</label
                >
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="Quantidade_Meses"
                  :disabled="true"
                />
                <label for="valid_descricao" class="rf_texto"
                  >Quantidade de Meses</label
                >
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="Pmt"
                  :disabled="true"
                />
                <label for="valid_descricao" class="rf_texto"
                  >Valor da Parcela</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Formas de Pagamento-->
    <div class="card-container">
      <div class="card">
        <div class="mb-4">
          <h6 class="section-title linha">
            <i class="bi bi-credit-card me-2 icon-text-form-title"></i>
            Informações de Pagamento
          </h6>
          <div
            class="form-check form-switch d-flex align-items-center justify-content-sm-end"
          >
            <label class="form-check-label me-1 mt-3">Financiamento</label>
            <div class="toggle-form-container">
              <div class="d-flex align-items-center mt-2">
                <input
                  class="form-check-input mx-2"
                  type="checkbox"
                  role="switch"
                  v-model="forma_pagamento"
                  :disabled="bloquear_entrada"
                  @change="pagamento_vista()"
                />
              </div>
            </div>
            <label class="form-check-label ms-1 mt-3">À Vista</label>
          </div>
        </div>

        <!--Quadro para Venda a Vista-->
        <div v-if="venda_vista">
          <div class="row g-2 p-2">
            <h6 class="section-title mb-1">
              <i class="bi bi-cash-stack me-2 icon-text-form-title"></i>
              Informe o Pagamento
            </h6>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  disabled
                  v-model="Valor_Total_Venda"
                />
                <label>Valor da Venda</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="met_pagamento_vista"
                  @change="verificarMetodoPagamento"
                >
                  <option
                    v-for="item in metodo_pagamento_vista"
                    :value="item.id"
                    :key="item.id"
                    :disabled="
                      item.descricao === 'FINANCIAMENTO' ||
                      item.descricao === 'VEÍCULO TROCA'
                    "
                  >
                    {{ item.descricao }}
                  </option>
                </select>
                <label for="valid_empresa">Tipo de Pagamento </label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="valor_parcela_vista"
                  @input="
                    valor_parcela_vista = formatarValor(valor_parcela_vista)
                  "
                />
                <label>Valor</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="qtd_parcela_vista"
                >
                  <option
                    v-for="item in qtd_parcelamento"
                    :value="item.value"
                    :key="item.value"
                  >
                    {{ item.value }}
                  </option>
                </select>
                <label for="valid_empresa">Parcela </label>
              </div>
            </div>

            <!-- Seção: Ações -->
            <div class="d-flex justify-content-end gap-3 mt-4">
              <!-- Mobile Actions -->
              <div class="d-flex d-md-none gap-2">
                <button
                  type="button"
                  class="btn round-btn"
                  :disabled="habilitar_inserir_pagamento"
                  @click="inserir_pagamento()"
                >
                  <i class="bi bi-plus-circle" title="Inserir"></i>
                </button>
              </div>
              <!-- Desktop Actions -->
              <div class="d-none d-md-flex gap-2">
                <button
                  type="button"
                  class="btn btn-form"
                  :disabled="habilitar_inserir_pagamento"
                  @click="inserir_pagamento()"
                >
                  Inserir
                </button>
              </div>
            </div>
            <div
              v-if="this.hab_avista"
              class="alert alert-warning alert-dismissible fade show"
              role="alert"
            >
              <strong>{{ this.msg }}</strong>
            </div>
          </div>
          <div class="g-2 p-2">
            <h6 class="section-title linha">
              <i class="bi bi-file-earmark-text me-2 icon-text-form-title"></i
              >Composição do Pagamento
            </h6>
            <div class="d-md-none">
              <div
                v-for="item in itens_pagamentos"
                :key="item.nome"
                class="accordion mb-2"
              >
                <div class="accordion-item">
                  <button
                    class="accordion-button collapsed card-table-txt"
                    data-bs-toggle="collapse"
                    :data-bs-target="'#row-' + item.id"
                  >
                    <span>Avaliação - </span
                    >{{ this.currency(item.valor_parcela) }}
                  </button>
                  <div
                    :id="'row-' + item.id"
                    class="accordion-collapse collapse"
                  >
                    <div class="accordion-body">
                      <p>
                        <strong>Valor Informado:</strong>
                        {{ this.currency(item.valor_parcela) }}
                      </p>
                      <p>
                        <strong>Tipo de Pagamento:</strong>
                        {{ item.tipo_pagamento_descricao }}
                      </p>
                      <p>
                        <strong>Quantidade de Parcelas:</strong>
                        {{ item.qtd_parcela }}
                      </p>
                      <button
                        class="dropdown-toggle-icon"
                        data-bs-target="#excluiModalPagamento"
                        data-bs-toggle="modal"
                        @click="remover_item_pagamento(item)"
                      >
                        <i class="bi bi-trash3"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-none d-md-block">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col" style="width: 15%">Valor Informado</th>
                    <th scope="col" style="width: 15%">Pagamento</th>
                    <th scope="col" style="width: 10%">Qtd.</th>

                    <th scope="col" style="width: 5%">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in itens_pagamentos"
                    :key="item.id"
                    class="table-linha"
                  >
                    <td>{{ this.currency(item.valor_parcela) }}</td>
                    <td>{{ item.tipo_pagamento_descricao }}</td>
                    <td>{{ item.qtd_parcela }}</td>

                    <td style="display: flex">
                      <button
                        class="dropdown-toggle-icon"
                        data-bs-target="#excluiModalPagamento"
                        data-bs-toggle="modal"
                        @click="remover_item_pagamento(item)"
                      >
                        <i class="bi bi-trash3"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!--Quadro para financiamento-->
        <div v-if="venda_financiamento">
          <div class="col">
            <div class="d-md-none">
              <!-- Entradas para simulação -->
              <div class="card mb-3">
                <div class="card-title gy-4 linha">
                  <span class="txt-title-form-desk">Simulação</span>
                </div>
                <!-- Primeira Entrada-->
                <div class="row g-2 mb-3 mt-2">
                  <div class="col-12">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control"
                        v-model="entrada_1"
                        v-on:blur="calcular_real_1"
                        :disabled="bloquear_entrada"
                        @input="entrada_1 = formatarValor(entrada_1)"
                        tabindex="1"
                      />
                      <label class="rf_texto">Entrada R$</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        :disabled="true"
                        v-model="entrada_1_perc"
                        @input="calcular_perc_1()"
                        tabindex="-1"
                      />
                      <label>Entrada %</label>
                    </div>
                  </div>
                </div>
                <!-- Segunda Entrada-->
                <div class="row g-2 mb-3 mt-2">
                  <div class="col-12">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control"
                        v-model="entrada_2"
                        v-on:blur="calcular_real_2"
                        :disabled="bloquear_entrada"
                        @input="entrada_2 = formatarValor(entrada_2)"
                        tabindex="1"
                      />
                      <label class="rf_texto">Entrada R$</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        :disabled="true"
                        v-model="entrada_2_perc"
                        @input="calcular_perc_2()"
                        tabindex="-1"
                      />
                      <label>Entrada %</label>
                    </div>
                  </div>
                </div>
                <!-- Terceira Entrada-->
                <div class="row g-2 mb-3 mt-2">
                  <div class="col-12">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control"
                        v-model="entrada_3"
                        v-on:blur="calcular_real_3"
                        :disabled="bloquear_entrada"
                        @input="entrada_3 = formatarValor(entrada_3)"
                        tabindex="1"
                      />
                      <label class="rf_texto">Entrada R$</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        :disabled="true"
                        v-model="entrada_3_perc"
                        @input="calcular_perc_3()"
                        tabindex="-1"
                      />
                      <label>Entrada %</label>
                    </div>
                  </div>
                </div>
                <!--Quantidade de parcelas-->
                <div class="row g-2 mb-3">
                  <div class="card-title gy-4 linha">
                    <span class="txt-title-form-desk"
                      >Quantidade de Parcelas</span
                    >
                  </div>
                  <div class="col-4 mb-2">
                    <select
                      class="form-select txt-form-input"
                      v-model="parcela_1"
                    >
                      <option
                        v-for="item in itens_financiamento"
                        :value="item.value"
                        :key="item.value"
                      >
                        {{ item.value }}
                      </option>
                    </select>
                  </div>
                  <div class="col-4 mb-2">
                    <select
                      class="form-select txt-form-input"
                      v-model="parcela_2"
                      v-on:blur="hab_ranquear"
                    >
                      <option
                        v-for="item in itens_financiamento"
                        :value="item.value"
                        :key="item.value"
                      >
                        {{ item.value }}
                      </option>
                    </select>
                  </div>
                  <div class="col-4 mb-2">
                    <select
                      class="form-select txt-form-input"
                      v-model="parcela_3"
                      v-on:blur="hab_ranquear"
                    >
                      <option
                        v-for="item in itens_financiamento"
                        :value="item.value"
                        :key="item.value"
                      >
                        {{ item.value }}
                      </option>
                    </select>
                  </div>
                </div>
                <!--Botões da parcela-->
                <div class="row g-2">
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 11 }"
                      @click="select_pmt(parcela_1_1, 11)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_1_1 }}
                    </button>
                  </div>
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 12 }"
                      @click="select_pmt(parcela_1_2, 12)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_1_2 }}
                    </button>
                  </div>
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 13 }"
                      @click="select_pmt(parcela_1_3, 13)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_1_3 }}
                    </button>
                  </div>
                </div>
                <div class="row g-2">
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 21 }"
                      @click="select_pmt(parcela_2_1, 21)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_2_1 }}
                    </button>
                  </div>
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 22 }"
                      @click="select_pmt(parcela_2_2, 22)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_2_2 }}
                    </button>
                  </div>
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 23 }"
                      @click="select_pmt(parcela_2_3, 2)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_2_3 }}
                    </button>
                  </div>
                </div>
                <div class="row g-2">
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 31 }"
                      @click="select_pmt(parcela_3_1, 31)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_3_1 }}
                    </button>
                  </div>
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 32 }"
                      @click="select_pmt(parcela_3_2, 32)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_3_2 }}
                    </button>
                  </div>
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 33 }"
                      @click="select_pmt(parcela_3_3, 33)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_3_3 }}
                    </button>
                  </div>
                </div>
                <div class="row g-2 mb-3 d-flex">
                  <!--Ranquear-->
                  <div
                    class="col-4 flex-wrap justify-content-around align-items-center"
                  >
                    <button
                      class="btn btn-desk"
                      @click="handleRanqueamento(1)"
                      tabindex="4"
                      :disabled="bloquear_entrada_botoes"
                    >
                      <span class="payment-status paid">
                        <i class="bi bi-trophy-fill" title="Ranquear">
                          Ranquear
                        </i>
                      </span>
                    </button>
                  </div>
                  <div
                    class="col-4 flex-wrap justify-content-around align-items-center"
                  >
                    <button
                      class="btn btn-desk"
                      @click="handleRanqueamento(2)"
                      tabindex="4"
                      :disabled="bloquear_entrada_botoes"
                    >
                      <span class="payment-status paid">
                        <i class="bi bi-trophy-fill" title="Ranquear">
                          Ranquear
                        </i>
                      </span>
                    </button>
                  </div>
                  <div
                    class="col-4 flex-wrap justify-content-around align-items-center"
                  >
                    <button
                      class="btn btn-desk"
                      @click="handleRanqueamento(3)"
                      tabindex="4"
                      :disabled="bloquear_entrada_botoes"
                    >
                      <span class="payment-status paid">
                        <i class="bi bi-trophy-fill" title="Ranquear">
                          Ranquear
                        </i>
                      </span>
                    </button>
                  </div>
                </div>
                <div
                  class="row g-2 mb-3 flex-wrap justify-content-around align-items-center"
                >
                  <!--Limpar Entradas-->
                  <div class="col">
                    <button
                      class="btn btn-desk"
                      @click="limpar_financiamento"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      <i class="bi bi-eraser-fill" title="Limpar Entradas">
                        Limpar
                      </i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Versão para telas médias (768px - 992px) -->
            <div class="d-none d-md-block d-lg-none">
              <div class="card mb-3">
                <div class="card-title gy-4 linha">
                  <span class="txt-title-form-desk">Simulação</span>
                </div>
                <!-- Primeira Entrada-->
                <div class="row g-2 mb-3 mt-2">
                  <div class="col-6">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control"
                        v-model="entrada_1"
                        v-on:blur="calcular_real_1"
                        :disabled="bloquear_entrada"
                        @input="entrada_1 = formatarValor(entrada_1)"
                        tabindex="1"
                      />
                      <label class="rf_texto">Entrada R$</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        :disabled="true"
                        v-model="entrada_1_perc"
                        @input="calcular_perc_1()"
                        tabindex="-1"
                      />
                      <label>Entrada %</label>
                    </div>
                  </div>
                </div>
                <!-- Segunda Entrada-->
                <div class="row g-2 mb-3 mt-2">
                  <div class="col-6">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control"
                        v-model="entrada_2"
                        v-on:blur="calcular_real_2"
                        :disabled="bloquear_entrada"
                        @input="entrada_2 = formatarValor(entrada_2)"
                        tabindex="1"
                      />
                      <label class="rf_texto">Entrada R$</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        :disabled="true"
                        v-model="entrada_2_perc"
                        @input="calcular_perc_2()"
                        tabindex="-1"
                      />
                      <label>Entrada %</label>
                    </div>
                  </div>
                </div>
                <!-- Terceira Entrada-->
                <div class="row g-2 mb-3 mt-2">
                  <div class="col-6">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control"
                        v-model="entrada_3"
                        v-on:blur="calcular_real_3"
                        :disabled="bloquear_entrada"
                        @input="entrada_3 = formatarValor(entrada_3)"
                        tabindex="1"
                      />
                      <label class="rf_texto">Entrada R$</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        :disabled="true"
                        v-model="entrada_3_perc"
                        @input="calcular_perc_3()"
                        tabindex="-1"
                      />
                      <label>Entrada %</label>
                    </div>
                  </div>
                </div>
                <!--Quantidade de parcelas-->
                <div class="row g-2 mb-3">
                  <div class="card-title gy-4 linha">
                    <span class="txt-title-form-desk"
                      >Quantidade de Parcelas</span
                    >
                  </div>
                  <div class="col-4 mb-2">
                    <select
                      class="form-select txt-form-input"
                      v-model="parcela_1"
                    >
                      <option
                        v-for="item in itens_financiamento"
                        :value="item.value"
                        :key="item.value"
                      >
                        {{ item.value }}
                      </option>
                    </select>
                  </div>
                  <div class="col-4 mb-2">
                    <select
                      class="form-select txt-form-input"
                      v-model="parcela_2"
                      v-on:blur="hab_ranquear"
                    >
                      <option
                        v-for="item in itens_financiamento"
                        :value="item.value"
                        :key="item.value"
                      >
                        {{ item.value }}
                      </option>
                    </select>
                  </div>
                  <div class="col-4 mb-2">
                    <select
                      class="form-select txt-form-input"
                      v-model="parcela_3"
                      v-on:blur="hab_ranquear"
                    >
                      <option
                        v-for="item in itens_financiamento"
                        :value="item.value"
                        :key="item.value"
                      >
                        {{ item.value }}
                      </option>
                    </select>
                  </div>
                </div>
                <!--Botões da parcela-->
                <div class="row g-2">
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 11 }"
                      @click="select_pmt(parcela_1_1, 11)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_1_1 }}
                    </button>
                  </div>
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 12 }"
                      @click="select_pmt(parcela_1_2, 12)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_1_2 }}
                    </button>
                  </div>
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 13 }"
                      @click="select_pmt(parcela_1_3, 13)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_1_3 }}
                    </button>
                  </div>
                </div>
                <div class="row g-2">
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 21 }"
                      @click="select_pmt(parcela_2_1, 21)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_2_1 }}
                    </button>
                  </div>
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 22 }"
                      @click="select_pmt(parcela_2_2, 22)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_2_2 }}
                    </button>
                  </div>
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 23 }"
                      @click="select_pmt(parcela_2_3, 2)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_2_3 }}
                    </button>
                  </div>
                </div>
                <div class="row g-2">
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 31 }"
                      @click="select_pmt(parcela_3_1, 31)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_3_1 }}
                    </button>
                  </div>
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 32 }"
                      @click="select_pmt(parcela_3_2, 32)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_3_2 }}
                    </button>
                  </div>
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn btn-desk"
                      :class="{ active: pmtSelected === 33 }"
                      @click="select_pmt(parcela_3_3, 33)"
                      tabindex="-1"
                      :disabled="bloquear_entrada_botoes"
                    >
                      {{ parcela_3_3 }}
                    </button>
                  </div>
                </div>

                <div class="row g-2 mb-3 d-flex">
                  <div class="col-md-4">
                    <!--Ranquear-->
                    <button
                      class="btn btn-form w-100"
                      @click="handleRanqueamento(1)"
                      tabindex="4"
                      :disabled="bloquear_entrada_botoes"
                    >
                      <span class="payment-status paid"> Ranquear </span>
                    </button>
                  </div>
                  <div class="col-md-4">
                    <!--Ranquear-->
                    <button
                      class="btn btn-form w-100"
                      @click="handleRanqueamento(2)"
                      tabindex="4"
                      :disabled="bloquear_entrada_botoes"
                    >
                      <span class="payment-status paid"> Ranquear </span>
                    </button>
                  </div>
                  <div class="col-md-4">
                    <!--Ranquear-->
                    <button
                      class="btn btn-form w-100"
                      @click="handleRanqueamento(3)"
                      tabindex="4"
                      :disabled="bloquear_entrada_botoes"
                    >
                      <span class="payment-status paid"> Ranquear </span>
                    </button>
                  </div>
                </div>
                <div class="col-md-12">
                  <!--Limpar Entradas-->
                  <button
                    class="btn btn-form w-100"
                    @click="limpar_financiamento"
                    tabindex="-1"
                    :disabled="bloquear_entrada_botoes"
                  >
                    <span>Limpar Entradas</span>
                  </button>
                </div>
              </div>
            </div>

            <!-- Versão para telas grandes (992px+) -->
            <div class="d-none d-lg-block">
              <table class="table txt-form-input">
                <thead>
                  <tr>
                    <th class=""></th>
                    <th class=""></th>
                    <th class=""></th>

                    <th class="">
                      <div class="form-floating">
                        <select
                          class="form-select txt-form-input"
                          v-model="parcela_1"
                        >
                          <option
                            v-for="item in itens_financiamento"
                            :value="item.value"
                            :key="item.value"
                          >
                            {{ item.value }}
                          </option>
                        </select>
                        <label class="rf_texto">Parcela</label>
                      </div>
                    </th>

                    <th class="">
                      <div class="form-floating">
                        <select
                          class="form-select txt-form-input"
                          v-model="parcela_2"
                          v-on:blur="hab_ranquear"
                        >
                          <option
                            v-for="item in itens_financiamento"
                            :value="item.value"
                            :key="item.value"
                          >
                            {{ item.value }}
                          </option>
                        </select>
                        <label for="valid_empresa" class="rf_texto"
                          >Parcela</label
                        >
                      </div>
                    </th>

                    <th class="">
                      <div class="form-floating">
                        <select
                          class="form-select txt-form-input"
                          v-model="parcela_3"
                          v-on:blur="hab_ranquear"
                        >
                          <option
                            v-for="item in itens_financiamento"
                            :value="item.value"
                            :key="item.value"
                          >
                            {{ item.value }}
                          </option>
                        </select>
                        <label for="valid_empresa" class="rf_texto"
                          >Parcela</label
                        >
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Primeira Linha-->
                  <tr>
                    <th scope="row">
                      <div class="d-grid gap-2 disabled">
                        <button class="btn btn-form" disabled>
                          <span class="txt-form-input">Simulação 1</span>
                        </button>
                      </div>
                    </th>
                    <td>
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control txt-form-input"
                          v-model="entrada_1"
                          v-on:blur="calcular_real_1"
                          :disabled="bloquear_entrada"
                          @input="entrada_1 = formatarValor(entrada_1)"
                          tabindex="1"
                        />
                        <label>Entrada R$</label>
                      </div>
                    </td>
                    <td>
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control txt-form-input"
                          :disabled="true"
                          v-model="entrada_1_perc"
                          @input="calcular_perc_1()"
                          tabindex="-1"
                        />
                        <label>Entrada %</label>
                      </div>
                    </td>
                    <td>
                      <div class="d-grid gap-2">
                        <button
                          type="button"
                          class="btn btn-form"
                          :class="{ active: pmtSelected === 11 }"
                          @click="select_pmt(parcela_1_1, 11)"
                          tabindex="-1"
                          :disabled="bloquear_entrada_botoes"
                        >
                          {{ parcela_1_1 }}
                        </button>
                      </div>
                    </td>
                    <td>
                      <div class="d-grid gap-2">
                        <button
                          type="button"
                          class="btn btn-form"
                          :class="{ active: pmtSelected === 12 }"
                          @click="select_pmt(parcela_1_2, 12)"
                          tabindex="-1"
                          :disabled="bloquear_entrada_botoes"
                        >
                          {{ parcela_1_2 }}
                        </button>
                      </div>
                    </td>
                    <td>
                      <div class="d-grid gap-2">
                        <button
                          type="button"
                          class="btn btn-form"
                          :class="{ active: pmtSelected === 13 }"
                          @click="select_pmt(parcela_1_3, 13)"
                          tabindex="-1"
                          :disabled="bloquear_entrada_botoes"
                        >
                          {{ parcela_1_3 }}
                        </button>
                      </div>
                    </td>
                  </tr>
                  <!-- Segunda Linha-->
                  <tr>
                    <th scope="row">
                      <div class="d-grid gap-2 disabled">
                        <button class="btn btn-form" disabled>
                          <span class="txt-form-input">Simulação 2</span>
                        </button>
                      </div>
                    </th>
                    <td>
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control txt-form-input"
                          v-model="entrada_2"
                          v-on:blur="calcular_real_2"
                          :disabled="bloquear_entrada"
                          @input="entrada_2 = formatarValor(entrada_2)"
                          tabindex="1"
                        />
                        <label>Entrada R$</label>
                      </div>
                    </td>
                    <td>
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control txt-form-input"
                          :disabled="true"
                          v-model="entrada_2_perc"
                          @input="calcular_perc_1()"
                          tabindex="-1"
                        />
                        <label>Entrada %</label>
                      </div>
                    </td>
                    <td>
                      <div class="d-grid gap-2">
                        <button
                          type="button"
                          class="btn btn-form"
                          :class="{ active: pmtSelected === 21 }"
                          @click="select_pmt(parcela_2_1, 21)"
                          tabindex="-1"
                          :disabled="bloquear_entrada_botoes"
                        >
                          {{ parcela_2_1 }}
                        </button>
                      </div>
                    </td>
                    <td>
                      <div class="d-grid gap-2">
                        <button
                          type="button"
                          class="btn btn-form"
                          :class="{ active: pmtSelected === 22 }"
                          @click="select_pmt(parcela_2_2, 22)"
                          tabindex="-1"
                          :disabled="bloquear_entrada_botoes"
                        >
                          {{ parcela_2_2 }}
                        </button>
                      </div>
                    </td>
                    <td>
                      <div class="d-grid gap-2">
                        <button
                          type="button"
                          class="btn btn-form"
                          :class="{ active: pmtSelected === 23 }"
                          @click="select_pmt(parcela_2_3, 23)"
                          tabindex="-1"
                          :disabled="bloquear_entrada_botoes"
                        >
                          {{ parcela_2_3 }}
                        </button>
                      </div>
                    </td>
                  </tr>
                  <!-- Terceira Linha-->
                  <tr>
                    <th scope="row">
                      <div class="d-grid gap-2 disabled">
                        <button class="btn btn-form" disabled>
                          <span class="txt-form-input">Simulação 3</span>
                        </button>
                      </div>
                    </th>
                    <td>
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control txt-form-input"
                          v-model="entrada_3"
                          v-on:blur="calcular_real_3"
                          :disabled="bloquear_entrada"
                          @input="entrada_3 = formatarValor(entrada_3)"
                          tabindex="1"
                        />
                        <label>Entrada R$</label>
                      </div>
                    </td>
                    <td>
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control txt-form-input"
                          :disabled="true"
                          v-model="entrada_3_perc"
                          @input="calcular_perc_3()"
                          tabindex="-1"
                        />
                        <label>Entrada %</label>
                      </div>
                    </td>
                    <td>
                      <div class="d-grid gap-2">
                        <button
                          type="button"
                          class="btn btn-form"
                          :class="{ active: pmtSelected === 31 }"
                          @click="select_pmt(parcela_3_1, 31)"
                          tabindex="-1"
                          :disabled="bloquear_entrada_botoes"
                        >
                          {{ parcela_3_1 }}
                        </button>
                      </div>
                    </td>
                    <td>
                      <div class="d-grid gap-2">
                        <button
                          type="button"
                          class="btn btn-form"
                          :class="{ active: pmtSelected === 32 }"
                          @click="select_pmt(parcela_3_2, 32)"
                          tabindex="-1"
                          :disabled="bloquear_entrada_botoes"
                        >
                          {{ parcela_3_2 }}
                        </button>
                      </div>
                    </td>
                    <td>
                      <div class="d-grid gap-2">
                        <button
                          type="button"
                          class="btn btn-form"
                          :class="{ active: pmtSelected === 33 }"
                          @click="select_pmt(parcela_3_3, 33)"
                          tabindex="-1"
                          :disabled="bloquear_entrada_botoes"
                        >
                          {{ parcela_3_3 }}
                        </button>
                      </div>
                    </td>
                  </tr>
                  <!-- Quarta Linha-->
                  <tr>
                    <td class="col-4">
                      <div class="d-grid gap-2">
                        <button
                          class="btn btn-form"
                          @click="limpar_financiamento"
                          tabindex="-1"
                          :disabled="bloquear_entrada_botoes"
                        >
                          <span class="rf_texto_btn">Limpar Entradas</span>
                        </button>
                      </div>
                    </td>
                    <th></th>
                    <th></th>
                    <th scope="row">
                      <div class="d-grid gap-2">
                        <button
                          class="btn btn-form"
                          id="btn_1"
                          @click="handleRanqueamento(1)"
                          tabindex="4"
                          :disabled="bloquear_entrada_botoes"
                        >
                          <span class="rf_texto_btn">Ranquear</span>
                        </button>
                      </div>
                    </th>
                    <th scope="row">
                      <div class="d-grid gap-2">
                        <button
                          class="btn btn-form"
                          id="btn_1"
                          @click="handleRanqueamento(2)"
                          tabindex="4"
                          :disabled="bloquear_entrada_botoes"
                        >
                          <span class="rf_texto_btn">Ranquear</span>
                        </button>
                      </div>
                    </th>
                    <th scope="row">
                      <div class="d-grid gap-2">
                        <button
                          class="btn btn-form"
                          id="btn_1"
                          @click="handleRanqueamento(3)"
                          tabindex="4"
                          :disabled="bloquear_entrada_botoes"
                        >
                          <span class="rf_texto_btn">Ranquear</span>
                        </button>
                      </div>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="abrir_modal">
            <Message :msg="msg" v-show="msg" />
          </div>
          <div>
            <Aviso
              :msg="modalMessage"
              :visible="showModal"
              @close="closeModal"
            />
          </div>
          <div v-if="abrir_modal_atualizar">
            <MessageAtualizar :msg="msg_atualizar" v-show="msg_atualizar" />
          </div>
        </div>
        <!--Informações-->
        <div class="row g-2 p-2">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-floating">
              <textarea
                v-model="info_adicionais"
                class="form-control"
                rows="4"
                style="min-height: 100px; resize: vertical"
              ></textarea>
              <label>Informações Adicionais</label>
            </div>
          </div>
        </div>
        <!--Botões-->
        <div class="row g-2 p-2">
          <!-- Mobile Actions -->
          <div
            class="d-flex d-md-none flex-wrap justify-content-around align-items-center"
          >
            <!-- Botão Gravar Informações -->
            <div class="mb-2 mx-1">
              <button
                class="btn round-btn"
                :disabled="info_adicionais === ''"
                @click="grava_info_adicional"
              >
                <i class="bi bi-floppy" title="Gravar Informações"></i>
              </button>
            </div>

            <!-- Botão Gerar Menu (condicional) -->
            <div v-if="venda_financiamento" class="mb-2 mx-1">
              <button
                type="submit"
                class="btn round-btn"
                data-bs-toggle="modal"
                data-bs-target="#ModalGerarMenu"
                :disabled="btn_gerar_menu"
                @click="carregarDadosMenu()"
              >
                <i class="bi bi-menu-button-wide-fill" title="Gerar Menu"></i>
              </button>
            </div>

            <div v-if="venda_vista" class="mb-2 mx-1">
              <button
                class="btn round-btn"
                data-bs-toggle="modal"
                data-bs-target="#ModalGerarMenuVista"
                :disabled="habilitar_gerar_menu_avista"
                @click="carregarDadosMenuVista"
              >
                <i class="bi bi-menu-button-wide-fill" title="Gerar Menu"></i>
              </button>
            </div>

            <!-- Botão Finalizar Venda (condicional) -->
            <div v-if="venda_financiamento" class="mb-2 mx-1">
              <button
                class="btn round-btn"
                data-bs-toggle="modal"
                data-bs-target="#previsaoFaturamento"
                :disabled="btn_finalizar_venda"
              >
                <i class="bi bi-check-circle-fill" title="Finalizar Venda"></i>
              </button>
            </div>

            <div v-if="venda_vista" class="mb-2 mx-1">
              <button
                class="btn round-btn"
                data-bs-toggle="modal"
                data-bs-target="#previsaoFaturamento"
                :disabled="btn_finalizar_venda_vista"
              >
                <i class="bi bi-check-circle-fill" title="Finalizar Venda"></i>
              </button>
            </div>

            <!-- Botão Venda Perdida -->
            <div class="mb-2 mx-1">
              <button
                class="btn round-btn"
                data-bs-toggle="modal"
                data-bs-target="#justVendaPerdida"
              >
                <i class="bi bi-x-circle-fill" title="Venda Perdida"></i>
              </button>
            </div>
          </div>

          <!-- Desktop Actions -->
          <div class="d-none d-md-flex gap-2 align-items-stretch w-100">
            <!-- Container principal com 4 colunas -->
            <div class="d-flex flex-wrap flex-md-nowrap w-100 gap-2">
              <!-- Botão 1: Gravar Informações (largura flexível) -->
              <div class="flex-grow-1">
                <button
                  class="btn btn-form h-80 w-100"
                  :disabled="info_adicionais === ''"
                  @click="grava_info_adicional"
                >
                  <span class="rf_texto_btn_desk">Gravar Informações</span>
                </button>
              </div>

              <!-- Botão 2: Gerar Menu (condicional) -->
              <div
                class="flex-grow-1"
                v-if="venda_financiamento || venda_vista"
              >
                <button
                  class="btn btn-form h-80 w-100"
                  data-bs-toggle="modal"
                  :data-bs-target="
                    venda_financiamento
                      ? '#ModalGerarMenu'
                      : '#ModalGerarMenuVista'
                  "
                  :disabled="
                    venda_financiamento
                      ? btn_gerar_menu
                      : habilitar_gerar_menu_avista
                  "
                  @click="
                    venda_financiamento
                      ? carregarDadosMenu()
                      : carregarDadosMenuVista()
                  "
                >
                  <span>Gerar Menu</span>
                </button>
              </div>

              <!-- Botão 3: Finalizar Venda (condicional) -->
              <div
                class="flex-grow-1"
                v-if="venda_financiamento || venda_vista"
              >
                <button
                  class="btn btn-form h-80 w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#previsaoFaturamento"
                  :disabled="
                    venda_financiamento
                      ? btn_finalizar_venda
                      : btn_finalizar_venda_vista
                  "
                >
                  <span class="rf_texto_btn_desk">Finalizar Venda</span>
                </button>
              </div>

              <!-- Botão 4: Venda Perdida (sempre visível) -->
              <div class="flex-grow-1">
                <button
                  class="btn btn-form h-80 w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#justVendaPerdida"
                >
                  <span class="rf_texto_btn_desk">Venda Perdida</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Modal Previsão de Faturamento-->
    <div
      class="modal fade"
      id="previsaoFaturamento"
      tabindex="-1"
      aria-labelledby="confirmModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-tools fs-5 icon-text-logout"></i>
            <span class="txt-title-modal">Finalizar Venda</span>
            <button
              class="btn-close"
              type="button"
              data-bs-toggle="modal"
              aria-label="Close"
            ></button>
          </div>

          <div class="modal-body txt-body-modal">
            <div class="row g-2 p-2">
              <h6 class="section-title mb-3">
                <i
                  class="bi bi-exclamation-circle me-2 icon-text-form-title"
                ></i>
                Informe a data de previsão de faturamento!
              </h6>
            </div>
            <div class="row g-2 p-2">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="form-floating txt-form-label">
                  <input
                    type="date"
                    class="form-control txt-form-input"
                    v-model="previsao_faturamento"
                    autocomplete="off"
                  />
                  <label>Previsão de Faturamento</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col-6">
                <button
                  type="button"
                  class="btn btn-form"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
              <div class="col-6">
                <button
                  type="button"
                  class="btn btn-form"
                  data-bs-dismiss="modal"
                  @click="finalizar_venda"
                >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Modal Justufificar Venda Perdida-->
    <div
      class="modal fade"
      id="justVendaPerdida"
      tabindex="-1"
      aria-labelledby="confirmModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-tools fs-5 icon-text-logout"></i>
            <span class="txt-title-modal">Justificar Venda Perdida</span>
            <button
              class="btn-close"
              type="button"
              data-bs-toggle="modal"
              aria-label="Close"
            ></button>
          </div>

          <div class="modal-body txt-body-modal">
            <form @submit.prevent="solicitar_venda_perdida">
              <div class="row g-2 p-2">
                <h6 class="section-title mb-3">
                  <i
                    class="bi bi-exclamation-circle me-2 icon-text-form-title"
                  ></i>
                  Informe o motivo da venda perdida!
                </h6>
              </div>
              <!--Informações-->
              <div class="row g-2 p-2">
                <div class="col">
                  <div class="form-floating">
                    <textarea
                      v-model="just_venda_perdida"
                      style="height: 200px !important"
                      class="form-control txt-form-input"
                      v-on:blur="validar_just_perdida"
                      required
                    >
                    </textarea>
                    <label>Informações Adicionais</label>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <div class="row">
                  <div class="col-6">
                    <button
                      type="button"
                      class="btn btn-form"
                      data-bs-dismiss="modal"
                    >
                      Cancelar
                    </button>
                  </div>
                  <div class="col-6">
                    <button
                      type="submit"
                      class="btn btn-form"
                      data-bs-dismiss="modal"
                    >
                      Confirmar
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!--Modal Exclusão pagamento-->
    <div
      class="modal fade"
      id="excluiModalPagamento"
      tabindex="-1"
      aria-labelledby="confirmModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
            <span class="txt-title-modal"> Excluir Pagamento</span>
            <button
              class="btn-close"
              type="button"
              data-bs-toggle="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <div class="row g-2 p-2">
              <span class="txt-form-input">Deseja remover o pagamento?</span>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-md-none">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-x-circle" title="Cancelar"></i>
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    data-bs-dismiss="modal"
                    @click="confirmarAlteracaoPagamento()"
                  >
                    <i class="bi bi-check-circle" title="Confirmar"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="d-none d-md-block">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-lg btn-desk-filtro"
                    data-bs-dismiss="modal"
                  >
                    Cancelar
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-lg btn-desk-filtro"
                    data-bs-dismiss="modal"
                    @click="confirmarAlteracaoPagamento()"
                  >
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para edição -->
    <div
      class="modal fade"
      id="clienteFoundByCpfCnpjModal"
      tabindex="-1"
      aria-labelledby="clienteFoundByCpfCnpjModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content card-container rf_texto">
          <div class="modal-header">
            <div class="card-title gy-4">
              <i class="bi bi-exclamation-triangle-fill fs-5 icone_kit"
                ><span class="texto_kit"
                  >Encontramos este cliente na base</span
                ></i
              >
            </div>
            <button
              class="btn btn-modal btn-lg py-1 px-3 mt-1"
              type="button"
              data-bs-target="#clienteFoundByCpfCnpjModal"
              data-bs-toggle="modal"
              aria-label="Close"
            >
              Fechar
            </button>
          </div>
          <div class="modal-body">
            <div class="row g-2 p-2">
              <!--Nome-->
              <div class="col">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control rf_bg_form rf_texto"
                    v-model="modal_cliente"
                    id="modal_cliente"
                    required
                  />
                  <label for="modal_cliente" class="rf_texto">Nome</label>
                  <div class="invalid-feedback">
                    O campo nome é obrigatório!
                  </div>
                </div>
              </div>
              <!--CPF/CNPJ-->
              <div class="col-2">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control rf_bg_form rf_texto"
                    v-model="modal_cpfCnpj"
                    id="modal_cpfCnpj"
                  />
                  <label for="modal_cpfCnpj" class="rf_texto">CPF/CNPJ</label>
                </div>
              </div>
              <!--Data Nascimento-->
              <div class="col-2">
                <div class="form-floating">
                  <input
                    type="date"
                    class="form-control rf_bg_form rf_texto"
                    v-model="modal_dataNascimento"
                    id="modal_dataNascimento"
                  />
                  <label for="modal_dataNascimento" class="rf_texto"
                    >Data Nascimento</label
                  >
                  <div class="invalid-feedback">
                    O campo data nascimento é obrigatório!
                  </div>
                </div>
              </div>
              <!--Email-->
              <div class="col-3">
                <div class="form-floating">
                  <input
                    type="email"
                    class="form-control rf_bg_form rf_texto"
                    v-model="modal_email"
                    id="modal_email"
                    v-on:blur="email"
                  />
                  <label for="modal_email" class="rf_texto">Email</label>
                </div>
              </div>
            </div>
            <div class="row g-2 p-2">
              <!--Endereço-->
              <div class="col">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control rf_bg_form rf_texto"
                    v-model="modal_endereco"
                    id="modal_endereco"
                    required
                  />
                  <label for="modal_endereco" class="rf_texto">Endereço</label>
                  <div class="invalid-feedback">
                    O campo endereço é obrigatório!
                  </div>
                </div>
              </div>
              <!--Complemento-->
              <div class="col-2">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control rf_bg_form rf_texto"
                    v-model="modal_complemento"
                    id="modal_complemento"
                    required
                  />
                  <label for="modal_complemento" class="rf_texto"
                    >Complemento</label
                  >
                  <div class="invalid-feedback">
                    O campo complemento é obrigatório!
                  </div>
                </div>
              </div>
              <!--Telefone-->
              <div class="col-2">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control rf_bg_form rf_texto"
                    v-model="modal_tel"
                    id="modal_tel"
                    v-on:blur="vTel"
                  />
                  <label for="modal_tel" class="rf_texto">Telefone</label>
                </div>
              </div>
              <!--Celular-->
              <div class="col-2">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control rf_bg_form rf_texto"
                    v-model="modal_cel"
                    id="modal_cel"
                    v-on:blur="vCel"
                  />
                  <label for="modal_cel" class="rf_texto">Celular</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer flex gap-2">
            <button
              type="button"
              data-bs-dismiss="modal"
              class="btn btn-modal btn-secondary btn-lg py-1 px-3 mt-1"
            >
              Cancelar
            </button>
            <button
              type="button"
              @click="acceptClienteFoundByCpfCnpjInfo()"
              class="btn btn-modal btn-lg py-1 px-3 mt-1"
            >
              Aceitar informações
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--Modal Trocar Vendedor-->
    <div
      class="modal fade"
      id="ModalTrocarVendedor"
      aria-hidden="true"
      aria-labelledby="exampleModalToggleLabel2"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
            <span class="txt-title-modal"> Trocar Vendedor</span>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <form @submit.prevent="onSubmitTrocaVendedor">
              <div class="row g-2 p-2">
                <div v-if="abrir_modal">
                  <div class="alert text-center" role="alert">
                    {{ msg }}
                  </div>
                </div>
              </div>
              <!--Item-->
              <div class="row g-2 p-2">
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      type="text"
                      class="form-control txt-form-input"
                      v-model="justificativa_vendedor"
                      v-on:blur="validar_vendedor"
                    />
                    <label>Justificativa</label>
                  </div>
                </div>
              </div>
              <div class="row g-2 p-2">
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <select
                      class="form-select txt-form-input"
                      v-model="vendedor_troca"
                      :disabled="check_vend"
                    >
                      <option
                        v-for="item in troca_vendedor"
                        :value="item.id"
                        :key="item.id"
                      >
                        {{ item.username }}
                      </option>
                    </select>
                    <label class="rf_texto">Vendedor</label>
                  </div>
                </div>
                <div class="col-12 col-md-2 d-flex justify-content-end">
                  <div class="form-floating">
                    <button
                      class="btn btn-lg btn-form align-self-end"
                      data-bs-dismiss="modal"
                      :disabled="check_vend"
                      type="submit"
                    >
                      <span>Alterar</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--Modal Trocar Mídia-->
    <div
      class="modal fade"
      id="ModalTrocarMidia"
      aria-hidden="true"
      aria-labelledby="ModalTrocarMidiaLabel"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content card-container">
          <!-- Cabeçalho com close à direita -->
          <div
            class="modal-header p-3 d-flex justify-content-between align-items-center"
          >
            <div class="d-flex align-items-center gap-2">
              <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
              <span class="txt-title-modal">Alterar Mídia</span>
            </div>
            <button
              type="button"
              class="btn-close m-0"
              data-bs-dismiss="modal"
              aria-label="Fechar"
            ></button>
          </div>

          <!-- Corpo do modal (mantido igual ao anterior) -->
          <div class="modal-body p-3">
            <form @submit.prevent="onSubmitTrocaMidia">
              <div v-if="abrir_modal" class="alert text-center p-2 mb-3 small">
                {{ msg }}
              </div>
              <div class="form-floating mb-3">
                <select
                  class="form-select txt-form-input"
                  required
                  v-model="midia_id"
                >
                  <option v-for="item in midia" :value="item.id" :key="item.id">
                    {{ item.descricao }}
                  </option>
                </select>
                <label class="txt-form-label">Mídia</label>
              </div>
              <div class="d-md-none">
                <div class="d-grid gap-2">
                  <button
                    type="submit"
                    class="btn round-btn py-2"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-pencil-square"></i>
                  </button>
                </div>
              </div>
              <div class="d-none d-md-block">
                <div class="d-grid gap-2">
                  <button
                    type="submit"
                    class="btn btn-modal py-2"
                    data-bs-dismiss="modal"
                  >
                    Alterar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--Modal Histórico Cliente-->
    <div
      class="modal fade"
      id="ModalHistoricoCliente"
      aria-hidden="true"
      aria-labelledby="exampleModalToggleLabel2"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
            <span class="txt-title-modal"> Histórico do Cliente</span>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div class="modal-body">
            <div class="row g-2 p-2">
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    disabled
                    v-model="id_historico_cliente"
                  />
                  <label>Id</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    disabled
                    v-model="nome_historico_cliente"
                  />
                  <label>Cliente</label>
                </div>
              </div>

              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <div
                    class="d-md-none d-flex justify-content-center align-items-center"
                  >
                    <button
                      class="btn round-btn"
                      type="button"
                      @click="
                        page = 1;
                        historico_cliente(id_historico_cliente);
                      "
                    >
                      <i class="bi bi-search" title="Pesquisar"></i>
                    </button>
                  </div>
                  <div class="d-none d-md-block">
                    <button
                      class="btn btn-modal"
                      type="button"
                      @click="
                        page = 1;
                        historico_cliente(id_historico_cliente);
                      "
                    >
                      <span class="rf_texto_btn">Pesquisar</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!--Tabelas-->
            <div class="card card-table-txt">
              <div class="d-md-none">
                <div
                  v-for="item in hist_cliente"
                  :key="item.id"
                  class="accordion mb-2"
                >
                  <div class="accordion-item">
                    <button
                      class="accordion-button collapsed d-flex flex-column align-items-start txt-form-input"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#row-' + item.id"
                    >
                      <strong>Nº Atendimento:</strong>
                      <span>{{ item.id }}</span>
                    </button>
                    <div
                      :id="'row-' + item.id"
                      class="accordion-collapse collapse"
                    >
                      <div class="accordion-body">
                        <p class="txt-form-input">
                          <strong>Loja:</strong>
                          {{ item.empresa_proposta.nome }}
                        </p>
                        <p class="txt-form-input">
                          <strong>Data:</strong>
                          {{
                            new Date(item.createdAt).toLocaleDateString("pt-BR")
                          }}
                        </p>
                        <p class="txt-form-input">
                          <strong>Status:</strong>
                          {{ item.status_proposta }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-none d-md-block">
                <table class="table rf_texto_desk">
                  <thead>
                    <tr>
                      <th scope="col">Nº Atendimento</th>
                      <th scope="col">Loja</th>
                      <th scope="col">Data</th>
                      <!-- <th scope="col">R$ custo</th> -->
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in hist_cliente" :key="item.id">
                      <td>{{ item.id }}</td>
                      <td>{{ item.empresa_proposta.nome }}</td>
                      <td>
                        {{
                          new Date(item.createdAt).toLocaleDateString("pt-BR")
                        }}
                      </td>
                      <td>{{ item.status_proposta }}</td>
                      <!-- <td>{{ item.status }}</td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
              <pagination
                v-if="hist_cliente.length"
                :offset="totalPages"
                :total="totalItems"
                :limit="pageSize"
                @change-page="handlePageChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Modal Histórico do Veículo-->
    <div
      class="modal fade"
      id="ModalAvaliacaoVeiculo"
      aria-hidden="true"
      aria-labelledby="exampleModalToggleLabel2"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
            <span class="txt-title-modal"> Histórico de Avaliações</span>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <!--Tabelas-->
            <div class="card txt-title-table-desk">
              <div class="d-md-none">
                <div
                  v-for="item in historico_avaliacoes.avaliacoes"
                  :key="item.id"
                  class="accordion mb-2"
                >
                  <div class="accordion-item">
                    <button
                      class="accordion-button collapsed d-flex flex-column align-items-start txt-form-input"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#row-' + item.id"
                    >
                      <strong>Loja:</strong>
                      {{ item.empresa }}
                    </button>
                    <div
                      :id="'row-' + item.id"
                      class="accordion-collapse collapse"
                    >
                      <div class="accordion-body">
                        <p class="txt-form-input">
                          <strong>Valor:</strong>
                          {{ currency(item.precoAvaliacao) }}
                        </p>
                        <p class="txt-form-input">
                          <strong>KM:</strong>
                          {{ formatarKM(item.kilometragem) }}
                        </p>
                        <p class="txt-form-input">
                          <strong>Avaliador:</strong>
                          {{ item.avaliador_id }}
                        </p>
                        <p class="txt-form-input">
                          <strong>Data:</strong>
                          {{ new Date(item.data).toLocaleDateString("pt-BR") }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-none d-md-block d-lg-none">
                <div
                  v-for="item in historico_avaliacoes.avaliacoes"
                  :key="item.id"
                  class="accordion mb-2"
                >
                  <div class="accordion-item">
                    <button
                      class="accordion-button collapsed d-flex flex-column align-items-start txt-form-input"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#row-' + item.id"
                    >
                      <strong>Loja:</strong>
                      {{ item.empresa }}
                    </button>
                    <div
                      :id="'row-' + item.id"
                      class="accordion-collapse collapse"
                    >
                      <div class="accordion-body">
                        <p class="txt-form-input">
                          <strong>Valor:</strong>
                          {{ currency(item.precoAvaliacao) }}
                        </p>
                        <p class="txt-form-input">
                          <strong>KM:</strong>
                          {{ formatarKM(item.kilometragem) }}
                        </p>
                        <p class="txt-form-input">
                          <strong>Avaliador:</strong>
                          {{ item.avaliador_id }}
                        </p>
                        <p class="txt-form-input">
                          <strong>Data:</strong>
                          {{ new Date(item.data).toLocaleDateString("pt-BR") }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-none d-lg-block">
                <table class="table rf_texto_desk">
                  <thead>
                    <tr>
                      <th scope="col">Valor</th>
                      <th scope="col">KM</th>
                      <th scope="col">Loja</th>
                      <th scope="col">Avaliador</th>
                      <th scope="col">Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in historico_avaliacoes.avaliacoes"
                      :key="item.id"
                    >
                      <td>{{ currency(item.precoAvaliacao) }}</td>
                      <td>{{ formatarKM(item.kilometragem) }}</td>
                      <td>{{ item.empresa }}</td>
                      <td>{{ item.avaliador_id }}</td>
                      <td>
                        {{ new Date(item.data).toLocaleDateString("pt-BR") }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <pagination
                v-if="avaliacoes.length"
                :offset="totalPages"
                :total="totalItems"
                :limit="pageSize"
                @change-page="handlePageChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Modal Estoque-->
    <div
      class="modal fade"
      id="ModalVeiculoEstoque"
      aria-hidden="true"
      aria-labelledby="exampleModalToggleLabel2"
      tabindex="-1"
    >
      <div class="d-md-none">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content card-container">
            <div class="modal-header">
              <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
              <span class="txt-title-modal"> Estoque de Veículos</span>
              <button
                class="btn-close"
                type="button"
                data-bs-toggle="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body txt-body-modal">
              <div class="row g-2 p-2">
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <select
                      class="form-select txt-form-input"
                      v-model="tipoVeiculo"
                    >
                      <option value="NOVO">Novo</option>
                      <option value="USADO">Usado</option>
                    </select>
                    <label>Tipo Veículo</label>
                  </div>
                </div>
                <!--Marca-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      v-model="searchMarca"
                      class="form-control txt-form-input"
                      list="dataListMarcaEstoque"
                      autocomplete="off"
                    />

                    <label>Marca</label>
                    <datalist id="dataListMarcaEstoque">
                      <option
                        v-for="opt in marcas_estoque"
                        :data-value="opt.marca"
                        :value="opt.marca"
                        :key="opt.marca"
                      ></option>
                    </datalist>
                  </div>
                </div>
                <!--Modelo-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-4">
                  <div class="form-floating txt-form-label">
                    <input
                      v-model="searchTitle"
                      class="form-control txt-form-input"
                      list="dataListModeloEstoque"
                      autocomplete="off"
                    />

                    <label>Modelo</label>
                    <datalist id="dataListModeloEstoque">
                      <option
                        v-for="opt in modelos_estoque"
                        :data-value="opt.modelo"
                        :value="opt.modelo"
                        :key="opt.modelo"
                      ></option>
                    </datalist>
                  </div>
                </div>
                <!--Ano modelo-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      type="text"
                      class="form-control txt-form-input"
                      v-model="searchAnoMod"
                    />
                    <label>Ano Mod.</label>
                  </div>
                </div>
                <!--Ano Fabricação-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      type="text"
                      class="form-control txt-form-input"
                      v-model="searchAnoFab"
                    />
                    <label>Ano Fab.</label>
                  </div>
                </div>
                <!--Cor-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-8">
                  <div class="form-floating txt-form-label">
                    <input
                      v-model="searchCor"
                      class="form-control txt-form-input"
                      list="dataListCorEstoque"
                      autocomplete="off"
                    />

                    <label>Cor</label>
                    <datalist id="dataListCorEstoque">
                      <option
                        v-for="opt in cores_estoque"
                        :data-value="opt.cor"
                        :value="opt.cor"
                        :key="opt.cor"
                      ></option>
                    </datalist>
                  </div>
                </div>
                <!--Chassi-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      type="text"
                      class="form-control txt-form-input"
                      v-model="searchChassi"
                    />
                    <label>Chassi</label>
                  </div>
                </div>
                <!--Placa-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      type="text"
                      class="form-control txt-form-input"
                      v-model="searchPlaca"
                    />
                    <label>Placa</label>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-end gap-3 mt-4">
                <button
                  class="btn btn-lg btn-form align-self-end"
                  @click="
                    page = 1;
                    retrieveEstoque();
                  "
                >
                  <span>Pesquisar</span>
                </button>
              </div>
              <!--Tabelas-->
              <div v-if="isLoading" class="text-center my-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Carregando...</span>
                </div>
              </div>
              <v-else>
                <div class="card card-table-txt">
                  <div
                    v-for="item in estoque_veiculo"
                    :key="item.id"
                    class="accordion mb-2"
                  >
                    <div class="accordion-item">
                      <button
                        class="accordion-button collapsed card-table-txt"
                        data-bs-toggle="collapse"
                        :data-bs-target="'#row-' + item.id"
                      >
                        {{ item.modelo }}
                      </button>
                      <div
                        :id="'row-' + item.id"
                        class="accordion-collapse collapse"
                      >
                        <div class="accordion-body">
                          <p class="txt-form-input">
                            <strong>Estoque:</strong>
                            {{ item.situacaoestoque }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Loja:</strong>
                            {{ item.descricaoreduzida }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Categoria:</strong>
                            {{ item.estadoveiculo }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Chassis:</strong>
                            {{ item.chassi }}
                          </p>
                          <p class="txt-form-input">
                            <strong>R$ PPS:</strong>
                            {{ currency(item.valortotalvenda) }}
                          </p>

                          <p class="txt-form-input">
                            <strong>Dias em Estoque:</strong>
                            {{ item.diasestoque }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Cor:</strong>
                            {{ item.cor }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Marca:</strong>
                            {{ item.marca }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Ano Modelo:</strong>
                            {{ item.anomodelo }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Ano Fabricação:</strong>
                            {{ item.anofabricacao }}
                          </p>
                          <p class="txt-form-input">
                            <strong>KM:</strong>
                            {{ item.quilometragem }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Placa:</strong>
                            {{ item.placa }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Combustível:</strong>
                            {{ item.combustivel }}
                          </p>

                          <button
                            type="button"
                            class="btn round-btn"
                            data-bs-dismiss="modal"
                            @click="carregarVeiculo(item)"
                          >
                            <i class="bi bi-pencil-square"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <pagination
                    v-if="estoque_veiculo.length"
                    :total="totalItemsEstoque"
                    :limit="pageSizeEstoque"
                    :offset="currentPage"
                    :totalPages="Math.ceil(totalItemsEstoque / pageSizeEstoque)"
                    @change-page="handlePageChangeVeiculoEstoque"
                  />
                  <div class="row justify-content-end gap-3 mt-4">
                    <div class="col-lg-3 col-xl-3">
                      <button
                        type="button"
                        class="btn btn-modal"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        Fechar
                      </button>
                    </div>
                  </div>
                </div>
              </v-else>
            </div>
          </div>
        </div>
      </div>
      <div class="d-none d-md-flex d-lg-none">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content card-container">
            <div class="modal-header">
              <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
              <span class="txt-title-modal"> Estoque de Veículos</span>
              <button
                class="btn-close"
                type="button"
                data-bs-toggle="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body txt-body-modal">
              <div class="row g-2 p-2">
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <select
                      class="form-select txt-form-input"
                      v-model="tipoVeiculo"
                    >
                      <option value="NOVO">Novo</option>
                      <option value="USADO">Usado</option>
                    </select>
                    <label>Tipo Veículo</label>
                  </div>
                </div>
                <!--Marca-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      v-model="searchMarca"
                      class="form-control txt-form-input"
                      list="dataListMarcaEstoque"
                      autocomplete="off"
                    />

                    <label>Marca</label>
                    <datalist id="dataListMarcaEstoque">
                      <option
                        v-for="opt in marcas_estoque"
                        :data-value="opt.marca"
                        :value="opt.marca"
                        :key="opt.marca"
                      ></option>
                    </datalist>
                  </div>
                </div>
                <!--Modelo-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-4">
                  <div class="form-floating txt-form-label">
                    <input
                      v-model="searchTitle"
                      class="form-control txt-form-input"
                      list="dataListModeloEstoque"
                      autocomplete="off"
                    />

                    <label>Modelo</label>
                    <datalist id="dataListModeloEstoque">
                      <option
                        v-for="opt in modelos_estoque"
                        :data-value="opt.modelo"
                        :value="opt.modelo"
                        :key="opt.modelo"
                      ></option>
                    </datalist>
                  </div>
                </div>
                <!--Ano modelo-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      type="text"
                      class="form-control txt-form-input"
                      v-model="searchAnoMod"
                    />
                    <label>Ano Mod.</label>
                  </div>
                </div>
                <!--Ano Fabricação-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      type="text"
                      class="form-control txt-form-input"
                      v-model="searchAnoFab"
                    />
                    <label>Ano Fab.</label>
                  </div>
                </div>
                <!--Cor-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-8">
                  <div class="form-floating txt-form-label">
                    <input
                      v-model="searchCor"
                      class="form-control txt-form-input"
                      list="dataListCorEstoque"
                      autocomplete="off"
                    />

                    <label>Cor</label>
                    <datalist id="dataListCorEstoque">
                      <option
                        v-for="opt in cores_estoque"
                        :data-value="opt.cor"
                        :value="opt.cor"
                        :key="opt.cor"
                      ></option>
                    </datalist>
                  </div>
                </div>
                <!--Chassi-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      type="text"
                      class="form-control txt-form-input"
                      v-model="searchChassi"
                    />
                    <label>Chassi</label>
                  </div>
                </div>
                <!--Placa-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      type="text"
                      class="form-control txt-form-input"
                      v-model="searchPlaca"
                    />
                    <label>Placa</label>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-end gap-3 mt-4">
                <button
                  class="btn btn-lg btn-form align-self-end"
                  @click="
                    page = 1;
                    retrieveEstoque();
                  "
                >
                  <span>Pesquisar</span>
                </button>
              </div>
              <!--Tabelas-->
              <div v-if="isLoading" class="text-center my-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Carregando...</span>
                </div>
              </div>
              <v-else>
                <div class="card card-table-txt">
                  <div
                    v-for="item in estoque_veiculo"
                    :key="item.id"
                    class="accordion mb-2"
                  >
                    <div class="accordion-item">
                      <button
                        class="accordion-button collapsed card-table-txt"
                        data-bs-toggle="collapse"
                        :data-bs-target="'#row-' + item.id"
                      >
                        {{ item.modelo }}
                      </button>
                      <div
                        :id="'row-' + item.id"
                        class="accordion-collapse collapse"
                      >
                        <div class="accordion-body">
                          <p class="txt-form-input">
                            <strong>Estoque:</strong>
                            {{ item.situacaoestoque }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Loja:</strong>
                            {{ item.descricaoreduzida }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Categoria:</strong>
                            {{ item.estadoveiculo }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Chassis:</strong>
                            {{ item.chassi }}
                          </p>
                          <p class="txt-form-input">
                            <strong>R$ PPS:</strong>
                            {{ currency(item.valortotalvenda) }}
                          </p>

                          <p class="txt-form-input">
                            <strong>Dias em Estoque:</strong>
                            {{ item.diasestoque }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Cor:</strong>
                            {{ item.cor }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Marca:</strong>
                            {{ item.marca }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Ano Modelo:</strong>
                            {{ item.anomodelo }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Ano Fabricação:</strong>
                            {{ item.anofabricacao }}
                          </p>
                          <p class="txt-form-input">
                            <strong>KM:</strong>
                            {{ item.quilometragem }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Placa:</strong>
                            {{ item.placa }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Combustível:</strong>
                            {{ item.combustivel }}
                          </p>

                          <button
                            type="button"
                            class="btn btn-modal"
                            data-bs-dismiss="modal"
                            @click="carregarVeiculo(item)"
                          >
                            <span>Inserir</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <pagination
                    v-if="estoque_veiculo.length"
                    :total="totalItemsEstoque"
                    :limit="pageSizeEstoque"
                    :offset="currentPage"
                    :totalPages="Math.ceil(totalItemsEstoque / pageSizeEstoque)"
                    @change-page="handlePageChangeVeiculoEstoque"
                  />
                  <div class="row justify-content-end gap-3 mt-4">
                    <div class="col-lg-3 col-xl-3">
                      <button
                        type="button"
                        class="btn btn-modal"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        Fechar
                      </button>
                    </div>
                  </div>
                </div>
              </v-else>
            </div>
          </div>
        </div>
      </div>
      <div class="d-none d-lg-flex">
        <div class="modal-dialog modal-dialog-centered modal-fullscreen">
          <div class="modal-content card-container">
            <div class="modal-header">
              <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
              <span class="txt-title-modal"> Estoque de Veículos</span>
              <button
                class="btn-close"
                type="button"
                data-bs-toggle="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body txt-body-modal">
              <div class="row g-2 p-2">
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <select
                      class="form-select txt-form-input"
                      v-model="tipoVeiculo"
                    >
                      <option value="NOVO">Novo</option>
                      <option value="USADO">Usado</option>
                    </select>
                    <label>Tipo Veículo</label>
                  </div>
                </div>
                <!--Marca-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      v-model="searchMarca"
                      class="form-control txt-form-input"
                      list="dataListMarcaEstoque"
                      autocomplete="off"
                    />

                    <label>Marca</label>
                    <datalist id="dataListMarcaEstoque">
                      <option
                        v-for="opt in marcas_estoque"
                        :data-value="opt.marca"
                        :value="opt.marca"
                        :key="opt.marca"
                      ></option>
                    </datalist>
                  </div>
                </div>
                <!--Modelo-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-4">
                  <div class="form-floating txt-form-label">
                    <input
                      v-model="searchTitle"
                      class="form-control txt-form-input"
                      list="dataListModeloEstoque"
                      autocomplete="off"
                    />

                    <label>Modelo</label>
                    <datalist id="dataListModeloEstoque">
                      <option
                        v-for="opt in modelos_estoque"
                        :data-value="opt.modelo"
                        :value="opt.modelo"
                        :key="opt.modelo"
                      ></option>
                    </datalist>
                  </div>
                </div>
                <!--Ano modelo-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      type="text"
                      class="form-control txt-form-input"
                      v-model="searchAnoMod"
                    />
                    <label>Ano Mod.</label>
                  </div>
                </div>
                <!--Ano Fabricação-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      type="text"
                      class="form-control txt-form-input"
                      v-model="searchAnoFab"
                    />
                    <label>Ano Fab.</label>
                  </div>
                </div>
                <!--Cor-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-8">
                  <div class="form-floating txt-form-label">
                    <input
                      v-model="searchCor"
                      class="form-control txt-form-input"
                      list="dataListCorEstoque"
                      autocomplete="off"
                    />

                    <label>Cor</label>
                    <datalist id="dataListCorEstoque">
                      <option
                        v-for="opt in cores_estoque"
                        :data-value="opt.cor"
                        :value="opt.cor"
                        :key="opt.cor"
                      ></option>
                    </datalist>
                  </div>
                </div>
                <!--Chassi-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      type="text"
                      class="form-control txt-form-input"
                      v-model="searchChassi"
                    />
                    <label>Chassi</label>
                  </div>
                </div>
                <!--Placa-->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      type="text"
                      class="form-control txt-form-input"
                      v-model="searchPlaca"
                    />
                    <label>Placa</label>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-end gap-3 mt-4">
                <button
                  class="btn btn-lg btn-form align-self-end"
                  @click="
                    page = 1;
                    retrieveEstoque();
                  "
                >
                  <span>Pesquisar</span>
                </button>
              </div>
              <!--Tabelas-->
              <div class="card card-table-txt">
                <table class="table card-table-txt" v-if="!isLoading">
                  <thead>
                    <tr>
                      <th scope="col">Estoque</th>
                      <th scope="col">Loja</th>
                      <th scope="col">Cat.</th>
                      <th scope="col">Chassis</th>
                      <th scope="col">Modelo</th>
                      <th scope="col">R$ PPS</th>
                      <th scope="col">Dias Est.</th>
                      <th scope="col">Cor</th>
                      <th scope="col">Marca</th>
                      <th scope="col">Ano Mod.</th>
                      <th scope="col">Ano Fab.</th>
                      <th scope="col">KM</th>
                      <th scope="col">Placa</th>
                      <th scope="col">Comb.</th>
                      <th scope="col">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in estoque_veiculo"
                      :key="item.id"
                      class="card-table-item"
                    >
                      <td>{{ item.situacaoestoque }}</td>
                      <td>{{ item.descricaoreduzida }}</td>
                      <td>{{ item.estadoveiculo }}</td>
                      <td>{{ item.chassi }}</td>
                      <td>{{ item.modelo }}</td>
                      <td>
                        {{ currency(item.valortotalvenda) }}
                      </td>

                      <td>{{ item.diasestoque }}</td>
                      <td>{{ item.cor }}</td>
                      <td>{{ item.marca }}</td>
                      <td>{{ item.anomodelo }}</td>
                      <td>{{ item.anofabricacao }}</td>
                      <td>{{ item.quilometragem }}</td>
                      <td>{{ item.placa }}</td>
                      <td>{{ item.combustivel }}</td>

                      <td>
                        <button
                          type="button"
                          class="dropdown-toggle-icon"
                          data-bs-dismiss="modal"
                          @click="carregarVeiculo(item)"
                        >
                          <i class="bi bi-pencil-square"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="loading-indicator">Carregando...</div>
                <pagination
                  v-if="estoque_veiculo.length"
                  :total="totalItemsEstoque"
                  :limit="pageSizeEstoque"
                  :offset="currentPage"
                  :totalPages="Math.ceil(totalItemsEstoque / pageSizeEstoque)"
                  @change-page="handlePageChangeVeiculoEstoque"
                />
                <div class="row justify-content-end gap-3 mt-4">
                  <div class="col-lg-3 col-xl-3">
                    <button
                      type="button"
                      class="btn btn-modal"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      Fechar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Modal Itens Acessorios-->
    <div
      class="modal fade"
      id="ModalItensAcessorios"
      aria-hidden="true"
      aria-labelledby="exampleModalToggleLabel2"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content card-container">
          <div
            class="modal-header p-3 d-flex justify-content-between align-items-center"
          >
            <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
            <span class="txt-title-modal"> Cortesias</span>
            <button
              class="btn-close"
              type="button"
              data-bs-toggle="modal"
              aria-label="Fechar"
            ></button>
          </div>

          <div class="modal-body txt-body-modal">
            <div class="row g-2 p-2">
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="searchCodigo"
                  />
                  <label>Código</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-10">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="searchDescricao"
                  />
                  <label>Descrição</label>
                </div>
              </div>
              <div class="d-flex justify-content-end gap-3 mt-4">
                <div class="d-flex d-md-none gap-2">
                  <button
                    type="button"
                    @click="
                      page = 1;
                      retrieveCortesias();
                    "
                    class="btn round-btn"
                  >
                    <i class="bi bi-search" title="Pesquisar"></i>
                  </button>
                </div>
                <div class="d-none d-md-flex gap-2">
                  <button
                    class="btn btn-form"
                    @click="
                      page = 1;
                      retrieveCortesias();
                    "
                  >
                    <span>Pesquisar</span>
                  </button>
                </div>
              </div>
            </div>
            <!--Tabelas-->
            <div class="card card-table-txt">
              <div class="d-md-none">
                <div
                  v-for="item in cortesias"
                  :key="item.id"
                  class="accordion mb-2"
                >
                  <div class="accordion-item">
                    <button
                      class="accordion-button collapsed card-table-txt"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#row-' + item.id"
                    >
                      {{ item.descricao }}
                    </button>
                    <div
                      :id="'row-' + item.id"
                      class="accordion-collapse collapse"
                    >
                      <div class="accordion-body">
                        <p class="txt-form-input">
                          <strong>Código:</strong>
                          {{ item.codigo }}
                        </p>
                        <p class="txt-form-input">
                          <strong>R$ Valor:</strong>
                          {{ currency(item.preco_venda) }}
                        </p>
                        <button
                          type="button"
                          class="btn round-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                          @click="inserirAcessorios(item)"
                        >
                          <i class="bi bi-pencil-square"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-block d-md-block d-lg-none">
                <div
                  v-for="item in cortesias"
                  :key="item.id"
                  class="accordion mb-2"
                >
                  <div class="accordion-item">
                    <button
                      class="accordion-button collapsed card-table-txt"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#row-' + item.id"
                    >
                      {{ item.descricao }}
                    </button>
                    <div
                      :id="'row-' + item.id"
                      class="accordion-collapse collapse"
                    >
                      <div class="accordion-body">
                        <p class="txt-form-input">
                          <strong>Código:</strong>
                          {{ item.codigo }}
                        </p>
                        <p class="txt-form-input">
                          <strong>R$ Valor:</strong>
                          {{ currency(item.preco_venda) }}
                        </p>
                        <button
                          type="button"
                          class="btn round-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                          @click="inserirAcessorios(item)"
                        >
                          <i class="bi bi-pencil-square"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-none d-lg-block">
                <table class="table mt-2 linha" v-if="!isLoading">
                  <thead>
                    <tr>
                      <th scope="col">Código</th>
                      <th scope="col">Descrição</th>
                      <th scope="col">R$ Valor</th>
                      <th scope="col">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in cortesias"
                      :key="item.id"
                      class="table-linha"
                    >
                      <td>{{ item.codigo }}</td>
                      <td>{{ item.descricao }}</td>
                      <td>{{ currency(item.preco_venda) }}</td>
                      <!-- <td>{{ item.preco_base_peca }}</td> -->
                      <!-- <td>{{ item.status }}</td> -->
                      <td>
                        <button
                          type="button"
                          class="dropdown-toggle-icon"
                          data-bs-dismiss="modal"
                          @click="inserirAcessorios(item)"
                        >
                          <i class="bi bi-pencil-square"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="loading-indicator">Carregando...</div>
              </div>
              <pagination
                v-if="acessorios.length"
                :total="totalItems_acc"
                :limit="pageSize_acc"
                :offset="currentPage"
                :totalPages="Math.ceil(totalItems_acc / pageSize_acc)"
                @change-page="handlePageChangeItemAcessorio"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Modal Veiculo Avaliação-->
    <div
      class="modal fade"
      id="ModalVeiculoAvaliacao"
      aria-hidden="true"
      aria-labelledby="exampleModalToggleLabel2"
      tabindex="-1"
    >
      <div class="d-md-none">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content card-container">
            <div
              class="modal-header p-3 d-flex justify-content-between align-items-center"
            >
              <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
              <span class="txt-title-modal"> Veículo para Avaliação</span>
              <button
                class="btn-close"
                type="button"
                data-bs-toggle="modal"
                aria-label="Fechar"
              ></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onSubmitVeiculoAvaliacao">
                <!--Item-->
                <div class="row g-2 p-2">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="placa_av"
                        :style="{ 'border-color': placaCorBorda }"
                        v-on:blur="verificar_avaliacao_placa()"
                      />
                      <label class="rf_texto">Placa *</label>
                    </div>
                  </div>
                  <!--Marca-->
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        v-model="marcaSelecionada"
                        class="form-control txt-form-input"
                        list="datalistMarcas"
                        id="marca"
                        autocomplete="off"
                        @change="buscarModelo"
                        ref="marcaInput"
                        :style="{ 'border-color': marcaCorBorda }"
                      />

                      <label class="rf_texto">Marcas *</label>
                      <datalist id="datalistMarcas" ref="datalistMarcas">
                        <option
                          v-for="marca in marcas"
                          :data-id="marca.codigo"
                          :value="marca.descricao"
                          :key="marca.id"
                        ></option>
                      </datalist>
                    </div>
                  </div>
                  <!--Modelo-->
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-6">
                    <div class="form-floating txt-form-label">
                      <input
                        v-model="modeloSelecionado"
                        class="form-control txt-form-input"
                        list="datalistModelos"
                        id="modelo"
                        autocomplete="off"
                        :style="{ 'border-color': modeloCorBorda }"
                      />

                      <label class="rf_texto">Modelo *</label>
                      <datalist id="datalistModelos">
                        <option
                          v-for="modelo in modelos"
                          :data-id="modelo.codigo"
                          :value="modelo.descricao"
                          :key="modelo.id"
                        ></option>
                      </datalist>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="anoModelo_av"
                        :style="{ 'border-color': anoModeloCorBorda }"
                      />
                      <label class="rf_texto">Ano Modelo *</label>
                    </div>
                  </div>
                </div>
                <div class="row g-2 p-2">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-8">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="cor_av"
                        :style="{ 'border-color': corCorBorda }"
                      />
                      <label class="rf_texto">Cor *</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="kilometragem_av"
                        :style="{ 'border-color': kilometragemCorBorda }"
                        @input="kilometragem_av = formatarKM(kilometragem_av)"
                      />
                      <label class="rf_texto">KM *</label>
                    </div>
                  </div>

                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="valor_av"
                        :style="{ 'border-color': valorAvaliadoCorBorda }"
                        @input="valor_av = formatarValor(valor_av)"
                      />
                      <label class="rf_texto">R$ Avaliado *</label>
                    </div>
                  </div>
                </div>
                <div class="row g-2 p-2">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="form-floating txt-form-label">
                      <textarea
                        v-model="obs_av"
                        class="form-control txt-form-input"
                      ></textarea>
                      <label class="rf_texto">Observação</label>
                    </div>
                  </div>
                </div>
                <div class="row g-2 p-2">
                  <h6 class="section-title linha">
                    <i class="bi bi-book me-2 icon-text-form-title"></i>Última
                    Avaliação
                  </h6>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="data_av_hst"
                        disabled
                      />
                      <label>Data</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="kilometragem_av_hst"
                        disabled
                      />
                      <label>KM</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="valor_av_hst"
                        disabled
                      />
                      <label>R$ Avaliado</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="empresa_avaliacao"
                        disabled
                      />
                      <label>Loja</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <label class="rf_texto" v-if="info_erros.placa_av"
                      >Preencha o campo Placa!</label
                    >
                    <label class="rf_texto" v-if="info_erros.marcaSelecionada"
                      >Preencha o campo Marca!</label
                    >
                    <label class="rf_texto" v-if="info_erros.modeloSelecionado"
                      >Preencha o campo Modelo!</label
                    >
                    <label class="rf_texto" v-if="info_erros.anoModelo_av"
                      >Preencha o campo Ano!</label
                    >
                    <label class="rf_texto" v-if="info_erros.cor_av"
                      >Preencha o campo Cor!</label
                    >
                  </div>
                </div>
                <div v-if="hist_avaliacoes">
                  <div
                    v-for="item in historico_avaliacoes.avaliacoes"
                    :key="item.id"
                    class="accordion mb-2"
                  >
                    <div class="accordion-item">
                      <button
                        class="accordion-button collapsed d-flex flex-column align-items-start txt-form-input"
                        data-bs-toggle="collapse"
                        :data-bs-target="'#row-' + item.id"
                      >
                        <strong>Loja:</strong>
                        {{ item.empresa }}
                      </button>
                      <div
                        :id="'row-' + item.id"
                        class="accordion-collapse collapse"
                      >
                        <div class="accordion-body">
                          <p class="txt-form-input">
                            <strong>Valor:</strong>
                            {{ currency(item.precoAvaliacao) }}
                          </p>
                          <p class="txt-form-input">
                            <strong>KM:</strong>
                            {{ formatarKM(item.kilometragem) }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Avaliador:</strong>
                            {{ item.avaliador_id }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Data:</strong>
                            {{
                              new Date(item.data).toLocaleDateString("pt-BR")
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row g-2 p-2">
                  <div
                    class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2 d-flex justify-content-center align-items-center"
                  >
                    <div class="form-floating">
                      <button
                        class="btn round-btn"
                        type="submit"
                        @click="handleUpdate"
                      >
                        <i class="bi bi-pencil-square" title="Alterar"></i>
                      </button>
                    </div>
                    <div class="form-floating">
                      <button
                        class="btn round-btn"
                        type="submit"
                        @click="handleInsert"
                      >
                        <i class="bi bi-plus-circle" title="Inserir"></i>
                      </button>
                    </div>
                    <div class="form-floating">
                      <button
                        class="btn round-btn"
                        :disabled="hab_hist_avaliacao"
                        @click="mostrar_historico"
                      >
                        <i class="bi bi-car-front-fill" title="Historico"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="d-none d-md-block d-lg-none">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content card-container">
            <div
              class="modal-header p-3 d-flex justify-content-between align-items-center"
            >
              <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
              <span class="txt-title-modal"> Veículo para Avaliação</span>
              <button
                class="btn-close"
                type="button"
                data-bs-toggle="modal"
                aria-label="Fechar"
              ></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onSubmitVeiculoAvaliacao">
                <!--Item-->
                <div class="row g-2 p-2">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="placa_av"
                        :style="{ 'border-color': placaCorBorda }"
                        v-on:blur="verificar_avaliacao_placa()"
                      />
                      <label class="rf_texto">Placa *</label>
                    </div>
                  </div>
                  <!--Marca-->
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        v-model="marcaSelecionada"
                        class="form-control txt-form-input"
                        list="datalistMarcas"
                        id="marca"
                        autocomplete="off"
                        @change="buscarModelo"
                        ref="marcaInput"
                        :style="{ 'border-color': marcaCorBorda }"
                      />

                      <label class="rf_texto">Marcas *</label>
                      <datalist id="datalistMarcas" ref="datalistMarcas">
                        <option
                          v-for="marca in marcas"
                          :data-id="marca.codigo"
                          :value="marca.descricao"
                          :key="marca.id"
                        ></option>
                      </datalist>
                    </div>
                  </div>
                  <!--Modelo-->
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-6">
                    <div class="form-floating txt-form-label">
                      <input
                        v-model="modeloSelecionado"
                        class="form-control txt-form-input"
                        list="datalistModelos"
                        id="modelo"
                        autocomplete="off"
                        :style="{ 'border-color': modeloCorBorda }"
                      />

                      <label class="rf_texto">Modelo *</label>
                      <datalist id="datalistModelos">
                        <option
                          v-for="modelo in modelos"
                          :data-id="modelo.codigo"
                          :value="modelo.descricao"
                          :key="modelo.id"
                        ></option>
                      </datalist>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="anoModelo_av"
                        :style="{ 'border-color': anoModeloCorBorda }"
                      />
                      <label class="rf_texto">Ano Modelo *</label>
                    </div>
                  </div>
                </div>
                <div class="row g-2 p-2">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-8">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="cor_av"
                        :style="{ 'border-color': corCorBorda }"
                      />
                      <label class="rf_texto">Cor *</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="kilometragem_av"
                        :style="{ 'border-color': kilometragemCorBorda }"
                        @input="kilometragem_av = formatarKM(kilometragem_av)"
                      />
                      <label class="rf_texto">KM *</label>
                    </div>
                  </div>

                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="valor_av"
                        :style="{ 'border-color': valorAvaliadoCorBorda }"
                        @input="valor_av = formatarValor(valor_av)"
                      />
                      <label class="rf_texto">R$ Avaliado *</label>
                    </div>
                  </div>
                </div>
                <div class="row g-2 p-2">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="form-floating txt-form-label">
                      <textarea
                        v-model="obs_av"
                        class="form-control txt-form-input"
                      ></textarea>
                      <label class="rf_texto">Observação</label>
                    </div>
                  </div>
                </div>
                <div class="row g-2 p-2">
                  <h6 class="section-title linha">
                    <i class="bi bi-book me-2 icon-text-form-title"></i>Última
                    Avaliação
                  </h6>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="data_av_hst"
                        disabled
                      />
                      <label>Data</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="kilometragem_av_hst"
                        disabled
                      />
                      <label>KM</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="valor_av_hst"
                        disabled
                      />
                      <label>R$ Avaliado</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="empresa_avaliacao"
                        disabled
                      />
                      <label>Loja</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <label class="rf_texto" v-if="info_erros.placa_av"
                      >Preencha o campo Placa!</label
                    >
                    <label class="rf_texto" v-if="info_erros.marcaSelecionada"
                      >Preencha o campo Marca!</label
                    >
                    <label class="rf_texto" v-if="info_erros.modeloSelecionado"
                      >Preencha o campo Modelo!</label
                    >
                    <label class="rf_texto" v-if="info_erros.anoModelo_av"
                      >Preencha o campo Ano!</label
                    >
                    <label class="rf_texto" v-if="info_erros.cor_av"
                      >Preencha o campo Cor!</label
                    >
                  </div>
                </div>
                <div v-if="hist_avaliacoes">
                  <div
                    v-for="item in historico_avaliacoes.avaliacoes"
                    :key="item.id"
                    class="accordion mb-2"
                  >
                    <div class="accordion-item">
                      <button
                        class="accordion-button collapsed d-flex flex-column align-items-start txt-form-input"
                        data-bs-toggle="collapse"
                        :data-bs-target="'#row-' + item.id"
                      >
                        <strong>Loja:</strong>
                        {{ item.empresa }}
                      </button>
                      <div
                        :id="'row-' + item.id"
                        class="accordion-collapse collapse"
                      >
                        <div class="accordion-body">
                          <p class="txt-form-input">
                            <strong>Valor:</strong>
                            {{ currency(item.precoAvaliacao) }}
                          </p>
                          <p class="txt-form-input">
                            <strong>KM:</strong>
                            {{ formatarKM(item.kilometragem) }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Avaliador:</strong>
                            {{ item.avaliador_id }}
                          </p>
                          <p class="txt-form-input">
                            <strong>Data:</strong>
                            {{
                              new Date(item.data).toLocaleDateString("pt-BR")
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row g-2 p-2">
                  <div
                    class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2 d-flex justify-content-center align-items-center"
                  >
                    <div class="form-floating">
                      <button
                        class="btn round-btn"
                        type="submit"
                        @click="handleUpdate"
                      >
                        <i class="bi bi-pencil-square" title="Alterar"></i>
                      </button>
                    </div>
                    <div class="form-floating">
                      <button
                        class="btn round-btn"
                        type="submit"
                        @click="handleInsert"
                      >
                        <i class="bi bi-plus-circle" title="Inserir"></i>
                      </button>
                    </div>
                    <div class="form-floating">
                      <button
                        class="btn round-btn"
                        :disabled="hab_hist_avaliacao"
                        @click="mostrar_historico"
                      >
                        <i class="bi bi-car-front-fill" title="Historico"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="d-none d-lg-block">
        <div class="modal-dialog modal-xl">
          <div class="modal-content card-container">
            <div
              class="modal-header p-3 d-flex justify-content-between align-items-center"
            >
              <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
              <span class="txt-title-modal"> Veículo para Avaliação</span>
              <button
                class="btn-close"
                type="button"
                data-bs-toggle="modal"
                aria-label="Fechar"
              ></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onSubmitVeiculoAvaliacao">
                <!--Item-->
                <div class="row g-2 p-2">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="placa_av"
                        :style="{ 'border-color': placaCorBorda }"
                        v-on:blur="verificar_avaliacao_placa()"
                      />
                      <label class="rf_texto">Placa *</label>
                    </div>
                  </div>
                  <!--Marca-->
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        v-model="marcaSelecionada"
                        class="form-control txt-form-input"
                        list="datalistMarcas"
                        id="marca"
                        autocomplete="off"
                        @change="buscarModelo"
                        ref="marcaInput"
                        :style="{ 'border-color': marcaCorBorda }"
                      />

                      <label class="rf_texto">Marcas *</label>
                      <datalist id="datalistMarcas" ref="datalistMarcas">
                        <option
                          v-for="marca in marcas"
                          :data-id="marca.codigo"
                          :value="marca.descricao"
                          :key="marca.id"
                        ></option>
                      </datalist>
                    </div>
                  </div>
                  <!--Modelo-->
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-6">
                    <div class="form-floating txt-form-label">
                      <input
                        v-model="modeloSelecionado"
                        class="form-control txt-form-input"
                        list="datalistModelos"
                        id="modelo"
                        autocomplete="off"
                        :style="{ 'border-color': modeloCorBorda }"
                      />

                      <label class="rf_texto">Modelo *</label>
                      <datalist id="datalistModelos">
                        <option
                          v-for="modelo in modelos"
                          :data-id="modelo.codigo"
                          :value="modelo.descricao"
                          :key="modelo.id"
                        ></option>
                      </datalist>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="anoModelo_av"
                        :style="{ 'border-color': anoModeloCorBorda }"
                      />
                      <label class="rf_texto">Ano Modelo *</label>
                    </div>
                  </div>
                </div>
                <div class="row g-2 p-2">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-6">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="cor_av"
                        :style="{ 'border-color': corCorBorda }"
                      />
                      <label class="rf_texto">Cor *</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="kilometragem_av"
                        :style="{ 'border-color': kilometragemCorBorda }"
                        @input="kilometragem_av = formatarKM(kilometragem_av)"
                      />
                      <label class="rf_texto">KM *</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="valor_av"
                        :style="{ 'border-color': valorAvaliadoCorBorda }"
                        @input="valor_av = formatarValor(valor_av)"
                      />
                      <label class="rf_texto">R$ Avaliado *</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="valor_quitacao"
                        :style="{ 'border-color': valorQuitacaoCorBorda }"
                        @input="valor_quitacao = formatarValor(valor_quitacao)"
                      />
                      <label class="rf_texto">R$ Quitação *</label>
                    </div>
                  </div>
                </div>
                <div class="row g-2 p-2">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="form-floating txt-form-label">
                      <textarea
                        v-model="obs_av"
                        class="form-control txt-form-input"
                      ></textarea>
                      <label class="rf_texto">Observação</label>
                    </div>
                  </div>
                </div>
                <div class="row g-2 p-2">
                  <h6 class="section-title linha">
                    <i class="bi bi-book me-2 icon-text-form-title"></i>Última
                    Avaliação
                  </h6>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="data_av_hst"
                        disabled
                      />
                      <label>Data</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="kilometragem_av_hst"
                        disabled
                      />
                      <label>KM</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="valor_av_hst"
                        disabled
                      />
                      <label>R$ Avaliado</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <input
                        type="text"
                        class="form-control txt-form-input"
                        v-model="empresa_avaliacao"
                        disabled
                      />
                      <label>Loja</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <div class="form-floating txt-form-label">
                      <button
                        type="button"
                        class="btn btn-modal"
                        :disabled="hab_hist_avaliacao"
                        @click="mostrar_historico"
                      >
                        <span>Histórico</span>
                      </button>
                    </div>
                  </div>
                  <div
                    class="col-12 col-sm-12 col-m-12 col-lg-12 col-xl-12"
                    v-if="hist_avaliacoes"
                  >
                    <table class="table rf_texto_desk">
                      <thead>
                        <tr>
                          <th scope="col">Valor</th>
                          <th scope="col">KM</th>
                          <th scope="col">Loja</th>
                          <th scope="col">Avaliador</th>
                          <th scope="col">Data</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in historico_avaliacoes.avaliacoes"
                          :key="item.id"
                        >
                          <td>{{ currency(item.precoAvaliacao) }}</td>
                          <td>{{ formatarKM(item.kilometragem) }}</td>
                          <td>{{ item.empresa }}</td>
                          <td>{{ item.avaliador_id }}</td>
                          <td>
                            {{
                              new Date(item.data).toLocaleDateString("pt-BR")
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                    <label class="rf_texto" v-if="info_erros.placa_av"
                      >Preencha o campo Placa!</label
                    >
                    <label class="rf_texto" v-if="info_erros.marcaSelecionada"
                      >Preencha o campo Marca!</label
                    >
                    <label class="rf_texto" v-if="info_erros.modeloSelecionado"
                      >Preencha o campo Modelo!</label
                    >
                    <label class="rf_texto" v-if="info_erros.anoModelo_av"
                      >Preencha o campo Ano!</label
                    >
                    <label class="rf_texto" v-if="info_erros.cor_av"
                      >Preencha o campo Cor!</label
                    >
                  </div>
                </div>

                <div class="d-flex flex-wrap flex-md-nowrap w-100 gap-2">
                  <div class="flex-grow-1">
                    <button
                      class="btn btn-form"
                      type="submit"
                      @click="handleUpdate"
                    >
                      <span> Alterar</span>
                    </button>
                  </div>
                  <div class="flex-grow-1">
                    <button
                      class="btn btn-form"
                      type="submit"
                      @click="handleInsert"
                    >
                      <span>Inserir</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Modal Ranqueamento-->
    <div
      class="modal fade"
      id="ModalRanqueamento"
      aria-hidden="true"
      aria-labelledby="exampleModalToggleLabel2"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered modal-fullscreen">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
            <span class="txt-title-modal"> Ranqueamento</span>
            <button
              class="btn-close"
              type="button"
              data-bs-toggle="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <!--Tabelas 1 -->
            <div class="card txt-title-table-desk">
              <div class="d-md-none">
                <div class="row g-2 p-2">
                  <div class="card-title gy-4 linha">
                    <i class="bi bi-cash-coin fs-5 icon-text-form"></i>
                    <span class="txt-title-form">Valores da Simulação</span>
                  </div>
                  <div
                    class="card-title gy-4 d-flex justify-content-center align-items-center"
                  >
                    <div class="col-6">
                      <span class="txt-title-form-desk"
                        >Valor de Entrada: <strong>{{ Valor_Entrada }}</strong>
                      </span>
                    </div>
                    <div class="col-6">
                      <span class="txt-title-form-desk"
                        >Valor Financiado:
                        <strong>{{ Valor_Financiado }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  v-for="item in parcelamento_1"
                  :key="item.id"
                  class="accordion mb-2"
                >
                  <div class="accordion-item">
                    <button
                      class="accordion-button collapsed card-table-txt"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#row-' + item.id"
                      :class="{
                        'custom-highlight-row': item.id === linhaSelecionada
                      }"
                    >
                      {{ item.plano }} - {{ currency(item.pmt) }}
                    </button>
                    <div
                      :id="'row-' + item.id"
                      class="accordion-collapse collapse"
                    >
                      <div class="accordion-body">
                        <p>
                          <strong>Financeira:</strong>
                          {{ item.financeira }}
                        </p>
                        <p>
                          <strong>Ret:</strong>
                          {{ item.ret }}
                        </p>
                        <p>
                          <strong>R$ Entrada Miníma:</strong>
                          {{ currency(item.entrada_min_valor) }}
                        </p>
                        <p>
                          <strong>% Entrada Miníma:</strong>
                          {{ item.entrada_min_porcentagem }}
                        </p>
                        <p>
                          <strong>Rentabilidade:</strong>
                          {{ currency(item.rentabilidade) }}
                        </p>
                        <p>
                          <strong>Rebate:</strong>
                          {{
                            currency(
                              (parseFloat(
                                (Valor_Financiado || "0")
                                  .replace(/[^\d,]+/g, "")
                                  .replace(",", ".")
                              ) +
                                item.tc_cob) *
                                item.descontoCoeficiente
                            )
                          }}
                        </p>
                        <p>
                          <strong>Pmt:</strong>
                          {{ currency(item.pmt) }}
                        </p>
                        <p>
                          <strong>Spf:</strong>
                          {{ item.spf }}
                        </p>
                        <p>
                          <strong>Retorno:</strong>
                          {{ item.retorno }}
                        </p>
                        <p>
                          <strong>Tc. Cob:</strong>
                          {{ currency(item.tc_cob) }}
                        </p>
                        <p>
                          <strong>Tc. Dev:</strong>
                          {{ item.tc_dev }}
                        </p>
                        <p>
                          <strong>Coeficiente:</strong>
                          {{ item.coeficiente }}
                        </p>
                        <p>
                          <strong>Quantidade de Parcelas:</strong>
                          {{ item.qtd_parcelas }}
                        </p>
                        <button
                          type="button"
                          class="btn round-btn"
                          @click="
                            rowSelect(
                              key,
                              item.id,
                              1,
                              item.pmt,
                              item.rentabilidade
                            )
                          "
                        >
                          <i class="bi bi-pencil-square"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Versão para telas médias (768px - 992px) -->
              <div class="d-none d-md-block d-lg-none">
                <div class="row g-2 p-2">
                  <div class="card-title gy-4 linha">
                    <i class="bi bi-cash-coin fs-5 icon-text-form"></i>
                    <span class="txt-title-form">Valores da Simulação</span>
                  </div>
                  <div
                    class="card-title gy-4 d-flex justify-content-center align-items-center"
                  >
                    <div class="col-6">
                      <span class="txt-title-form-desk"
                        >Valor de Entrada: <strong>{{ Valor_Entrada }}</strong>
                      </span>
                    </div>
                    <div class="col-6">
                      <span class="txt-title-form-desk"
                        >Valor Financiado:
                        <strong>{{ Valor_Financiado }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  v-for="item in parcelamento_1"
                  :key="item.id"
                  class="accordion mb-2"
                >
                  <div class="accordion-item">
                    <button
                      class="accordion-button collapsed card-table-txt"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#row-' + item.id"
                      :class="{
                        'custom-highlight-row': item.id === linhaSelecionada
                      }"
                    >
                      {{ item.plano }} - {{ currency(item.pmt) }}
                    </button>
                    <div
                      :id="'row-' + item.id"
                      class="accordion-collapse collapse"
                    >
                      <div class="accordion-body">
                        <p>
                          <strong>Financeira:</strong>
                          {{ item.financeira }}
                        </p>
                        <p>
                          <strong>Ret:</strong>
                          {{ item.ret }}
                        </p>
                        <p>
                          <strong>R$ Entrada Miníma:</strong>
                          {{ currency(item.entrada_min_valor) }}
                        </p>
                        <p>
                          <strong>% Entrada Miníma:</strong>
                          {{ item.entrada_min_porcentagem }}
                        </p>
                        <p>
                          <strong>Rentabilidade:</strong>
                          {{ currency(item.rentabilidade) }}
                        </p>
                        <p>
                          <strong>Rebate:</strong>
                          {{
                            currency(
                              (parseFloat(
                                (Valor_Financiado || "0")
                                  .replace(/[^\d,]+/g, "")
                                  .replace(",", ".")
                              ) +
                                item.tc_cob) *
                                item.descontoCoeficiente
                            )
                          }}
                        </p>
                        <p>
                          <strong>Pmt:</strong>
                          {{ currency(item.pmt) }}
                        </p>
                        <p>
                          <strong>Spf:</strong>
                          {{ item.spf }}
                        </p>
                        <p>
                          <strong>Retorno:</strong>
                          {{ item.retorno }}
                        </p>
                        <p>
                          <strong>Tc. Cob:</strong>
                          {{ currency(item.tc_cob) }}
                        </p>
                        <p>
                          <strong>Tc. Dev:</strong>
                          {{ item.tc_dev }}
                        </p>
                        <p>
                          <strong>Coeficiente:</strong>
                          {{ item.coeficiente }}
                        </p>
                        <p>
                          <strong>Quantidade de Parcelas:</strong>
                          {{ item.qtd_parcelas }}
                        </p>
                        <button
                          type="button"
                          class="btn btn-form"
                          @click="
                            rowSelect(
                              key,
                              item.id,
                              1,
                              item.pmt,
                              item.rentabilidade
                            )
                          "
                        >
                          <i class="bi bi-pencil-square me-2"></i>
                          <span>Selecionar Taxa</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-none d-lg-block">
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <div class="card-title gy-4">
                        <i
                          class="bi bi-cash-coin me-1 icon-text-form-title"
                        ></i>
                        <span class="txt-form-label me-3"
                          >Valor de Entrada:
                          <strong>{{ Valor_Entrada }}</strong>
                        </span>
                        <i
                          class="bi bi-cash-coin me-1 icon-text-form-title"
                        ></i>
                        <span class="txt-form-label"
                          >Valor Financiado:
                          <strong>{{ Valor_Financiado }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col" v-if="this.mensagemErro">
                      <div class="card-title gy-4">
                        <i
                          class="bi bi-cash-coin me-1 icon-text-form-title"
                        ></i>
                        <span class="txt-form-label me-3 msg_tx">
                          <strong>{{ this.mensagemErro }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col" v-if="this.mensagemErro_1">
                      <div class="card-title gy-4">
                        <i
                          class="bi bi-cash-coin me-1 icon-text-form-title"
                        ></i>
                        <span class="txt-form-label me-3 msg_tx">
                          <strong>{{ this.mensagemErro_1 }}</strong>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <table class="table mt-2 linha" v-if="!isLoading">
                  <thead>
                    <tr>
                      <th scope="col">Financeira</th>
                      <th scope="col">Plano</th>
                      <th scope="col">Ret</th>
                      <th scope="col">R$ Ent. Min</th>
                      <th scope="col">% Ent. Min</th>
                      <th scope="col">Rentabilidade</th>
                      <th scope="col">Rebate</th>
                      <th scope="col">Pmt</th>
                      <th scope="col">Spf</th>
                      <th scope="col">Retorno</th>
                      <th scope="col">Tc Cob</th>
                      <th scope="col">Tc Dev</th>
                      <th scope="col">Coef</th>
                      <th scope="col">Qtd. Parc</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :class="
                        item.id_taxa === linhaSelecionada
                          ? 'custom-highlight-row'
                          : ''
                      "
                      @click="
                        rowSelect(
                          key,
                          item.id_taxa,
                          1,
                          item.pmt,
                          item.rentabilidade
                        )
                      "
                      v-for="(item, key) in parcelamento_1"
                      :key="item.id"
                    >
                      <td>{{ item.financeira }}</td>
                      <td>{{ item.plano }}</td>
                      <td>{{ item.ret }}</td>
                      <td>{{ currency(item.entrada_min_valor) }}</td>
                      <td>{{ item.entrada_min_porcentagem }}</td>
                      <td>{{ currency(item.rentabilidade) }}</td>

                      <td>
                        {{
                          currency(
                            (parseFloat(
                              (Valor_Financiado || "0")
                                .replace(/[^\d,]+/g, "")
                                .replace(",", ".")
                            ) +
                              item.tc_cob) *
                              item.descontoCoeficiente
                          )
                        }}
                      </td>
                      <td>{{ currency(item.pmt) }}</td>
                      <td>{{ item.spf }}</td>
                      <td>{{ item.retorno }}</td>
                      <td>{{ currency(item.tc_cob) }}</td>
                      <td>{{ item.tc_dev }}</td>
                      <td>{{ item.coeficiente }}</td>
                      <td>{{ item.qtd_parcelas }}</td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="loading-indicator">Carregando...</div>
              </div>
              <pagination
                v-if="parcelamento_1.length"
                :total="totalItems_1"
                :limit="pageSize_1"
                :offset="currentPage"
                :totalPages="Math.ceil(totalItems_1 / pageSize_1)"
                @change-page="handlePageChangeEntrada1"
              />
            </div>

            <!--Tabelas 2-->
            <div class="card txt-title-table-desk">
              <div class="d-md-none">
                <div class="row g-2 p-2">
                  <div class="card-title gy-4 linha">
                    <i class="bi bi-cash-coin fs-5 icon-text-form"></i>
                    <span class="txt-title-form">Valores da Simulação</span>
                  </div>
                  <div
                    class="card-title gy-4 d-flex justify-content-center align-items-center"
                  >
                    <div class="col-6">
                      <span class="txt-title-form-desk"
                        >Valor de Entrada:
                        <strong>{{ Valor_Entrada_2 }}</strong>
                      </span>
                    </div>
                    <div class="col-6">
                      <span class="txt-title-form-desk"
                        >Valor Financiado:
                        <strong>{{ Valor_Financiado_2 }}</strong>
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  v-for="item in parcelamento_2"
                  :key="item.id"
                  class="accordion mb-2"
                >
                  <div class="accordion-item">
                    <button
                      class="accordion-button collapsed card-table-txt"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#row-' + item.id"
                      :class="{
                        'custom-highlight-row': item.id === linhaSelecionada2
                      }"
                    >
                      {{ item.plano }} - {{ currency(item.pmt) }}
                    </button>
                    <div
                      :id="'row-' + item.id"
                      class="accordion-collapse collapse"
                    >
                      <div class="accordion-body">
                        <p>
                          <strong>Financeira:</strong>
                          {{ item.financeira }}
                        </p>
                        <p>
                          <strong>Ret:</strong>
                          {{ item.ret }}
                        </p>
                        <p>
                          <strong>R$ Entrada Miníma:</strong>
                          {{ currency(item.entrada_min_valor) }}
                        </p>
                        <p>
                          <strong>% Entrada Miníma:</strong>
                          {{ item.entrada_min_porcentagem }}
                        </p>
                        <p>
                          <strong>Rentabilidade:</strong>
                          {{ currency(item.rentabilidade) }}
                        </p>
                        <p>
                          <strong>Rebate:</strong>
                          {{
                            currency(
                              (parseFloat(
                                (Valor_Financiado_2 || "0")
                                  .replace(/[^\d,]+/g, "")
                                  .replace(",", ".")
                              ) +
                                item.tc_cob) *
                                item.descontoCoeficiente
                            )
                          }}
                        </p>
                        <p>
                          <strong>Pmt:</strong>
                          {{ currency(item.pmt) }}
                        </p>
                        <p>
                          <strong>Spf:</strong>
                          {{ item.spf }}
                        </p>
                        <p>
                          <strong>Retorno:</strong>
                          {{ item.retorno }}
                        </p>
                        <p>
                          <strong>Tc. Cob:</strong>
                          {{ currency(item.tc_cob) }}
                        </p>
                        <p>
                          <strong>Tc. Dev:</strong>
                          {{ item.tc_dev }}
                        </p>
                        <p>
                          <strong>Coeficiente:</strong>
                          {{ item.coeficiente }}
                        </p>
                        <p>
                          <strong>Quantidade de Parcelas:</strong>
                          {{ item.qtd_parcelas }}
                        </p>
                        <button
                          type="button"
                          class="btn round-btn"
                          @click="
                            rowSelect2(
                              key,
                              item.id,
                              2,
                              item.pmt,
                              item.rentabilidade
                            )
                          "
                        >
                          <i class="bi bi-pencil-square"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Versão para telas médias (768px - 992px) -->
              <div class="d-none d-md-block d-lg-none">
                <div class="row g-2 p-2">
                  <div class="card-title gy-4 linha">
                    <i class="bi bi-cash-coin fs-5 icon-text-form"></i>
                    <span class="txt-title-form">Valores da Simulação</span>
                  </div>
                  <div
                    class="card-title gy-4 d-flex justify-content-center align-items-center"
                  >
                    <div class="col-6">
                      <span class="txt-title-form-desk"
                        >Valor de Entrada:
                        <strong>{{ Valor_Entrada_2 }}</strong>
                      </span>
                    </div>
                    <div class="col-6">
                      <span class="txt-title-form-desk"
                        >Valor Financiado:
                        <strong>{{ Valor_Financiado_2 }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  v-for="item in parcelamento_2"
                  :key="item.id"
                  class="accordion mb-2"
                >
                  <div class="accordion-item">
                    <button
                      class="accordion-button collapsed card-table-txt"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#row-' + item.id"
                      :class="{
                        'custom-highlight-row': item.id === linhaSelecionada2
                      }"
                    >
                      {{ item.plano }} - {{ currency(item.pmt) }}
                    </button>
                    <div
                      :id="'row-' + item.id"
                      class="accordion-collapse collapse"
                    >
                      <div class="accordion-body">
                        <p>
                          <strong>Financeira:</strong>
                          {{ item.financeira }}
                        </p>
                        <p>
                          <strong>Ret:</strong>
                          {{ item.ret }}
                        </p>
                        <p>
                          <strong>R$ Entrada Miníma:</strong>
                          {{ currency(item.entrada_min_valor) }}
                        </p>
                        <p>
                          <strong>% Entrada Miníma:</strong>
                          {{ item.entrada_min_porcentagem }}
                        </p>
                        <p>
                          <strong>Rentabilidade:</strong>
                          {{ currency(item.rentabilidade) }}
                        </p>
                        <p>
                          <strong>Rebate:</strong>
                          {{
                            currency(
                              (parseFloat(
                                (Valor_Financiado_2 || "0")
                                  .replace(/[^\d,]+/g, "")
                                  .replace(",", ".")
                              ) +
                                item.tc_cob) *
                                item.descontoCoeficiente
                            )
                          }}
                        </p>
                        <p>
                          <strong>Pmt:</strong>
                          {{ currency(item.pmt) }}
                        </p>
                        <p>
                          <strong>Spf:</strong>
                          {{ item.spf }}
                        </p>
                        <p>
                          <strong>Retorno:</strong>
                          {{ item.retorno }}
                        </p>
                        <p>
                          <strong>Tc. Cob:</strong>
                          {{ currency(item.tc_cob) }}
                        </p>
                        <p>
                          <strong>Tc. Dev:</strong>
                          {{ item.tc_dev }}
                        </p>
                        <p>
                          <strong>Coeficiente:</strong>
                          {{ item.coeficiente }}
                        </p>
                        <p>
                          <strong>Quantidade de Parcelas:</strong>
                          {{ item.qtd_parcelas }}
                        </p>
                        <button
                          type="button"
                          class="btn btn-form"
                          @click="
                            rowSelect2(
                              key,
                              item.id,
                              2,
                              item.pmt,
                              item.rentabilidade
                            )
                          "
                        >
                          <i class="bi bi-pencil-square me-2"></i>
                          <span>Selecionar Taxa</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-none d-lg-block">
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <div class="card-title gy-4">
                        <i
                          class="bi bi-cash-coin me-1 icon-text-form-title"
                        ></i>
                        <span class="txt-form-label me-3"
                          >Valor de Entrada:
                          <strong>{{ Valor_Entrada_2 }}</strong>
                        </span>
                        <i
                          class="bi bi-cash-coin me-1 icon-text-form-title"
                        ></i>
                        <span class="txt-form-label"
                          >Valor Financiado:
                          <strong>{{ Valor_Financiado_2 }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col" v-if="this.mensagemErro">
                      <div class="card-title gy-4">
                        <i
                          class="bi bi-cash-coin me-1 icon-text-form-title"
                        ></i>
                        <span class="txt-form-label me-3 msg_tx">
                          <strong>{{ this.mensagemErro }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col" v-if="this.mensagemErro_2">
                      <div class="card-title gy-4">
                        <i
                          class="bi bi-cash-coin me-1 icon-text-form-title"
                        ></i>
                        <span class="txt-form-label me-3 msg_tx">
                          <strong>{{ this.mensagemErro_2 }}</strong>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <table class="table mt-2 linha" v-if="!isLoading">
                  <thead>
                    <tr>
                      <th scope="col">Financeira</th>
                      <th scope="col">Plano</th>
                      <th scope="col">Ret</th>
                      <th scope="col">R$ Ent. Min</th>
                      <th scope="col">% Ent. Min</th>
                      <th scope="col">Rentabilidade</th>
                      <th scope="col">Rebate</th>
                      <th scope="col">Pmt</th>
                      <th scope="col">Spf</th>
                      <th scope="col">Retorno</th>
                      <th scope="col">Tc Cob</th>
                      <th scope="col">Tc Dev</th>
                      <th scope="col">Coef</th>
                      <th scope="col">Qtd. Parc</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :class="
                        item.id_taxa === linhaSelecionada2
                          ? 'custom-highlight-row'
                          : ''
                      "
                      @click="
                        rowSelect2(
                          key,
                          item.id_taxa,
                          2,
                          item.pmt,
                          item.rentabilidade
                        )
                      "
                      v-for="(item, key) in parcelamento_2"
                      :key="item.id"
                    >
                      <td>{{ item.financeira }}</td>
                      <td>{{ item.plano }}</td>
                      <td>{{ item.ret }}</td>
                      <td>{{ currency(item.entrada_min_valor) }}</td>
                      <td>{{ item.entrada_min_porcentagem }}</td>
                      <td>{{ currency(item.rentabilidade) }}</td>
                      <td>
                        {{
                          currency(
                            (parseFloat(
                              (Valor_Financiado_2 || "0")
                                .replace(/[^\d,]+/g, "")
                                .replace(",", ".")
                            ) +
                              item.tc_cob) *
                              item.descontoCoeficiente
                          )
                        }}
                      </td>
                      <td>{{ currency(item.pmt) }}</td>
                      <td>{{ item.spf }}</td>
                      <td>{{ item.retorno }}</td>
                      <td>{{ currency(item.tc_cob) }}</td>
                      <td>{{ item.tc_dev }}</td>
                      <td>{{ item.coeficiente }}</td>
                      <td>{{ item.qtd_parcelas }}</td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="loading-indicator">Carregando...</div>
              </div>
              <pagination
                v-if="parcelamento_2.length"
                :total="totalItems_2"
                :limit="pageSize_2"
                :offset="currentPage"
                :totalPages="Math.ceil(totalItems_2 / pageSize_2)"
                @change-page="handlePageChangeEntrada2"
              />
            </div>
            <!--Tabelas 3-->
            <div class="card txt-title-table-desk">
              <div class="d-md-none">
                <div class="row g-2 p-2">
                  <div class="card-title gy-4 linha">
                    <i class="bi bi-cash-coin fs-5 icon-text-form"></i>
                    <span class="txt-title-form">Valores da Simulação</span>
                  </div>
                  <div
                    class="card-title gy-4 d-flex justify-content-center align-items-center"
                  >
                    <div class="col-6">
                      <span class="txt-title-form-desk"
                        >Valor de Entrada:
                        <strong>{{ Valor_Entrada_3 }}</strong>
                      </span>
                    </div>
                    <div class="col-6">
                      <span class="txt-title-form-desk"
                        >Valor Financiado:
                        <strong>{{ Valor_Financiado_3 }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  v-for="item in parcelamento_3"
                  :key="item.id"
                  class="accordion mb-2"
                >
                  <div class="accordion-item">
                    <button
                      class="accordion-button collapsed card-table-txt"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#row-' + item.id"
                      :class="{
                        'custom-highlight-row': item.id === linhaSelecionada3
                      }"
                    >
                      {{ item.plano }} - {{ currency(item.pmt) }}
                    </button>
                    <div
                      :id="'row-' + item.id"
                      class="accordion-collapse collapse"
                    >
                      <div class="accordion-body">
                        <p>
                          <strong>Financeira:</strong>
                          {{ item.financeira }}
                        </p>
                        <p>
                          <strong>Ret:</strong>
                          {{ item.ret }}
                        </p>
                        <p>
                          <strong>R$ Entrada Miníma:</strong>
                          {{ currency(item.entrada_min_valor) }}
                        </p>
                        <p>
                          <strong>% Entrada Miníma:</strong>
                          {{ item.entrada_min_porcentagem }}
                        </p>
                        <p>
                          <strong>Rentabilidade:</strong>
                          {{ currency(item.rentabilidade) }}
                        </p>
                        <p>
                          <strong>Rebate:</strong>
                          {{
                            currency(
                              (parseFloat(
                                (Valor_Financiado_3 || "0")
                                  .replace(/[^\d,]+/g, "")
                                  .replace(",", ".")
                              ) +
                                item.tc_cob) *
                                item.descontoCoeficiente
                            )
                          }}
                        </p>
                        <p>
                          <strong>Pmt:</strong>
                          {{ currency(item.pmt) }}
                        </p>
                        <p>
                          <strong>Spf:</strong>
                          {{ item.spf }}
                        </p>
                        <p>
                          <strong>Retorno:</strong>
                          {{ item.retorno }}
                        </p>
                        <p>
                          <strong>Tc. Cob:</strong>
                          {{ currency(item.tc_cob) }}
                        </p>
                        <p>
                          <strong>Tc. Dev:</strong>
                          {{ item.tc_dev }}
                        </p>
                        <p>
                          <strong>Coeficiente:</strong>
                          {{ item.coeficiente }}
                        </p>
                        <p>
                          <strong>Quantidade de Parcelas:</strong>
                          {{ item.qtd_parcelas }}
                        </p>
                        <button
                          type="button"
                          class="btn round-btn"
                          @click="
                            rowSelect3(
                              key,
                              item.id,
                              3,
                              item.pmt,
                              item.rentabilidade
                            )
                          "
                        >
                          <i class="bi bi-pencil-square"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Versão para telas médias (768px - 992px) -->
              <div class="d-none d-md-block d-lg-none">
                <div class="row g-2 p-2">
                  <div class="card-title gy-4 linha">
                    <i class="bi bi-cash-coin fs-5 icon-text-form"></i>
                    <span class="txt-title-form">Valores da Simulação</span>
                  </div>
                  <div
                    class="card-title gy-4 d-flex justify-content-center align-items-center"
                  >
                    <div class="col-6">
                      <span class="txt-title-form-desk"
                        >Valor de Entrada:
                        <strong>{{ Valor_Entrada_3 }}</strong>
                      </span>
                    </div>
                    <div class="col-6">
                      <span class="txt-title-form-desk"
                        >Valor Financiado:
                        <strong>{{ Valor_Financiado_3 }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  v-for="item in parcelamento_3"
                  :key="item.id"
                  class="accordion mb-2"
                >
                  <div class="accordion-item">
                    <button
                      class="accordion-button collapsed card-table-txt"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#row-' + item.id"
                      :class="{
                        'custom-highlight-row': item.id === linhaSelecionada3
                      }"
                    >
                      {{ item.plano }} - {{ currency(item.pmt) }}
                    </button>
                    <div
                      :id="'row-' + item.id"
                      class="accordion-collapse collapse"
                    >
                      <div class="accordion-body">
                        <p>
                          <strong>Financeira:</strong>
                          {{ item.financeira }}
                        </p>
                        <p>
                          <strong>Ret:</strong>
                          {{ item.ret }}
                        </p>
                        <p>
                          <strong>R$ Entrada Miníma:</strong>
                          {{ currency(item.entrada_min_valor) }}
                        </p>
                        <p>
                          <strong>% Entrada Miníma:</strong>
                          {{ item.entrada_min_porcentagem }}
                        </p>
                        <p>
                          <strong>Rentabilidade:</strong>
                          {{ currency(item.rentabilidade) }}
                        </p>
                        <p>
                          <strong>Rebate:</strong>
                          {{
                            currency(
                              (parseFloat(
                                (Valor_Financiado_3 || "0")
                                  .replace(/[^\d,]+/g, "")
                                  .replace(",", ".")
                              ) +
                                item.tc_cob) *
                                item.descontoCoeficiente
                            )
                          }}
                        </p>
                        <p>
                          <strong>Pmt:</strong>
                          {{ currency(item.pmt) }}
                        </p>
                        <p>
                          <strong>Spf:</strong>
                          {{ item.spf }}
                        </p>
                        <p>
                          <strong>Retorno:</strong>
                          {{ item.retorno }}
                        </p>
                        <p>
                          <strong>Tc. Cob:</strong>
                          {{ currency(item.tc_cob) }}
                        </p>
                        <p>
                          <strong>Tc. Dev:</strong>
                          {{ item.tc_dev }}
                        </p>
                        <p>
                          <strong>Coeficiente:</strong>
                          {{ item.coeficiente }}
                        </p>
                        <p>
                          <strong>Quantidade de Parcelas:</strong>
                          {{ item.qtd_parcelas }}
                        </p>
                        <button
                          type="button"
                          class="btn btn-form"
                          @click="
                            rowSelect3(
                              key,
                              item.id,
                              3,
                              item.pmt,
                              item.rentabilidade
                            )
                          "
                        >
                          <i class="bi bi-pencil-square me-2"></i>
                          <span>Selecionar Taxa</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-none d-lg-block">
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <div class="card-title gy-4">
                        <i
                          class="bi bi-cash-coin me-1 icon-text-form-title"
                        ></i>
                        <span class="txt-form-label me-3"
                          >Valor de Entrada:
                          <strong>{{ Valor_Entrada_3 }}</strong>
                        </span>
                        <i
                          class="bi bi-cash-coin me-1 icon-text-form-title"
                        ></i>
                        <span class="txt-form-label"
                          >Valor Financiado:
                          <strong>{{ Valor_Financiado_3 }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col" v-if="this.mensagemErro">
                      <div class="card-title gy-4">
                        <i
                          class="bi bi-cash-coin me-1 icon-text-form-title"
                        ></i>
                        <span class="txt-form-label me-3 msg_tx">
                          <strong>{{ this.mensagemErro }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col" v-if="this.mensagemErro_3">
                      <div class="card-title gy-4">
                        <i
                          class="bi bi-cash-coin me-1 icon-text-form-title"
                        ></i>
                        <span class="txt-form-label me-3 msg_tx">
                          <strong>{{ this.mensagemErro_3 }}</strong>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <table class="table mt-2 linha" v-if="!isLoading">
                  <thead>
                    <tr>
                      <th scope="col">Financeira</th>
                      <th scope="col">Plano</th>
                      <th scope="col">Ret</th>
                      <th scope="col">R$ Ent. Min</th>
                      <th scope="col">% Ent. Min</th>
                      <th scope="col">Rentabilidade</th>
                      <th scope="col">Rebate</th>
                      <th scope="col">Pmt</th>
                      <th scope="col">Spf</th>
                      <th scope="col">Retorno</th>
                      <th scope="col">Tc Cob</th>
                      <th scope="col">Tc Dev</th>
                      <th scope="col">Coef</th>
                      <th scope="col">Qtd. Parc</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :class="
                        item.id_taxa === linhaSelecionada3
                          ? 'custom-highlight-row'
                          : ''
                      "
                      @click="
                        rowSelect3(
                          key,
                          item.id_taxa,
                          3,
                          item.pmt,
                          item.rentabilidade
                        )
                      "
                      v-for="(item, key) in parcelamento_3"
                      :key="item.id"
                    >
                      <td>{{ item.financeira }}</td>
                      <td>{{ item.plano }}</td>
                      <td>{{ item.ret }}</td>
                      <td>{{ currency(item.entrada_min_valor) }}</td>
                      <td>{{ item.entrada_min_porcentagem }}</td>
                      <td>{{ currency(item.rentabilidade) }}</td>
                      <td>
                        {{
                          currency(
                            (parseFloat(
                              (Valor_Financiado_3 || "0")
                                .replace(/[^\d,]+/g, "")
                                .replace(",", ".")
                            ) +
                              item.tc_cob) *
                              item.descontoCoeficiente
                          )
                        }}
                      </td>
                      <td>{{ currency(item.pmt) }}</td>
                      <td>{{ item.spf }}</td>
                      <td>{{ item.retorno }}</td>
                      <td>{{ currency(item.tc_cob) }}</td>
                      <td>{{ item.tc_dev }}</td>
                      <td>{{ item.coeficiente }}</td>
                      <td>{{ item.qtd_parcelas }}</td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="loading-indicator">Carregando...</div>
              </div>
              <pagination
                v-if="parcelamento_3.length"
                :total="totalItems_3"
                :limit="pageSize_3"
                :offset="currentPage"
                :totalPages="Math.ceil(totalItems_3 / pageSize_3)"
                @change-page="handlePageChangeEntrada3"
              />
            </div>
          </div>
          <div class="modal-footer p-2">
            <button
              type="button"
              data-bs-dismiss="modal"
              class="btn btn-modal"
              :disabled="
                !selecoesTaxas.tabela1 &&
                !selecoesTaxas.tabela2 &&
                !selecoesTaxas.tabela3
              "
              @click="enviarTodasTaxas"
            >
              RANKING
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--Modal Gerar Menu-->
    <div class="avoid-break">
      <div
        class="modal fade"
        id="ModalGerarMenu"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel2"
        tabindex="-1"
      >
        <div class="d-md-none">
          <div class="modal-dialog modal-lg rf_modal font-pdf-menu">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div class="container_pdf" ref="contentToPrint">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-6">
                        <a class="navbar-brand logo">
                          <img
                            src="../../assets/logo.png"
                            alt="Bootstrap"
                            class="logo-pdf"
                          />
                        </a>
                      </div>
                      <div class="col-6" style="text-align: right">
                        <a class="navbar-brand logo_cliente">
                          <img
                            src="../../assets/logo.png"
                            alt="Bootstrap"
                            class="logo-pdf"
                          />
                        </a>
                      </div>
                    </div>
                    <!-- Primeiro Bloco-->
                    <div class="row g-2">
                      <div class="col-12">
                        <div class="card card-pdf border-secondary mb-1">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-person-bounding-box ico-pdf"></i>
                            Informações do Cliente
                          </div>
                          <div class="card-body">
                            <p class="card-text-pdf">
                              <strong>CLIENTE:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_cliente
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>CPF/CNPJ:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_cpfCnpj
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>FONE:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_fone
                              }}</span>
                              /
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_fone2
                              }}</span>
                            </p>

                            <p class="card-text-pdf">
                              <strong>EMAIL:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_email
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="card card-pdf border-secondary mb-2">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-file-earmark-text ico-pdf"></i>
                            Informações do Atendimento
                          </div>
                          <div class="card-body">
                            <p class="card-text-pdf">
                              <strong>GERENTE:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_gerente
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>VENDEDOR:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_vendedor
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>NEGOCIAÇÃO:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_negociacao
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>DATA:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_data_negociacao
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="card card-pdf border-secondary mb-2">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-car-front-fill ico-pdf"></i>
                            Veículo de Troca
                          </div>
                          <div>
                            <ul class="list-group">
                              <li
                                v-for="item in veiculos_avaliados"
                                :key="item.id"
                                class="list-group-item texto_menu_desk_pdf"
                              >
                                <div class="row">
                                  <div class="col">
                                    <span class="header_pdf_txt">Marca</span>
                                  </div>
                                  <div class="col">
                                    <span class="header_pdf_txt">Modelo</span>
                                  </div>
                                  <div class="col">
                                    <span class="header_pdf_txt">Placa</span>
                                  </div>
                                  <div class="col">
                                    <span class="header_pdf_txt">Avaliado</span>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col">
                                    <span class="texto_menu_desk_pdf">{{
                                      item.marca
                                    }}</span>
                                  </div>
                                  <div class="col">
                                    <span class="texto_menu_desk_pdf">{{
                                      item.modelo
                                    }}</span>
                                  </div>
                                  <div class="col">
                                    <span class="texto_menu_desk_pdf">{{
                                      item.placa
                                    }}</span>
                                  </div>
                                  <div class="col">
                                    <span class="texto_menu_desk_pdf">{{
                                      item.preco_avaliado
                                    }}</span>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Segundo Bloco-->
                    <div class="row g-2">
                      <div class="col-12">
                        <div class="card card-pdf border-secondary mb-1">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-card-checklist ico-pdf"></i>
                            INFORMAÇÕES DO VEÍCULO
                          </div>
                          <div class="card-body text-secondary">
                            <p class="card-text-pdf">
                              <strong>MARCA:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_marca
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>MODELO:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_modelo
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>COR:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_cor
                              }}</span>
                            </p>
                            <div class="row">
                              <div class="col-5">
                                <p class="card-text-pdf">
                                  <strong>PLACA:</strong>
                                  <span class="texto_menu_desk_pdf">{{
                                    g_menu_placa
                                  }}</span>
                                </p>
                              </div>
                              <div class="col-7">
                                <p class="card-text-pdf">
                                  <strong>ANO:</strong
                                  ><span class="texto_menu_desk_pdf">{{
                                    g_menu_ano_modelo
                                  }}</span>
                                  /
                                  <span class="texto_menu_desk_pdf">{{
                                    g_menu_ano_fab
                                  }}</span>
                                </p>
                              </div>
                            </div>

                            <p class="card-text-pdf">
                              <strong>CHASSI:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_chassi
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="card card-pdf border-secondary mb-1">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-receipt-cutoff ico-pdf"></i>
                            RESUMO DA COMPRA
                          </div>
                          <div class="card-body text-secondary">
                            <p class="card-text-pdf">
                              <strong>VALOR SUGERIDO:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_val_sugerido
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>DESCONTO:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_val_desconto
                              }}</span>
                            </p>

                            <p class="card-text-pdf">
                              <strong>TOTAL VEÍCULO:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                Valor_Total_Venda
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>TOTAL VU:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                this.currency(this.valor_avaliacao)
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>FINANCIAMENTO:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                Valor_Financiado
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="card card-pdf border-secondary mb-1">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-chat-square-text-fill ico-pdf"></i>
                            OBSERVAÇÕES
                          </div>
                          <div class="card-body text-secondary">
                            <p class="card-text-pdf">
                              <span class="texto_menu_desk_pdf">{{
                                info_adicionais
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Opções de Financiamento-->

                    <div class="row g-2">
                      <div class="col-12">
                        <div class="card card-pdf-1 border-secondary">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-wallet2 ico-pdf"></i>ENTRADAS
                          </div>
                          <div class="row p-1">
                            <div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ Entrada_Total_1 }}</strong>
                              </div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ Entrada_Total_2 }}</strong>
                              </div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ Entrada_Total_3 }}</strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="card card-pdf-1 border-secondary">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-calendar-check ico-pdf"></i>
                            {{ parcela_1_resumo }} Meses
                          </div>
                          <div class="row p-1">
                            <div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_1_1 }}</strong>
                              </div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_2_1 }}</strong>
                              </div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_3_1 }}</strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="card card-pdf-1 border-secondary">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-calendar-check ico-pdf"></i>
                            {{ parcela_2_resumo }} Meses
                          </div>
                          <div class="row p-1">
                            <div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_1_2 }}</strong>
                              </div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_2_2 }}</strong>
                              </div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_3_2 }}</strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="card card-pdf-1 border-secondary">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-calendar-check ico-pdf"></i>
                            {{ parcela_3_resumo }} Meses
                          </div>
                          <div class="row p-1">
                            <div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_1_3 }}</strong>
                              </div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_2_3 }}</strong>
                              </div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_3_3 }}</strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!--Mensagem Rodapé-->
                    <div class="row g-2 p-2">
                      <div class="col-md-12 col-lg-12 col-xl-12">
                        <p
                          class="card-text-2"
                          v-for="(text, index) in disclaimer_texts"
                          :key="index"
                        >
                          {{ text }}
                        </p>
                      </div>
                    </div>

                    <div class="row g-2 p-2 mt-1">
                      <div class="col-12 rf_assinatura">
                        <span class="texto_menu_desk_pdf"
                          ><strong>Gerente:</strong> {{ g_menu_gerente }}</span
                        >
                      </div>
                      <div class="col-12 rf_assinatura">
                        <span class="texto_menu_desk_pdf"
                          ><strong>Cliente:</strong> {{ g_menu_cliente }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-toggle="modal"
            >
              Fechar
            </button>
            <button
              class="btn btn-secondary"
              :disabled="btn_gerar_menu"
              @click="generatePdf"
            >
              IMPRIMIR
            </button>
          </div>
        </div>
        <div class="d-none d-md-block">
          <div class="modal-dialog modal-fullscreen rf_modal font-pdf-menu">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div class="container_pdf" ref="contentToPrint">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6 col-lg-6 col-xl-6">
                        <a class="navbar-brand logo">
                          <img
                            src="../../assets/logo.png"
                            alt="Bootstrap"
                            class="logo-pdf"
                          />
                        </a>
                      </div>
                      <div
                        class="col-md-6 col-lg-6 col-xl-6"
                        style="text-align: right"
                      >
                        <a class="navbar-brand logo_cliente">
                          <img
                            src="../../assets/logo.png"
                            alt="Bootstrap"
                            class="logo-pdf"
                          />
                        </a>
                      </div>
                    </div>
                    <!-- Primeiro Bloco-->
                    <div class="row g-2">
                      <div class="col-md-6 col-lg-4 col-xl-4">
                        <div class="card card-pdf border-secondary mb-2">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-person-bounding-box ico-pdf"></i>
                            Informações do Cliente
                          </div>
                          <div class="card-body">
                            <p class="card-text-pdf">
                              <strong>CLIENTE:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_cliente
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>CPF/CNPJ:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_cpfCnpj
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>FONE:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_fone
                              }}</span>
                              /
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_fone2
                              }}</span>
                            </p>

                            <p class="card-text-pdf">
                              <strong>EMAIL:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_email
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-3 col-xl-3">
                        <div class="card card-pdf border-secondary mb-2">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-file-earmark-text ico-pdf"></i>
                            Informações do Atendimento
                          </div>
                          <div class="card-body">
                            <p class="card-text-pdf">
                              <strong>GERENTE:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_gerente
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>VENDEDOR:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_vendedor
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>NEGOCIAÇÃO:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_negociacao
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>DATA:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_data_negociacao
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-5 col-xl-5">
                        <div class="card card-pdf border-secondary mb-2">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-car-front-fill ico-pdf"></i>
                            Veículo de Troca
                          </div>
                          <div>
                            <ul class="list-group">
                              <li
                                v-for="item in veiculos_avaliados"
                                :key="item.id"
                                class="list-group-item texto_menu_desk_pdf"
                              >
                                <div class="row">
                                  <div class="col">
                                    <span class="header_pdf_txt">Marca</span>
                                  </div>
                                  <div class="col">
                                    <span class="header_pdf_txt">Modelo</span>
                                  </div>
                                  <div class="col">
                                    <span class="header_pdf_txt">Placa</span>
                                  </div>
                                  <div class="col">
                                    <span class="header_pdf_txt">Avaliado</span>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col">
                                    <span class="texto_menu_desk_pdf">{{
                                      item.marca
                                    }}</span>
                                  </div>
                                  <div class="col">
                                    <span class="texto_menu_desk_pdf">{{
                                      item.modelo
                                    }}</span>
                                  </div>
                                  <div class="col">
                                    <span class="texto_menu_desk_pdf">{{
                                      item.placa
                                    }}</span>
                                  </div>
                                  <div class="col">
                                    <span class="texto_menu_desk_pdf">{{
                                      item.preco_avaliado
                                    }}</span>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4 col-xl-4">
                        <div class="card card-pdf border-secondary mb-2">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-card-checklist ico-pdf"></i>
                            INFORMAÇÕES DO VEÍCULO
                          </div>
                          <div class="card-body text-secondary">
                            <p class="card-text-pdf">
                              <strong>MARCA:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_marca
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>MODELO:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_modelo
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>COR:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_cor
                              }}</span>
                            </p>
                            <div class="row">
                              <div class="col-5">
                                <p class="card-text-pdf">
                                  <strong>PLACA:</strong>
                                  <span class="texto_menu_desk_pdf">{{
                                    g_menu_placa
                                  }}</span>
                                </p>
                              </div>
                              <div class="col-7">
                                <p class="card-text-pdf">
                                  <strong>ANO:</strong
                                  ><span class="texto_menu_desk_pdf">{{
                                    g_menu_ano_modelo
                                  }}</span>
                                  /
                                  <span class="texto_menu_desk_pdf">{{
                                    g_menu_ano_fab
                                  }}</span>
                                </p>
                              </div>
                            </div>

                            <p class="card-text-pdf">
                              <strong>CHASSI:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_chassi
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4 col-xl-4">
                        <div class="card card-pdf border-secondary mb-2">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-receipt-cutoff ico-pdf"></i>
                            RESUMO DA COMPRA
                          </div>
                          <div class="card-body text-secondary">
                            <p class="card-text-pdf">
                              <strong>VALOR SUGERIDO:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_val_sugerido
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>DESCONTO:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_val_desconto
                              }}</span>
                            </p>

                            <p class="card-text-pdf">
                              <strong>TOTAL VEÍCULO:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                Valor_Total_Venda
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>TOTAL VU:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                this.currency(this.valor_avaliacao)
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>FINANCIAMENTO:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                Valor_Financiado
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4 col-xl-4">
                        <div class="card card-pdf border-secondary mb-2">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-chat-square-text-fill ico-pdf"></i>
                            OBSERVAÇÕES
                          </div>
                          <div class="card-body text-secondary">
                            <p class="card-text-pdf">
                              <span class="texto_menu_desk_pdf">{{
                                info_adicionais
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <!-- Opções de Financiamento-->

                      <div class="col-md-6 col-lg-3 col-xl-3">
                        <div class="card card-pdf-1 border-secondary mb-1">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-wallet2 ico-pdf"></i>ENTRADAS
                          </div>

                          <div class="row p-1">
                            <div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ Entrada_Total_1 }}</strong>
                              </div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ Entrada_Total_2 }}</strong>
                              </div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ Entrada_Total_3 }}</strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-3 col-xl-3">
                        <div class="card card-pdf-1 border-secondary">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-calendar-check ico-pdf"></i>
                            {{ parcela_1_resumo }} Meses
                          </div>

                          <div class="row p-1">
                            <div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_1_1 }}</strong>
                              </div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_2_1 }}</strong>
                              </div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_3_1 }}</strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-3 col-xl-3">
                        <div class="card card-pdf-1 border-secondary">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-calendar-check ico-pdf"></i>
                            {{ parcela_2_resumo }} Meses
                          </div>

                          <div class="row p-1">
                            <div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_1_2 }}</strong>
                              </div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_2_2 }}</strong>
                              </div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_3_2 }}</strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-3 col-xl-3">
                        <div class="card card-pdf-1 border-secondary">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-calendar-check ico-pdf"></i>
                            {{ parcela_3_resumo }} Meses
                          </div>

                          <div class="row p-1">
                            <div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_1_3 }}</strong>
                              </div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_2_3 }}</strong>
                              </div>
                              <div class="col texto_menu_desk_pdf-2">
                                <strong> {{ parcela_3_3 }}</strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!--Mensagem Rodapé-->
                    <div class="row g-2 p-2">
                      <div class="col-md-12 col-lg-12 col-xl-12">
                        <p
                          class="card-text-2"
                          v-for="(text, index) in disclaimer_texts"
                          :key="index"
                        >
                          {{ text }}
                        </p>
                      </div>
                    </div>

                    <div class="row g-2 p-2 mt-0">
                      <!-- Coluna 1: Gerente -->
                      <div class="col-md-6 col-lg-6 col-xl-6">
                        <!-- Linha de assinatura (borda superior) -->
                        <div class="linha_assinatura mb-2"></div>
                        <!-- Texto centralizado -->
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <span class="texto_menu_desk_pdf"
                            ><strong>Gerente:</strong>
                            {{ g_menu_gerente }}</span
                          >
                        </div>
                      </div>

                      <!-- Coluna 2: Cliente -->
                      <div class="col-md-6 col-lg-6 col-xl-6">
                        <!-- Linha de assinatura (borda superior) -->
                        <div class="linha_assinatura mb-2"></div>
                        <!-- Texto centralizado -->
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <span class="texto_menu_desk_pdf"
                            ><strong>Cliente:</strong>
                            {{ g_menu_cliente }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-xl-6">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-toggle="modal"
                      >
                        Fechar
                      </button>
                    </div>
                    <div class="col-md-6 col-lg-6 col-xl-6">
                      <button
                        class="btn btn-secondary"
                        :disabled="btn_gerar_menu"
                        @click="generatePdf"
                      >
                        IMPRIMIR
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Modal Gerar Menu A vista-->
    <div class="avoid-break">
      <div
        class="modal fade"
        id="ModalGerarMenuVista"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel2"
        tabindex="-1"
      >
        <div class="d-none d-md-block">
          <div class="modal-dialog modal-fullscreen rf_modal font-pdf-menu">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div class="container_pdf" ref="contentToPrint2">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-6">
                        <a class="navbar-brand logo">
                          <img
                            src="../../assets/logo.png"
                            alt="Bootstrap"
                            class="logo-pdf"
                          />
                        </a>
                      </div>
                      <div class="col-6" style="text-align: right">
                        <a class="navbar-brand logo_cliente">
                          <img
                            src="../../assets/logo.png"
                            alt="Bootstrap"
                            class="logo-pdf"
                          />
                        </a>
                      </div>
                    </div>
                    <!-- Primeiro Bloco-->
                    <div class="row g-2">
                      <div class="col-md-6 col-lg-4 col-xl-4">
                        <div class="card card-pdf border-secondary mb-2">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-person-bounding-box ico-pdf"></i>
                            Informações do Cliente
                          </div>
                          <div class="card-body">
                            <p class="card-text-pdf">
                              <strong>CLIENTE:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_cliente
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>CPF/CNPJ:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_cpfCnpj
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>FONE:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_fone
                              }}</span>
                              /
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_fone2
                              }}</span>
                            </p>

                            <p class="card-text-pdf">
                              <strong>EMAIL:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_email
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-3 col-xl-3">
                        <div class="card card-pdf border-secondary mb-2">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-file-earmark-text ico-pdf"></i>
                            Informações do Atendimento
                          </div>
                          <div class="card-body">
                            <p class="card-text-pdf">
                              <strong>GERENTE:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_gerente
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>VENDEDOR:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_vendedor
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>NEGOCIAÇÃO:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_negociacao
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>DATA:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_data_negociacao
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-5 col-xl-5">
                        <div class="card card-pdf border-secondary mb-2">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-car-front-fill ico-pdf"></i>
                            Veículo de Troca
                          </div>
                          <div>
                            <ul class="list-group">
                              <li
                                v-for="item in veiculos_avaliados"
                                :key="item.id"
                                class="list-group-item texto_menu_desk_pdf"
                              >
                                <div class="row">
                                  <div class="col">
                                    <span class="header_pdf_txt">Marca</span>
                                  </div>
                                  <div class="col">
                                    <span class="header_pdf_txt">Modelo</span>
                                  </div>
                                  <div class="col">
                                    <span class="header_pdf_txt">Placa</span>
                                  </div>
                                  <div class="col">
                                    <span class="header_pdf_txt">Avaliado</span>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col">
                                    <span class="texto_menu_desk_pdf">{{
                                      item.marca
                                    }}</span>
                                  </div>
                                  <div class="col">
                                    <span class="texto_menu_desk_pdf">{{
                                      item.modelo
                                    }}</span>
                                  </div>
                                  <div class="col">
                                    <span class="texto_menu_desk_pdf">{{
                                      item.placa
                                    }}</span>
                                  </div>
                                  <div class="col">
                                    <span class="texto_menu_desk_pdf">{{
                                      item.preco_avaliado
                                    }}</span>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- Segundo Bloco-->

                      <div class="col-md-6 col-lg-4 col-xl-4">
                        <div class="card card-pdf border-secondary">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-card-checklist ico-pdf"></i>
                            INFORMAÇÕES DO VEÍCULO
                          </div>
                          <div class="card-body text-secondary">
                            <p class="card-text-pdf">
                              <strong>MARCA:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_marca
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>MODELO:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                g_menu_modelo
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>COR:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_cor
                              }}</span>
                            </p>
                            <div class="row">
                              <div class="col-5">
                                <p class="card-text-pdf">
                                  <strong>PLACA:</strong>
                                  <span class="texto_menu_desk_pdf">{{
                                    g_menu_placa
                                  }}</span>
                                </p>
                              </div>
                              <div class="col-7">
                                <p class="card-text-pdf">
                                  <strong>ANO:</strong
                                  ><span class="texto_menu_desk_pdf">{{
                                    g_menu_ano_modelo
                                  }}</span>
                                  /
                                  <span class="texto_menu_desk_pdf">{{
                                    g_menu_ano_fab
                                  }}</span>
                                </p>
                              </div>
                            </div>

                            <p class="card-text-pdf">
                              <strong>CHASSI:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_chassi
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4 col-xl-4">
                        <div class="card card-pdf border-secondary mb-2">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-receipt-cutoff ico-pdf"></i>
                            RESUMO DA COMPRA
                          </div>
                          <div class="card-body text-secondary">
                            <p class="card-text-pdf">
                              <strong>VALOR SUGERIDO:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_val_sugerido
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>DESCONTO:</strong
                              ><span class="texto_menu_desk_pdf">{{
                                g_menu_val_desconto
                              }}</span>
                            </p>

                            <p class="card-text-pdf">
                              <strong>TOTAL VEÍCULO:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                Valor_Total_Venda
                              }}</span>
                            </p>
                            <p class="card-text-pdf">
                              <strong>TOTAL VU:</strong>
                              <span class="texto_menu_desk_pdf">{{
                                this.currency(this.valor_avaliacao)
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4 col-xl-4">
                        <div class="card card-pdf border-secondary mb-2">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-chat-square-text-fill ico-pdf"></i>
                            OBSERVAÇÕES
                          </div>
                          <div class="card-body text-secondary">
                            <p class="card-text-pdf">
                              <span class="texto_menu_desk_pdf">{{
                                info_adicionais
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="card card-pdf-1 border-secondary mb-2">
                          <div class="card-header header_pdf_txt">
                            <i class="bi bi-wallet2 ico-pdf"></i>Composição do
                            Pagamento
                          </div>
                          <div class="card-body p-0">
                            <!-- Itens (uma linha só, cada item é uma coluna) -->
                            <div class="pagamento-grid">
                              <div
                                v-for="item in itens_pagamentos"
                                :key="item.id"
                                class="pagamento-item"
                              >
                                <div
                                  class="texto_menu_desk_pdf"
                                  style="font-weight: bold"
                                >
                                  {{ currency(item.valor_parcela) }}
                                </div>
                                <div
                                  class="texto_menu_desk_pdf"
                                  style="font-size: 10px"
                                >
                                  {{ item.tipo_pagamento_descricao }}
                                </div>
                                <div
                                  class="texto_menu_desk_pdf"
                                  style="font-size: 10px"
                                >
                                  {{ item.qtd_parcela }}x
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!--Mensagem Rodapé-->
                    <div class="row g-2 p-2">
                      <div class="col-md-12 col-lg-12 col-xl-12">
                        <p
                          class="card-text-2"
                          v-for="(text, index) in disclaimer_texts"
                          :key="index"
                        >
                          {{ text }}
                        </p>
                      </div>
                    </div>
                    <div class="row g-2 p-2 mt-0">
                      <!-- Coluna 1: Gerente -->
                      <div class="col-md-6 col-lg-6 col-xl-6">
                        <!-- Linha de assinatura (borda superior) -->
                        <div class="linha_assinatura mb-2"></div>
                        <!-- Texto centralizado -->
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <span class="texto_menu_desk_pdf"
                            ><strong>Gerente:</strong>
                            {{ g_menu_gerente }}</span
                          >
                        </div>
                      </div>

                      <!-- Coluna 2: Cliente -->
                      <div class="col-md-6 col-lg-6 col-xl-6">
                        <!-- Linha de assinatura (borda superior) -->
                        <div class="linha_assinatura mb-2"></div>
                        <!-- Texto centralizado -->
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <span class="texto_menu_desk_pdf"
                            ><strong>Cliente:</strong>
                            {{ g_menu_cliente }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-xl-6">
                      <button
                        type="button"
                        class="btn btn-modal"
                        data-bs-toggle="modal"
                      >
                        Fechar
                      </button>
                    </div>
                    <div class="col-md-6 col-lg-6 col-xl-6">
                      <button class="btn btn-modal" @click="generatePdfAvista">
                        IMPRIMIR
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <RodapeVue />
  </div>
</template>

<script>
import SidebarVue from "../../components/menu/Sidebar.vue";
import axios from "axios";
//import DataService from "../../services/DataService";
import userService from "../../services/user.service";
import Pagination from "../../components/Pagination.vue";
import Message from "../../components/modal/Message.vue";
import MessageAtualizar from "../../components/modal/MessageAtualizar.vue";
import { VueMaskDirective } from "vue-the-mask";
import html2pdf from "html2pdf.js";
import router from "../../router";
import TokenService from "../../services/token.service";
import jwt_decode from "jwt-decode";
import RodapeVue from "../../components/menu/Rodape.vue";
import NavgatorDk from "../../components/menu/NavgatorDk.vue";
import Aviso from "../../components/modal/Modal.vue";
import { Modal } from "bootstrap";

export default {
  name: "Usuários",

  components: {
    SidebarVue,
    NavgatorDk,
    Pagination,
    Message,
    MessageAtualizar,
    Aviso,
    RodapeVue
  },
  directives: {
    mask: VueMaskDirective
  },
  data() {
    return {
      isLoading: false,
      selectedFilter: "Todos",

      startDate: "",
      endDate: "",
      adicional: "",
      just_venda_perdida: "",
      message: "",
      dialog: "",
      abrir_modal: false,
      abrir_modal_atualizar: false,
      info_adicionais: "",

      linhaSelecionada: null,
      linhaSelecionada2: null,
      linhaSelecionada3: null,

      css: null,
      css1: null,
      css2: null,
      css3: null,
      css4: null,
      css5: null,
      btn_avaliacao: true,

      //Tabela Proposta
      id_proposta: "", // Armazena o id da Proposta
      propostas_at: [],
      itens_veiculo: [],
      veiculos_avaliados: [],
      estoque_veiculo: [],
      acessorios: [],
      cortesias: [],
      itens_acessorios: [],
      itens_cortesias: [],
      marcas_estoque: [],
      modelos_estoque: [],
      cores_estoque: [],
      familia: [],
      desconto: "",
      acrescimo: "",
      searchTitle: "",
      searchChassi: "",
      searchPlaca: "",
      searchValIni: "",
      searchValFin: "",
      searchMarca: "",
      searchAnoMod: "",
      searchAnoFab: "",
      searchCor: "",
      tipoVeiculo: "",

      searchCodigo: "",
      searchDescricao: "",
      inserir_veiculo: true,

      item_p_avaliacao: "",
      valor_p_avaliacao: "",

      searchProposta: "",
      check_midia: "",

      tipo: "",

      //Campo do Financiamento
      itens_financiamento: [
        { value: 12 },
        { value: 18 },
        { value: 24 },
        { value: 36 },
        { value: 48 },
        { value: 60 }
      ],

      razao_financiamento: "",
      plano: "",

      orderBy: 0,
      orderBy_2: 0,
      orderBy_3: 0,
      sortBy: "",
      sortBy_2: "",
      sortBy_3: "",
      sortDesc: 0,
      sortDesc_2: 0,
      sortDesc_3: 0,

      //Paginação Entrada 1
      page_1: 1,
      totalPages_1: 0,
      totalItems_1: 0,

      pageSize_1: 5,
      //////////////////////
      //Paginação Entrada 2
      page_2: 1,
      totalPages_2: 0,
      totalItems_2: 0,

      pageSize_2: 5,
      //////////////////////

      //Paginação Entrada 3
      page_3: 1,
      totalPages_3: 0,
      totalItems_3: 0,

      pageSize_3: 5,
      //////////////////////

      //Paginação Tabela de Proposta
      page_4: 1,
      totalPages_4: 0,
      totalItems_4: 0,

      pageSize_4: 100,
      //////////////////////

      pageEstoque: 1,
      totalPagesEstoque: 0,
      totalItemsEstoque: 0,

      pageSizeEstoque: 50,

      pageVeiculo: 1,
      pageSizeVeiculo: 100000000,
      habilitar_inserir_pagamento: false,
      habilitar_gerar_menu_avista: true,

      //Campos ref ao cliente
      cliente_id: "",
      cpfCnpj: "",
      cliente: "",
      dataNascimento: "",
      clientes: "",
      email: "",
      endereco: "",
      complemento: "",
      uf: "",
      cidade: "",
      bairro: "",
      cep: "",
      tel: "",
      cel: "",
      obs: "",
      initialCpfCnpj: "",
      clienteFoundByCpfCnpjModal: null,
      cliente_update_disabled: false,
      modal_cliente_id: "",
      modal_cliente: "",
      modal_cpfCnpj: "",
      modal_dataNascimento: "",
      modal_email: "",
      modal_endereco: "",
      modal_complemento: "",
      modal_uf: "",
      modal_cidade: "",
      modal_bairro: "",
      modal_cep: "",
      modal_tel: "",
      modal_cel: "",
      model: null,
      model4: null,

      modelo: [],
      marca: [],

      search: null,

      midia: [],
      midia_informada: "",

      midia_id: "",
      page_midia: 1,

      pageSize_midia: 1000,

      page_acc: 1,

      totalItems_acc: 0,

      pageSize_acc: 1000,

      //Campos Veículo para troca
      marca_avaliacao: "",
      modelo_avaliacao: "",
      familia_avaliacao: "",

      placa_avaliacao: "",
      placa_av: "",

      valor_av_hst: "",
      kilometragem_av_hst: "",
      valor_av: "",
      valor_quitacao: "",
      kilometragem_av: "",
      anoModelo_av: "",
      cor_av: "",
      obs_av: "",
      valor_avaliacao: "",
      kilometragem: "",
      anoModelo_avaliacao: "",
      anoFabricacao_avaliacao: "",
      dialog_avaliacao: false,
      avaliacoes: "",
      info_avaliacao: "",
      hab_avaliacao: true,
      ativar_placa: false,
      desativar_placa: true,
      cor_avaliacao: "",
      marcaSelecionada: "",
      marcas: [],
      modelos: [],
      id_veiculo: "",
      lastClicked: "",
      placaCorBorda: "",
      marcaCorBorda: "",
      modeloCorBorda: "",
      anoModeloCorBorda: "",
      corCorBorda: "",
      kilometragemCorBorda: "",
      valorAvaliadoCorBorda: "",
      modelo_id: "",

      //Campos Veículo compra
      chassi_proposta: "",
      marca_proposta: "",
      modelo_proposta: "",
      cor_proposta: "",
      anoModelo_proposta: "",
      anoFabricacao_proposta: "",
      combustivel_proposta: "",
      numero_veiculo_proposta: "",
      propostaVeiculo_id: "",
      inserir_acessorios: true,

      venda_Futura: "",
      venda_futura: "",
      empresa: "",
      categoria: "",
      pps_valor: "",
      valor_veiculo: "",
      dias_em_estoque: "",
      placa: "",
      status_veiculo: "",

      //Acessorios
      descricaoAcessorio: "",
      valorAcessorio: "",
      custoAcessorio: "",

      ///Modais

      modal: false,
      modal_estoque: false,
      modal_itens_avaliacao: false,
      modal_itens_acessorios: false,
      modal_ranqueamento: false,

      modal_proposta: false,

      //Campos para calcular as parcelas
      parcela: [],
      parcela_1: 24,
      parcela_2: 36,
      parcela_3: 48,
      entrada_1: "",
      entrada_2: "",
      entrada_3: "",
      entrada_1_original: "",
      entrada_2_original: "",
      entrada_3_original: "",
      id_coluna: "",

      parcelamento_1: [],
      parcelamento_2: [],
      parcelamento_3: [],

      Valor_Entrada_2: "",
      Valor_Entrada_3: "",
      Valor_Financiado_2: "",
      Valor_Financiado_3: "",
      entrada_perc_1_padronizada: "",
      entrada_perc_2_padronizada: "",
      entrada_perc_3_padronizada: "",

      //Campos Filtro Ranqueamento
      filtro_tipo_veiculo: "",
      filtro_tipo_tabela: "SIM",
      filtro_spf: "SIM",

      //Primeira coluna botões
      parcela_1_1: 0.0,
      parcela_2_1: 0.0,
      parcela_3_1: 0.0,
      //Segunda Coluna botões
      parcela_1_2: 0.0,
      parcela_2_2: 0.0,
      parcela_3_2: 0.0,
      //Terceira Coluna botões
      parcela_1_3: 0.0,
      parcela_2_3: 0.0,
      parcela_3_3: 0.0,

      //Resumo
      //Valores do veículo
      Valor_Sugerido: 0.0,
      Valor_Custo_variaveis: 0.0,
      Valor_Itens_Acessorios: 0.0,
      Valor_Total_Venda: 0.0,

      //Valores da Avaliação
      Valor_Avaliado: 0.0,
      Valor_Itens_Avaliacao_db: 0.0,
      Valor_Itens_Avaliacao_cr: 0.0,
      Valor_Avaliacao_Final: 0.0,

      //Resultado Operacional / Gerencial
      Lucro_Bruto: 0.0,
      Lucro_Operacional: 0.0,
      Lucro_liquido: 0.0,
      Valor_Resultado_Financiamento: 0.0,

      //Informações Financiamento
      Valor_Entrada: 0.0,
      Valor_Financiado: 0.0,
      Quantidade_Meses: 0.0,
      Pmt: 0.0,
      pagamento: false,

      //Gráficos Desk Veiculos Novos
      qtd_clientes_novos_n: 0,
      qtd_clientes_retorno_n: 0,
      qtd_vendas_perdidas_n: 0,
      qtd_vendas_realizadas_n: 0,
      qtd_clientes_novos_n_int: 0,
      qtd_clientes_retorno_n_int: 0,
      qtd_vendas_perdidas_n_int: 0,
      qtd_vendas_realizadas_n_int: 0,

      //Gráfico Desk Veículos Usados
      qtd_clientes_novos_u: 0,
      qtd_clientes_retorno_u: 0,
      qtd_vendas_perdidas_u: 0,
      qtd_vendas_realizadas_u: 0,
      qtd_clientes_novos_u_int: 0,
      qtd_clientes_retorno_u_int: 0,
      qtd_vendas_perdidas_u_int: 0,
      qtd_vendas_realizadas_u_int: 0,

      inserir_item_avaliacao: true,
      btn_ranquear: true,
      btn_1: true,

      btn_gerar_menu: true,
      btn_finalizar_venda: true,
      btn_finalizar_venda_vista: true,
      cortesia: "",

      incluir_acessorios: true,

      //Gerar Menu
      //informações cliente
      dados_menu: "",
      g_menu_cliente: "",
      g_menu_cpfCnpj: "",
      g_menu_fone: "",
      g_menu_fone2: "",
      g_menu_email: "",
      //informações proposta
      g_menu_gerente: "",
      g_menu_vendedor: "",
      g_menu_vendedor_id: "",
      g_menu_negociacao: "",
      g_menu_data_negociacao: "",
      //opções de compra
      g_menu_val_sugerido: "",
      g_menu_val_desconto: "",
      g_menu_val_veiculo: "",
      g_menu_total_financiado: "",
      //Dados veiculo compra
      g_menu_marca: "",
      g_menu_modelo: "",
      g_menu_cor: "",
      g_menu_chassi: "",
      g_menu_km: "",
      g_menu_ano_modelo: "",
      g_menu_ano_fab: "",
      g_menu_placa: "",
      //Dados veiculo troca
      g_menu_marca_avaliacao: "",
      g_menu_placa_avaliacao: "",

      g_menu_ano_modelo_avaliacao: "",
      g_menu_valor_avaliado: "",
      g_menu_itens_avaliacao_db: "",
      g_menu_itens_avaliacao_cr: "",
      g_menu_valor_avaliacao_final: "",
      //Acessorios
      g_menu_total_acessorios: "",
      total_vendas_usados: "",
      total_vendas_clientes_novos: "",
      total_vendas_clientes_retorno: "",
      total_vendas_perdidas_usados: "",

      dialog_incluir_acessorios: false,
      message_incluir_acessorios: "",
      msg: "",
      msg_atualizar: "",

      open_proposta: true,
      id_cliente: "",

      Entrada_Total_1: "",
      Entrada_Total_2: "",
      Entrada_Total_3: "",
      Valor_Financiado_1: "",
      Valor_Entrada_1: "",
      handlePageChange: "",
      items: [],

      empresaID: "",
      status_proposta: "",
      data_ini: "",
      data_fim: "",
      entrada_1_perc: "",
      entrada_2_perc: "",
      entrada_3_perc: "",
      valor_sugerido_original: "",
      valor_custo_contabil: "",
      entrada_escolhida: "",
      //Daddos da Proposta
      dados_proposta: "",
      pmtSelected: null,
      selected_familia_veiculo_escolhido: [],
      selected_modelo_veiculo_escolhido: [],
      selected_cor_veiculo_escolhido: [],
      familia_veiculo_escolhido: "",
      modelo_veiculo_escolhido: "",
      cor_veiculo_escolhido: "",

      recepcionista: "",
      vendedor: [],
      vendedor_info: "",
      company_id: "",
      vend_ini: "",
      status_vendedor: "",
      modelo_futuro: [],
      input_cliente: true,
      nomeBorderColor: "",
      emailBorderColor: "",
      telBorderColor: "",
      celBorderColor: "",
      cnpjBorderColor: "",
      dataNascimentoBorderColor: "",
      enderecoBorderColor: "",
      complementoBorderColor: "",
      ufBorderColor: "",
      cidadeBorderColor: "",
      bairroBorderColor: "",
      cepBorderColor: "",
      cidades: [],
      estados: [
        { id: 11, sigla: "RO" },
        { id: 12, sigla: "AC" },
        { id: 13, sigla: "AM" },
        { id: 14, sigla: "RR" },
        { id: 15, sigla: "PA" },
        { id: 16, sigla: "AP" },
        { id: 17, sigla: "TO" },
        { id: 21, sigla: "MA" },
        { id: 22, sigla: "PI" },
        { id: 23, sigla: "CE" },
        { id: 24, sigla: "RN" },
        { id: 25, sigla: "PB" },
        { id: 26, sigla: "PE" },
        { id: 27, sigla: "AL" },
        { id: 28, sigla: "SE" },
        { id: 29, sigla: "BA" },
        { id: 31, sigla: "MG" },
        { id: 32, sigla: "ES" },
        { id: 33, sigla: "RJ" },
        { id: 35, sigla: "SP" },
        { id: 41, sigla: "PR" },
        { id: 42, sigla: "SC" },
        { id: 43, sigla: "RS" },
        { id: 50, sigla: "MS" },
        { id: 51, sigla: "MT" },
        { id: 52, sigla: "GO" },
        { id: 53, sigla: "DF" }
      ],
      troca_vendedor: [],
      justificativa_vendedor: "",
      tipo_vendedor: 2,
      check_vend: true,
      vendedor_troca: "",
      bloquear_entrada: false,
      bloquear_entrada_botoes: false,

      historico_avaliacoes: [],
      modeloSelecionado: "",
      data_av_hst: "",

      //Historico do Cliente
      id_historico_cliente: "",
      nome_historico_cliente: "",
      hist_cliente: [],
      modal_historico_cliente: false,
      showModal: false,
      modalMessage: "",
      info_erros: {},
      //Pagamento a vista
      itens_pagamentos: [],
      venda_vista: false,
      venda_financiamento: true,
      incluir_financiamento: true,
      valor_da_venda: "",
      metodo_pagamento_vista: [],
      met_pagamento_vista: "",
      valor_parcela_vista: "",
      qtd_parcela_vista: "",
      qtd_parcelamento: [
        { value: 1 },
        { value: 2 },
        { value: 3 },
        { value: 4 },
        { value: 5 },
        { value: 6 },
        { value: 7 },
        { value: 8 },
        { value: 9 },
        { value: 10 },
        { value: 11 },
        { value: 12 }
      ],

      id_pagamento: "",
      pagamentoVistaJaChamado: false,
      id_pagamento_desk: "",
      hab_ranquear: true,

      //Mensagens de aviso
      hab_avista: false,
      hab_financiamento: false,
      forma_pagamento: false,
      cliente_pcd: "",
      metodo_pagamento: "",
      mesmo_veiculo: false,
      msg_conteudo: "",
      atendimento_anterior: "",
      previsao_faturamento: "",
      hist_avaliacoes: false,
      hab_hist_avaliacao: true,
      empresa_avaliacao: "",
      selecoesTaxas: {
        tabela1: null,
        tabela2: null,
        tabela3: null
      },
      parcela_1_resumo: "",
      parcela_2_resumo: "",
      parcela_3_resumo: "",
      valorQuitacaoCorBorda: "",
      mensagemErro: "",
      mensagemErro_1: "",
      mensagemErro_2: "",
      mensagemErro_3: "",
      inserir_cortesia: "",
      disclaimer_texts: [],
      codigo_cliente: ""
    };
  },
  watch: {
    tipoVeiculo: function () {
      // Limpar campos de busca ao alterar o tipo de veículo
      this.searchMarca = "";
      this.searchTitle = "";
      this.searchAnoMod = "";
      this.searchAnoFab = "";
      this.searchCor = "";
      this.searchChassi = "";
      this.searchPlaca = "";
    },
    marcaSelecionada: function (novaMarca) {
      const marca = this.marcas.find((m) => m.descricao === novaMarca);
      this.marcaId = marca ? marca.id : null;
    },
    modeloSelecionado: function (novoModelo) {
      const modelo = this.modelos.find((m) => m.descricao === novoModelo);
      this.modeloId = modelo ? modelo.id : null;
    },
    codigo_cliente(novoValor) {
      if (novoValor) {
        this.setDisclaimer();
      }
    }
  },
  // computed: {
  //   tipoPagamento() {
  //     return this.pagamento ? "Pagamento à Vista" : "Financiamento";
  //   },
  // },

  mounted() {
    /**Ao abrir a tela de proposta chamar o método habilitar_proposta ele é responsável por startar o atendimento */
    this.getToken();
    this.habilitar_proposta();
    this.retrieveMidia();
    this.retrieveTipoPagamento();
    this.buscar_marcas();
    //this.setDisclaimer();
  },
  methods: {
    setDisclaimer() {
      switch (this.codigo_cliente) {
        case "grupoRioTokio":
          this.disclaimer_texts = [
            "* Fica o cliente ciente de que a compra e venda em questão está condicionada à disponibilidade do veículo pela fábrica e sujeita a reajuste no preço aqui pactuado, que ocorrendo será informado ao cliente antes do faturamento do veículo, podendo haver desistência em caso de não concordância, com devolução do sinal dado como princípio de pagamento.",

            "* A concessão do financiamento está condicionada à análise de crédito por parte da instituição financeira / O pagamento do IPVA do veículo desta proposta é de inteira responsabilidade do cliente / O veículo usado da troca deverá ser entregue nas mesmas condições descritas na avaliação em anexo.",

            "* Declaro-me ciente e informado de que meus dados pessoais serão objeto de atividades de tratamento pelo presente controlador e demais empresas de seu grupo econômico e parceiros comerciais aplicáveis à presente venda, inclusive inseridos em sistemas informatizados, com a finalidade de possibilitar o controle, gestão e cumprimento dos termos e regras estipulados no presente instrumento, bem como para o cumprimento de obrigações legais e regulamentares vigentes. Declaro-me ciente e informado de que meus dados poderão ser utilizados para ações de marketing, sendo-me facultado a qualquer tempo opor-me a tal operação pelos canais de contato do presente controlador destinados ao exercício dos direitos do titular."
          ];
          break;

        case "grupoBeni":
          this.disclaimer_texts = [
            "* O preço sugerido é válido enquanto durarem os veículos em estoque.",
            "* Despesa Operacional para preparação do veículo, é proibido condicionar desconto de bem à aquisição de seguro."
          ];
          break;

        default:
          this.disclaimer_texts = [
            "* O preço sugerido é válido enquanto durarem os veículos em estoque.",
            "* Despesa Operacional para preparação do veículo, é proibido condicionar desconto de bem à aquisição de seguro."
          ];
      }
    },
    async encontra_usuario(id) {
      try {
        if (!id) {
          return "N/A";
        }
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}users/${id}`,
          {
            params: {
              id: id
            }
          }
        );
        console.log("Dados do usuario", response.data.username);
        return response.data.username;
      } catch (error) {
        console.log(error);
      }
    },
    exibirMensagemErro(mensagem) {
      // Exibe o modal com a mensagem de erro
      this.abrir_modal = true;
      this.msg = mensagem;

      // Fecha o modal automaticamente após 3 segundos
      setTimeout(() => {
        this.abrir_modal = false;
      }, 5000); // Tempo ajustável em milissegundos
    },

    handleRanqueamento(index) {
      // Define as entradas principais e os campos percentuais correspondentes
      const entradasKeys = [`entrada_1`, `entrada_2`, `entrada_3`];
      const entradasNaoPreenchidas = [];
      console.log("Entradas", entradasKeys);
      // Verifica cada entrada principal
      entradasKeys.forEach((key, idx) => {
        const entradaValue = this[key];
        if (!entradaValue || entradaValue.trim() === "") {
          this[key] = "0.00"; // Define o valor como "0.00" para campos vazios
          entradasNaoPreenchidas.push(idx + 1); // Armazena o índice das entradas não preenchidas
        }
      });

      // Calcula os campos percentuais correspondentes
      this.calcular_real_1();
      this.calcular_real_2();
      this.calcular_real_3();

      // Exibe mensagem de erro se houver entradas que foram preenchidas automaticamente
      if (entradasNaoPreenchidas.length > 0) {
        this.exibirMensagemErro(
          `Os campos de Entrada: ${entradasNaoPreenchidas.join(
            ", "
          )} foram preenchidos automaticamente com "0.00".`
        );
        return; // Interrompe o processamento
      }

      // Caso todas estejam preenchidas, chama o método de ranqueamento correspondente
      this[`ranqueamento_${index}`]();
      this.abrirModalRanqueamento();
      this.id_coluna = index;
      console.log("ID coluna no handler", this.id_coluna);
    },
    mostrar_historico() {
      this.hist_avaliacoes = true;
    },
    // Função para abrir o modal manualmente
    abrirModalRanqueamento() {
      const modalElement = document.getElementById("ModalRanqueamento");
      const modalInstance = new Modal(modalElement); // Use o Modal diretamente
      modalInstance.show();
    },

    /**Função 0001 */
    getToken() {
      const accessToken = TokenService.getLocalAccessToken();
      TokenService.getLocalRefreshToken();
      const user_log = TokenService.getUser();
      const decodedToken = jwt_decode(accessToken);
      this.company_id = decodedToken.company;
      this.user_log = user_log.id;
      this.codigo_cliente = decodedToken.codigo_cliente;
      console.log(
        "Função inicial onde armazeno os seguintes dados -------------- 0001 "
      );
      console.log("usuário : ", user_log.id);
      console.log("Token de Acesso : ", decodedToken);
      console.log("Empresa Logada :", this.company_id);
      console.log("Slug", this.codigo_cliente);
    },
    /**Função 0002 */
    async habilitar_proposta() {
      const propostaId = this.$route.params.id;
      try {
        const dados_proposta = await userService.getPropostaId(propostaId);
        this.dados_proposta = dados_proposta.data;
        console.log("Dados obitido da proposta ----------------- 0002");
        console.log("Proposta", dados_proposta.data);
        const gerente_id = dados_proposta.data.gerente_id;

        if (gerente_id == null) {
          console.log("não existe gerente para essa proposta");
          this.inserir_gerente(dados_proposta.data.id);
        }

        const nome_vendedor = await this.encontra_usuario(
          this.dados_proposta.vendedor_id
        );
        const nome_recepcionista = await this.encontra_usuario(
          this.dados_proposta.user_id
        );

        /**Bloco de dados com informações do cliente */
        const dados_cliente = {
          id_cliente: this.dados_proposta["cliente_id"],
          nome: this.dados_proposta.clientes["nome"],
          cpfCnpj: this.dados_proposta.clientes["cpfCnpj"],
          dataNascimento: this.formatarData(
            this.dados_proposta.clientes["nascimento"]
          ),
          email: this.dados_proposta.clientes["email"],
          endereco: this.dados_proposta.clientes["endereco"],
          complemento: this.dados_proposta.clientes["complemento"],
          uf: this.dados_proposta.clientes["uf"],
          cidade: this.dados_proposta.clientes["cidade"],
          bairro: this.dados_proposta.clientes["bairro"],
          cep: this.dados_proposta.clientes["cep"],
          tel: this.dados_proposta.clientes["tel"],
          cel: this.dados_proposta.clientes["cel"],
          midia: this.dados_proposta.midias["descricao"],
          cliente_pcd: this.dados_proposta["cliente_pcd"] == 1 ? "Sim" : "Não"
        };
        this.id_cliente = dados_cliente.id_cliente;
        //Alterações Histórico do cliente
        this.id_historico_cliente = dados_cliente.id_cliente;
        this.nome_historico_cliente = dados_cliente.nome;
        //*** */
        this.cliente = dados_cliente.nome;
        this.cpfCnpj = dados_cliente.cpfCnpj;
        if (this.cpfCnpj)
          this.initialCpfCnpj = this.cpfCnpj.replace(/[^0-9]/g, "");
        this.dataNascimento = this.formatarData(dados_cliente.dataNascimento);
        this.email = dados_cliente.email;
        this.endereco = dados_cliente.endereco;
        this.complemento = dados_cliente.complemento;
        this.uf = dados_cliente.uf;
        this.cidade = dados_cliente.cidade;
        this.bairro = dados_cliente.bairro;
        this.cep = dados_cliente.cep;
        this.tel = dados_cliente.tel;
        this.cel = dados_cliente.cel;
        this.midia_informada = dados_cliente.midia;
        this.cliente_pcd = dados_cliente.cliente_pcd;
        /** */

        /**Bloco de dados com informações da proposta */
        const info_proposta = {
          id_proposta: this.dados_proposta["id"],
          empresaID: this.dados_proposta["empresa_id"],
          info_adicionais: this.dados_proposta["obs"],
          status_proposta: this.dados_proposta["status_proposta"],
          recepcionista: nome_recepcionista,
          vendedor_info: nome_vendedor
        };
        this.id_proposta = info_proposta.id_proposta;
        this.empresaID = info_proposta.empresaID;
        this.info_adicionais = info_proposta.info_adicionais;
        this.status_proposta = info_proposta.status_proposta;
        this.recepcionista = info_proposta.recepcionista;
        this.vendedor_info = info_proposta.vendedor_info;
        /** */

        /**Bloco de dados com informações do resumo da proposta */
        const resumo_proposta = {
          adicional: this.dados_proposta["adicional"],
          desconto: this.dados_proposta["desconto"],
          acessorios: this.dados_proposta["acessorios"],
          impostos: this.dados_proposta["impostos"],
          cortesia: this.dados_proposta["cortesia"],
          custos_variaveis: this.dados_proposta["custos_variaveis"],
          val_sugerido_venda: this.dados_proposta["val_sugerido_venda"]
        };

        this.adicional = this.currency(resumo_proposta.adicional);
        this.desconto = this.currency(resumo_proposta.desconto);
        this.Valor_Total_Venda = this.currency(
          resumo_proposta.val_sugerido_venda
        );
        if (resumo_proposta.val_sugerido_venda != null) {
          this.bloquear_entrada = false;
          this.bloquear_entrada_botoes = false;
        } else {
          this.bloquear_entrada = true;
          this.bloquear_entrada_botoes = true;
        }

        //Dados do Cliente

        if (this.dados_proposta.status_proposta == "Aguardando Atendimento") {
          this.alterar_status_proposta(propostaId);
        }

        //Dados do Veículo Usado
        if (this.dados_proposta.veiculoUsado_id != null) {
          this.marca_avaliacao =
            this.dados_proposta.veiculos_usados.modeloVeiculo.familiaVeiculo.marcaVeiculo.descricao;
          this.modelo_avaliacao =
            this.dados_proposta.veiculos_usados.modeloVeiculo.descricao;
          this.familia_avaliacao =
            this.dados_proposta.veiculos_usados.modeloVeiculo.familiaVeiculo.descricao;
          this.placa_avaliacao = this.dados_proposta.veiculos_usados.placa;
          this.kilometragem = this.numberToReal(
            this.dados_proposta.veiculos_usados.kilometragem
          );
          this.anoFabricacao_avaliacao =
            this.dados_proposta.veiculos_usados.anoFabricacao;
          this.anoModelo_avaliacao =
            this.dados_proposta.veiculos_usados.anoModelo;
          //this.verificar_avaliacao();
          console.log(
            "Chamar Avaliação -------------------------------------------------- 0026"
          );

          if (this.dados_proposta.avaliacaoVeiculo_id != null) {
            // this.valor_avaliacao = this.currency(
            //   this.dados_proposta.avaliacoes_veiculo.precoAvaliacao
            // );
            this.retrieveItensVeiculo();
            this.inserir_item_avaliacao = false;
            this.btn_avaliacao = false;
            this.inserir_veiculo = false;

            console.log(
              "Se ja tiver uma avaliação criada com valor é mostrado aqui! ------- 0027"
            );
            console.log(
              "Valor da Avaliação - " + this.valor_avaliacao + " ------- 0028"
            );
            console.log(
              "Em seguida é chamado o método que busca os itens de avaliação caso exista, habilita o botão inserir itens de avaliação e inserir veiculo ------- 0029"
            );
          } else {
            this.inserir_veiculo = true; // Bloqueia a inserção de veiculo para compra até preencher a avaliação
            //this.valor_avaliacao = 0;
            this.btn_avaliacao = false;
            console.log(
              "Bloqueia a inserção de veiculo para compra até preencher a avaliação ----- 0030"
            );
          }
        } else {
          this.inserir_veiculo = false;
          this.inserir_item_avaliacao = true;
          this.btn_avaliacao = true;
          this.verificar_avaliacao_id_proposta();
          console.log("Não existe veículo para avaliação ---- 0031");
        }

        // //Dados do Veículo para Compra
        if (
          this.dados_proposta.propostaVeiculo_id != null &&
          this.dados_proposta.proposta_veiculo.status_veiculo == 1
        ) {
          this.chassi_proposta = this.dados_proposta.proposta_veiculo.chassis;
          this.marca_proposta = this.dados_proposta.proposta_veiculo.marca;
          this.modelo_proposta =
            this.dados_proposta.proposta_veiculo.modelo_veiculo;
          this.cor_proposta = this.dados_proposta.proposta_veiculo.cor;
          this.anoModelo_proposta =
            this.dados_proposta.proposta_veiculo.ano_modelo;
          this.anoFabricacao_proposta =
            this.dados_proposta.proposta_veiculo.ano_fabricacao;
          this.combustivel_proposta =
            this.dados_proposta.proposta_veiculo.combustivel;
          ///Alteração na linha de baixo dia 10/05/2023
          this.Valor_Sugerido = this.currency(
            this.dados_proposta.proposta_veiculo.valor_veiculo + this.acrescimo
          );
          this.valor_sugerido_original =
            this.dados_proposta.proposta_veiculo.valor_veiculo;
          this.inserir_acessorios = false;
          //this.btn_ranquear = false;
          //this.btn_1 = false;
          this.retrieveItensCortesia();
        }

        //Resumo da Proposta
        this.modal_proposta = true;
        this.resumo();
        this.retrieveVeiculosAvaliacao();
        this.atualizar_valor_total();
      } catch (error) {
        console.log(error);
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      }

      //Inserir Gerente
      const gerente_id = this.$store.state.auth.user.id;
      console.log("Inserindo Gerente");
      await fetch(
        `${process.env.VUE_APP_API_URL}proposta_update_gerente/${propostaId}`,
        {
          method: "PUT",

          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            gerente_id_alteracao: gerente_id
          })
        }
      ).then((data) => {
        if (!data.ok) {
          console.log(data);
          this.abrir_modal = true;
          this.msg = "Sistema sendo atualizado!";
          setTimeout(() => (this.abrir_modal = false), 4000);
          throw Error(data.status);
        }

        return data.json();
      });
    },
    async buscar_marcas() {
      try {
        console.log("Buscando marcas");

        //const response = await axios.get("http://localhost:3007/api/marcas_fipe");
        const response = await axios.get(
          `${process.env.VUE_APP_API_FIPE_URL}marcas_fipe`
        );

        this.marcas = response.data.rows;
        console.log("Lista de marcas", this.marcas);
      } catch (error) {
        console.error(error);
        this.abrir_modal = true;
        this.msg = `Ocorreu um erro ao buscar as marcas. Código do erro: ${
          error.response?.status
        }. Mensagem: ${error.response?.data?.message || "Erro desconhecido."}`;
        setTimeout(() => (this.abrir_modal = false), 1000);
      }
    },
    buscarModelo() {
      const valorSelecionado = this.marcaSelecionada;
      const datalist = this.$refs.datalistMarcas;

      // Converter as opções em um array para facilitar a busca
      const options = Array.from(datalist.options);

      // Encontrar a opção que corresponde ao valor selecionado
      const opcao = options.find((opt) => opt.value === valorSelecionado);

      if (opcao) {
        const id = opcao.getAttribute("data-id");
        this.marcaIdSelecionada = id;
        console.log("ID da marca selecionada:", this.marcaIdSelecionada);
        this.buscar_modelo(this.marcaIdSelecionada);
        // Aqui você pode chamar outra função ou realizar alguma ação com o ID da marca
        // Por exemplo: this.carregarModelos(id);
      } else {
        console.log("Nenhuma marca correspondente encontrada.");
        this.marcaIdSelecionada = null;
      }
    },
    async buscar_modelo(id_marca) {
      try {
        console.log("Buscando modelo", id_marca);

        //const response = await axios.get("http://localhost:3007/api/marcas_fipe");
        const response = await axios.get(
          `${process.env.VUE_APP_API_FIPE_URL}modelo_marca`,
          {
            params: { id: id_marca }
          }
        );

        this.modelos = response.data.rows;
        console.log("Lista de modelos", response);
      } catch (error) {
        console.error(error);
        this.abrir_modal = true;
        this.msg = `Ocorreu um erro ao buscar as marcas. Código do erro: ${
          error.response?.status
        }. Mensagem: ${error.response?.data?.message || "Erro desconhecido."}`;
        setTimeout(() => (this.abrir_modal = false), 1000);
      }
    },
    getRequestParamsMidias(searchTitle, page_midia, pageSize_midia) {
      let params = {};
      if (searchTitle) {
        params["nome"] = searchTitle;
      }
      if (page_midia) {
        params["page"] = page_midia - 1;
      }
      if (pageSize_midia) {
        params["size"] = pageSize_midia;
      }
      return params;
    },
    pagamento_vista() {
      console.log("Forma de pagamento", this.forma_pagamento);
      if (this.forma_pagamento === true) {
        console.log("Ativo");
        this.venda_vista = true;
        this.venda_financiamento = false;
        this.incluir_acessorios = false;
        this.incluir_financiamento = false;
        this.metodo_pagamento = "A Vista";
        this.inserir_pagamento_avaliacao();
        if (!this.pagamentoVistaJaChamado) {
          this.retrievePagamentosDesk();
        }
      } else {
        this.metodo_pagamento = "Financiamento";
        this.venda_vista = false;
        this.venda_financiamento = true;
        this.incluir_acessorios = true;
        this.incluir_financiamento = true;
      }
    },
    async inserir_pagamento_avaliacao() {
      const valor_venda = this.Valor_Total_Venda
        ? parseFloat(
            this.Valor_Total_Venda.replace(/[^\d,]+/g, "").replace(",", ".")
          )
        : 0;
      const valor_parcela = this.valor_avaliacao;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}checar_valor_desk_avaliacao`,
          {
            params: {
              proposta_id: this.id_proposta,
              tipo_pagamento_id: this.id_pagamento
            }
          }
        );
        if (response.data.count > 0) {
          console.log("Avaliação ja inserida");
          return;
        }
      } catch (error) {
        console.log(error);
        if (error.response.status == 400) {
          this.hab_avista = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.hab_avista = false), 3000);
        }
      }

      //Validando antes de enviar para a api
      if (!valor_parcela) {
        // Se valor_parcela for null, undefined, ou 0, interrompe o processo
        console.log("Nenhum valor de avaliação. Ação não realizada.");
        return;
      }

      await fetch(`${process.env.VUE_APP_API_URL}pagamento_desk`, {
        method: "POST",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify({
          proposta_id: this.id_proposta,
          tipo_pagamento_id: this.id_pagamento,
          valor_venda: valor_venda,
          valor_parcela: valor_parcela,
          qtd_parcela: 1,
          status: 1
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          return data.json();
        })
        .then((resposta) => {
          console.log("Pagamento inserido com sucesso ------ " + resposta);
          if (resposta.StatusOk == 200) {
            this.hab_avista;
            this.msg = "Pagamento inserido com sucesso";
            setTimeout(() => (this.hab_avista = false), 8000);
            this.retrievePagamentosDesk();
            this.pagamentoVistaJaChamado = true;
          }
        });
    },
    async confirmarAlteracaoPagamento() {
      try {
        const id = this.id_pagamento_desk;
        await fetch(`${process.env.VUE_APP_API_URL}pagamento_desk/${id}`, {
          method: "PUT",

          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: id,
            status: 0
          })
        })
          .then((data) => {
            if (!data.ok) {
              throw Error(data.status);
            }
            return data.json();
          })
          .then((resposta) => {
            console.log("Resposta da atualização", resposta);
            if (resposta.StatusOk === 200) {
              this.hab_avista = true;
              this.msg = resposta.message;
              setTimeout(() => (this.hab_avista = false), 3000);
              console.log(
                "Chamando retrievePagamentosDesk após excluir um registro"
              );
              this.retrievePagamentosDesk();
            }
          });
      } catch (error) {
        console.error("Verificando log", error.message);

        if (error.response && error.response.status === 500) {
          this.hab_avista = true;
          this.msg = "Erro interno do servidor";
          setTimeout(() => (this.hab_avista = false), 4000);
        } else {
          // Tratar outros erros
          this.hab_avista = true;
          (this.msg = "Erro:"), error.message;
          (this.msg = "Status:"), error.response.status;
          (this.msg = "Dados:"), error.response.data;
          (this.msg = "Cabeçalhos:"), error.response.headers;
          setTimeout(() => (this.hab_avista = false), 4000);
        }
      }
    },

    async limpar_pagamento_vista() {
      try {
        const id = this.id_proposta;
        await fetch(
          `${process.env.VUE_APP_API_URL}limpar_pagamento_desk/${id}`,
          {
            method: "PUT",

            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: id,
              status: 0
            })
          }
        )
          .then((data) => {
            if (!data.ok) {
              throw Error(data.status);
            }
            return data.json();
          })
          .then((resposta) => {
            console.log("Resposta da atualização", resposta);
            // if (resposta.StatusOk === 200) {
            //   this.hab_avista = true;
            //   this.msg = resposta.message;
            //   setTimeout(() => (this.hab_avista = false), 3000);
            //   console.log("Chamando retrievePagamentosDesk após excluir um registro")
            //   this.retrievePagamentosDesk();
            // }
          });
      } catch (error) {
        console.error("Verificando log", error.message);

        if (error.response && error.response.status === 500) {
          this.hab_avista = true;
          this.msg = "Erro interno do servidor";
          setTimeout(() => (this.hab_avista = false), 4000);
        } else {
          // Tratar outros erros
          this.hab_avista = true;
          (this.msg = "Erro:"), error.message;
          (this.msg = "Status:"), error.response.status;
          (this.msg = "Dados:"), error.response.data;
          (this.msg = "Cabeçalhos:"), error.response.headers;
          setTimeout(() => (this.hab_avista = false), 4000);
        }
      }
    },

    async inserir_pagamento() {
      var somatorio_parcelas = "";
      var total_pagamento = "";
      const valor_venda = this.Valor_Total_Venda
        ? parseFloat(
            this.Valor_Total_Venda.replace(/[^\d,]+/g, "").replace(",", ".")
          )
        : 0;
      const valor_parcela = this.valor_parcela_vista
        ? parseFloat(
            this.valor_parcela_vista.replace(/[^\d,]+/g, "").replace(",", ".")
          )
        : 0;

      if (valor_parcela) {
        try {
          const response = await axios.get(
            `${process.env.VUE_APP_API_URL}checar_valor_desk`,
            {
              params: {
                proposta_id: this.id_proposta
              }
            }
          );

          somatorio_parcelas = response.data.data;
          total_pagamento = valor_parcela + somatorio_parcelas;

          console.log("Total Pagamento: ", total_pagamento);

          if (valor_venda < total_pagamento) {
            console.log("Valor maior");

            this.hab_avista = true;
            this.msg =
              "Os valores informados para pagamento ultrapassam o valor total de venda";
            setTimeout(() => (this.hab_avista = false), 4000);

            return;
          }
        } catch (error) {
          console.log(error);
          if (error.response.status == 400) {
            this.hab_avista = true;
            this.msg = error.response.data.message;
            setTimeout(() => (this.hab_avista = false), 3000);
          }
        }
      }

      //Validando antes de enviar para a api
      if (valor_parcela == 0) {
        this.abrir_modal = true;
        this.msg = "O valor da parcela não pode ser R$ 0,00";
        setTimeout(() => (this.abrir_modal = false), 4000);
        return;
      }
      console.log("=== ANTES DE INSERIR ===");
      console.log(
        "Quantidade atual de pagamentos:",
        this.itens_pagamentos?.length || 0
      );
      console.log("Itens atuais:", this.itens_pagamentos);
      await fetch(`${process.env.VUE_APP_API_URL}pagamento_desk`, {
        method: "POST",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify({
          proposta_id: this.id_proposta,
          tipo_pagamento_id: this.met_pagamento_vista,
          valor_venda: valor_venda,
          valor_parcela: valor_parcela,
          qtd_parcela: this.qtd_parcela_vista,
          status: 1
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          return data.json();
        })
        .then((resposta) => {
          console.log("Pagamento inserido com sucesso ------ " + resposta.data);
          this.met_pagamento_vista = "";
          this.valor_parcela_vista = "";
          this.qtd_parcela_vista = "";
          if (resposta.StatusOk == 200) {
            this.hab_avista = true;
            this.msg = "Pagamento inserido com sucesso";
            setTimeout(() => (this.hab_avista = false), 8000);
            this.retrievePagamentosDesk();
            this.resumo_vista();
            this.pagamentoVistaJaChamado = true;
          }
        });
    },
    async retrievePagamentosDesk() {
      const proposta_id = this.id_proposta;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}pagamento_desk`,
          {
            params: {
              proposta_id: proposta_id,
              status: 1,
              page: this.page - 1,
              size: this.pageSize
            }
          }
        );

        // 🔥 Pega os dados originais (pode ser response.data ou response.data.rows)
        const dadosOriginais = response.data.rows || response.data;

        console.log("Dados originais:", dadosOriginais);

        // 🔥 Cria um array novo APENAS com os campos que você quer mostrar na tabela
        this.itens_pagamentos = dadosOriginais.map((item) => ({
          id: item.id,
          valor_parcela: item.valor_parcela,
          qtd_parcela: item.qtd_parcela,
          tipo_pagamento_descricao:
            item.tipo_pagamento_desk?.descricao || "Não informado",
          tipo_pagamento_id: item.tipo_pagamento_id,
          // Se precisar do objeto completo para outras operações
          tipo_pagamento_desk: item.tipo_pagamento_desk
        }));

        console.log("Array filtrado para tabela:", this.itens_pagamentos);
        console.log(
          "Existe avaliação lançada e foi chamado o método checar_valores --- linha 5461"
        );

        this.checar_valores();
      } catch (error) {
        console.log(error);
        if (error.response?.status == 400) {
          this.hab_avista = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.hab_avista = false), 1000);
        }
      }
    },

    async checar_valores() {
      const valor_venda = this.Valor_Total_Venda
        ? parseFloat(
            this.Valor_Total_Venda.replace(/[^\d,]+/g, "").replace(",", ".")
          )
        : 0;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}checar_valor_desk`,
          {
            params: {
              proposta_id: this.id_proposta
            }
          }
        );

        const somatorio_parcelas = response.data.data;

        console.log(
          "Verificando se valor de venda é menor que a soma das parcelas"
        );
        if (valor_venda < somatorio_parcelas) {
          this.hab_avista = true;
          this.msg = "Valor do pagamento ultrapassa o valor do pacote";
          setTimeout(() => (this.hab_avista = false), 3000);
          return;
        }

        console.log(
          "Verificando se a soma das parcelas são iguais ao valor da venda para liberar o menu"
        );
        if (valor_venda == somatorio_parcelas) {
          console.log("pode gerar menu");
          this.habilitar_gerar_menu_avista = false;
          this.habilitar_finalizar_venda = false;
          this.btn_finalizar_venda_vista = false;
          this.resumo_vista();
        } else {
          this.habilitar_gerar_menu_avista = true;
          this.habilitar_finalizar_venda = true;
          this.btn_finalizar_venda_vista = true;
        }
      } catch (error) {
        console.log(error);
        if (error.response.status == 400) {
          this.hab_avista = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.hab_avista = false), 3000);
        }
      }
    },
    remover_item_pagamento(item) {
      this.id_pagamento_desk = item.id;
    },
    async retrieveTipoPagamento() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}tipo_pagamentos`,
          {
            params: {
              status: 1
            }
          }
        );

        // Faça algo com os dados aqui, como atribuir a uma variável de componente
        this.metodo_pagamento_vista = response.data; // exemplo de atribuição
        // Filtrar pelo registro com a descrição desejada
        const registro = this.metodo_pagamento_vista.find(
          (item) => item.descricao === "VEÍCULO TROCA" // altere para a descrição desejada
        );

        if (registro) {
          this.id_pagamento = registro.id; // Armazenar o ID do registro encontrado
          console.log("ID do Pagamento à vista:", this.id_pagamento);
        } else {
          console.log("Registro com a descrição especificada não encontrado.");
        }

        console.log("Lista de pagamentos", this.metodo_pagamento_vista);
      } catch (error) {
        console.log(error);
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 1000);
        }
      }
    },
    async retrieveMidia() {
      try {
        const params = this.getRequestParamsMidias(
          this.searchTitle,
          this.page_midia,
          this.pageSize_midia
        );
        userService
          .getMidia(params)
          .then((response) => {
            const { midias } = response.data;

            this.midia = midias;

            console.log(response.data);
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.abrir_modal = true;
              this.msg = error.response.data.message;
            }
          });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },

    /**Função 003 */
    /*Venda Futura e Veiculo do estoque*/
    async completar_modelo(item) {
      try {
        console.log("checando dados do modelo");
        console.log(item);

        const id_modelo = item;
        const modelo_venda = await axios.get(
          `${process.env.VUE_APP_API_URL}modelo/${id_modelo}`,
          {
            params: { id: id_modelo }
          }
        );

        /**Verifico se veio algum modelo na resposta da api */
        if (Object.keys(modelo_venda.data).length > 0) {
          /**Preenchendo os campos com os dados do modelo */
          (this.modelo_id = id_modelo),
            (this.modelo_futuro = modelo_venda.data);
          (this.venda_futura = 1),
            (this.empresa = this.empresaID),
            (this.chassi_proposta = ""),
            (this.categoria = "NOVO");
          (this.modelo_proposta = modelo_venda.data.descricao),
            (this.pps_valor = 0),
            (this.valor_veiculo = modelo_venda.data["precoVenda"]),
            (this.dias_em_estoque = 0),
            (this.marca_proposta =
              modelo_venda.data.familia_veiculo.marca_veiculo["descricao"]),
            (this.anoModelo_proposta = modelo_venda.data["anoModelo"]),
            (this.anoFabricacao_proposta = modelo_venda.data["anoFabricacao"]),
            (this.placa = ""),
            (this.combustivel_proposta =
              modelo_venda.data.combustivel_veiculo["descricao"]),
            (this.cor_proposta = this.selected_cor_veiculo_escolhido),
            (this.numero_veiculo_proposta = 0);
          this.status_veiculo = 1;
          (this.valor_custo_contabil = modelo_venda.data["precoVenda"]),
            (this.Valor_Sugerido = this.currency(
              modelo_venda.data["precoVenda"]
            )),
            (this.valor_sugerido_original = modelo_venda.data["precoVenda"]),
            (this.Valor_Total_Venda = this.currency(
              modelo_venda.data["precoVenda"]
            )),
            this.propostaVeiculo();
        } else {
          this.abrir_modal = true;
          this.msg = "O servidor não o modelo selecionado!";
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      } catch (error) {
        this.abrir_modal = true;
        this.msg = error;
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },
    async propostaMesmoVeiculo() {
      try {
        const alterar_veiculo = await fetch(
          `${process.env.VUE_APP_API_URL}veiculo_proposta`,
          {
            method: "POST",

            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              venda_futura: this.venda_futura,
              empresa: this.empresa,
              categoria: this.categoria,
              chassis: "",
              modelo_veiculo: this.modelo_proposta,
              pps_valor: this.pps_valor,
              valor_veiculo: this.valor_veiculo,
              dias_em_estoque: this.dias_em_estoque,
              cor: this.cor_proposta,
              marca: this.marca_proposta,
              ano_modelo: this.anoModelo_proposta,
              ano_fabricacao: this.anoFabricacao_proposta,
              kilometragem: "",
              placa: this.placa,
              combustivel: this.combustivel_proposta,
              numero_veiculo: this.numero_veiculo_proposta,
              status_veiculo: this.status_veiculo,
              proposta_id: this.id_proposta,
              valorcustocontabil: this.valor_custo_contabil,
              atendimento_anterior: this.atendimento_anterior
            })
          }
        );

        if (alterar_veiculo.ok) {
          this.adicional = "0.00";
          this.desconto = "0.00";
          this.atualizar_valor_total();
          this.update_entradas();
          //window.location.reload();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async propostaVeiculo() {
      try {
        const alterar_veiculo = await fetch(
          `${process.env.VUE_APP_API_URL}veiculo_proposta`,
          {
            method: "POST",

            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              venda_futura: this.venda_futura,
              empresa: this.empresa,
              categoria: this.categoria,
              chassis: this.chassi_proposta,
              modelo_veiculo: this.modelo_proposta,
              pps_valor: this.pps_valor,
              valor_veiculo: this.valor_veiculo,
              dias_em_estoque: this.dias_em_estoque,
              cor: this.cor_proposta,
              marca: this.marca_proposta,
              ano_modelo: this.anoModelo_proposta,
              ano_fabricacao: this.anoFabricacao_proposta,
              kilometragem: "",
              placa: this.placa,
              combustivel: this.combustivel_proposta,
              numero_veiculo: this.numero_veiculo_proposta,
              status_veiculo: this.status_veiculo,
              proposta_id: this.id_proposta,
              valorcustocontabil: this.valor_custo_contabil,
              modelo_id: this.modelo_id || null
            })
          }
        );

        if (alterar_veiculo.ok) {
          this.adicional = "0.00";
          this.desconto = "0.00";
          this.atualizar_valor_total();
          this.update_entradas();
          //window.location.reload();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async update_entradas() {
      try {
        const id = this.id_proposta;
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}update_entradas/${id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: id,
              status: 0
            })
          }
        );
        window.location.reload();
        if (response.status == 204) {
          //this.abrir_modal = true;
          //this.msg = "Não existe menu para esse atendimento!";
          //setTimeout(() => (this.abrir_modal = false), 4000);
        } else {
          window.location.reload();
        }
      } catch (error) {
        console.log(error);
        this.abrir_modal = true;
        this.msg = error;
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },
    openModal(message) {
      this.modalMessage = message;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      window.location.reload();
    },
    atualizarPagina() {
      window.location.reload(); // Recarrega a página
    },
    async carregarVeiculo(item) {
      console.log("Itens");
      console.log(item);
      try {
        if (item.estadoveiculo == "NOVO") {
          this.venda_futura = 1;
        } else {
          this.venda_futura = 0;
        }

        this.empresa = item.codigoempresa;
        this.categoria = item.estadoveiculo;
        this.chassi_proposta = item.chassi;
        this.modelo_proposta = item.modelo;
        this.pps_valor = item.valortotalentrada;
        this.valor_veiculo = item.valortotalvenda;
        this.Valor_Sugerido = this.currency(item.valortotalvenda);
        this.Valor_Total_Venda = this.currency(item.valortotalvenda);
        this.valor_sugerido_original = item.valortotalvenda;
        this.dias_em_estoque = item.diasestoque;
        this.marca_proposta = item.marca;
        this.anoModelo_proposta = item.anomodelo;
        this.anoFabricacao_proposta = item.anofabricacao;
        this.placa = item.placa;
        this.combustivel_proposta = item.combustivel;
        this.cor_proposta = item.cor;
        this.numero_veiculo_proposta = item.numero;
        this.status_veiculo = 1;
        this.modal_estoque = false;
        this.filtro_tipo_veiculo = item.estadoveiculo;
        this.inserir_acessorios = false;
        this.valor_custo_contabil = item.valorcustocontabil;

        const params = {
          numero: this.numero_veiculo_proposta,
          empresa: this.empresa
        };

        //**Verificar se o mesmo veículo está sendo vendido e avisar ou se o mesmo já foi vendido não deixar finalizar a venda */
        const verificar_veiculo = await axios.get(
          `${process.env.VUE_APP_API_URL}venda_mesmo_veiculo_apresentacao_full`,
          {
            params
          }
        );
        console.log("Verificando status do veículo");
        console.log(verificar_veiculo);

        // if (verificar_veiculo.data.statusOk == 1) {
        //   this.mesmo_veiculo = true;
        //   this.atendimento_anterior = verificar_veiculo.data.data[0].id;
        //   console.log("Dados do atendimento do mesmo véiculo");
        //   console.log(verificar_veiculo.data.data);
        //   const Filial = verificar_veiculo.data.data[0].empresa_proposta.nome;
        //   const Gerente = verificar_veiculo.data.data[0].gerentes.username;
        //   const Data_Venda =
        //     verificar_veiculo.data.data[0].horario_termino_atendimento;
        //   const date = new Date(Data_Venda);

        //   const day = String(date.getDate()).padStart(2, "0");
        //   const month = String(date.getMonth() + 1).padStart(2, "0"); // Os meses são baseados em zero
        //   const year = date.getFullYear();

        //   const formattedDate = `${day}/${month}/${year}`;

        //   const Mensagem = `
        //                     Empresa: ${Filial}
        //                     Gerente: ${Gerente}
        //                     Data: ${formattedDate}`;
        //   //this.openModal(Mensagem);
        //   this.msg_conteudo = Mensagem;
        //   //this.propostaMesmoVeiculo();
        //   return;
        // }
        if (verificar_veiculo.data.statusOk == 1) {
          this.mesmo_veiculo = true;
          this.atendimento_anterior = verificar_veiculo.data.data[0].id;
          console.log("Dados do atendimento do mesmo veículo");
          console.log(verificar_veiculo.data.data);

          let Mensagem = "";

          // Percorre todos os atendimentos
          verificar_veiculo.data.data.forEach((atendimento) => {
            const n_proposta = atendimento.id;
            const Filial = atendimento.empresa_proposta.nome;
            const Gerente = atendimento.gerentes
              ? atendimento.gerentes.username
              : "Não informado";
            const Data_Venda = atendimento.horario_termino_atendimento;
            const date = new Date(Data_Venda);

            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();

            const formattedDate = `${day}/${month}/${year}`;

            Mensagem += `➤ Atendimento ${n_proposta}: ${Filial} ${Gerente} (${formattedDate}) - ${atendimento.status_proposta}\n`;
          });

          this.msg_conteudo = Mensagem;
          return;
        }

        if (verificar_veiculo.data.statusOk == 2) {
          const emp_veiculo = verificar_veiculo.data.dados;
          const id_proposta = this.id_proposta;

          const processarEmpVeiculo = (index) => {
            if (index < emp_veiculo.length) {
              const item = emp_veiculo[index];

              if (item.id != id_proposta) {
                console.log(item.id);
                console.log(item.empresa_proposta.nome);
                this.abrir_modal = true;
                this.msg = `O veículo escolhido encontra-se aberto em outro atendimento com o número: ${item.id}, na empresa: ${item.empresa_proposta.nome}`;
                setTimeout(() => {
                  this.abrir_modal = false;
                  processarEmpVeiculo(index + 1); // Chama a próxima iteração
                }, 8000);
              } else {
                // Se a condição não for satisfeita, avance para a próxima iteração
                processarEmpVeiculo(index + 1);
              }
            } else {
              // Todas as iterações foram processadas, você pode chamar this.propostaVeiculo() aqui
              this.propostaVeiculo();
            }
          };

          processarEmpVeiculo(0); // Inicie o processamento a partir do índice 0
          return;
        }

        this.propostaVeiculo();
      } catch (error) {
        console.log(error);
        this.abrir_modal = true;
        this.msg = error;
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },
    /**Fim bloco venda futura */

    /**Função 0004 */
    async inserir_desconto() {
      const id = this.id_proposta;
      try {
        await fetch(`${process.env.VUE_APP_API_URL}proposta_desconto/${id}`, {
          method: "PUT",

          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: id,
            desconto: this.desconto
          })
        })
          .then((data) => {
            if (!data.ok) {
              throw Error(data.status);
            }
            return data.json();
          })
          .then((resposta) => {
            if (resposta.statusOk === 200) {
              this.atualizar_valor_total();
              this.update_entradas();
            }
          });
      } catch (error) {
        this.abrir_modal = true;
        this.msg = error;
        setTimeout(() => (this.dialog = false), 4000);
      }
    },

    async atualizar_valor_total() {
      console.log("Atualizando o valor total da venda!");
      const id = this.id_proposta;
      try {
        await fetch(
          `${process.env.VUE_APP_API_URL}proposta_atualizar_valor_total/${id}`,
          {
            method: "PUT",

            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: id,
              val_sugerido_venda: this.Valor_Sugerido,
              adicional: this.adicional,
              desconto: this.desconto
            })
          }
        )
          .then((data) => {
            if (!data.ok) {
              throw Error(data.status);
            }
            return data.json();
          })
          .then((resposta) => {
            console.log(resposta.data);
            if (resposta.StatusOk == 200) {
              this.Valor_Total_Venda = this.currency(
                resposta.data[0].val_sugerido_venda
              );
              this.adicional = this.currency(resposta.data[0].adicional);
              this.desconto = this.currency(resposta.data[0].desconto);
            }
          });
      } catch (error) {
        this.abrir_modal = true;
        this.msg = error;
        setTimeout(() => (this.abrir_modal = false), 4000);
      }

      //this.habilitar_proposta()
      //this.retrievePropostas();
    },

    async inserir_acrescimo() {
      const id = this.id_proposta;
      try {
        await fetch(`${process.env.VUE_APP_API_URL}proposta_acrescimo/${id}`, {
          method: "PUT",

          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: id,
            acrescimo: this.adicional
          })
        })
          .then((data) => {
            console.log(data);
            if (!data.ok) {
              throw Error(data.status);
            }
            return data.json();
          })
          .then((resposta) => {
            if (resposta.statusOk === 200) {
              this.atualizar_valor_total();
              this.update_entradas();
            }
          });
      } catch (error) {
        console.log(error);
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      }
    },
    /**Função 0005 */
    async resumo() {
      console.log("Aqui Resumo");
      await fetch(`${process.env.VUE_APP_API_URL}taxas/resumo`, {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          proposta_id: this.id_proposta
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          return data.json();
        })
        .then((resposta) => {
          console.log("Resumo", resposta);
          if (resposta["tipo_veiculo"] == "NOVO") {
            this.Lucro_Bruto = resposta["Lucro_Bruto_Zero"];
            this.Lucro_Operacional = resposta["Lucro_Operacional_Zero"];
            this.Lucro_liquido = resposta["Lucro_liquido_Zero"];
          }
          if (resposta["tipo_veiculo"] == "USADO") {
            this.Lucro_Bruto = resposta["Lucro_Bruto"];
            this.Lucro_Operacional = resposta["Lucro_Operacional"];
            this.Lucro_liquido = resposta["Lucro_liquido"];
          }
          (this.Valor_Sugerido = resposta["Valor_Sugerido"]),
            (this.Valor_Custo_variaveis = resposta["Valor_Custo_variaveis"]),
            (this.Valor_Itens_Acessorios = resposta["Valor_Itens_Acessorios"]);
          this.Valor_Total_Venda = resposta["Valor_Total_Venda"];

          // this.Valor_Avaliado = resposta["Valor_Avaliado"];
          // this.Valor_Itens_Avaliacao_db = resposta["Valor_Itens_Avaliacao_db"];
          // this.Valor_Itens_Avaliacao_cr = resposta["Valor_Itens_Avaliacao_cr"];
          // this.Valor_Avaliacao_Final = resposta["Valor_Avaliacao_Final"];
          this.Valor_Avaliacao_Final = this.currency(this.valor_avaliacao);

          this.Valor_Resultado_Financiamento =
            resposta["Valor_Resultado_Financiamento"];

          this.Valor_Entrada = resposta["Valor_Entrada"];
          this.Valor_Financiado = resposta["Valor_Financiado"];
          this.Quantidade_Meses = resposta["Quantidade_Meses"];

          this.Valor_Entrada_1 = resposta["Valor_Entrada_1"];
          this.Entrada_Total_1 = resposta["Entrada_Total_1"];
          this.Valor_Financiado_1 = resposta["Valor_Financiado_1"];
          this.Quantidade_Meses_1 = resposta["Quantidade_Meses_1"];

          this.Valor_Entrada_2 = resposta["Valor_Entrada_2"];
          this.Entrada_Total_2 = resposta["Entrada_Total_2"];
          this.Valor_Financiado_2 = resposta["Valor_Financiado_2"];
          this.Quantidade_Meses_2 = resposta["Quantidade_Meses_2"];

          this.Valor_Entrada_3 = resposta["Valor_Entrada_3"];
          this.Entrada_Total_3 = resposta["Entrada_Total_3"];
          this.Valor_Financiado_3 = resposta["Valor_Financiado_3"];
          this.Quantidade_Meses_3 = resposta["Quantidade_Meses_3"];

          this.Pmt = resposta["Pmt"];
          this.parcela_1_1 = resposta["Pmt_1"];
          this.parcela_2_1 = resposta["Pmt_2"];
          this.parcela_3_1 = resposta["Pmt_3"];
          this.parcela_1_2 = resposta["Pmt_4"];
          this.parcela_2_2 = resposta["Pmt_5"];
          this.parcela_3_2 = resposta["Pmt_6"];
          this.parcela_1_3 = resposta["Pmt_7"];
          this.parcela_2_3 = resposta["Pmt_8"];
          this.parcela_3_3 = resposta["Pmt_9"];
          if (resposta["Parcela1"]) {
            console.log("Existe uma parcela");
            this.parcela_1 = resposta["Parcela1"];
            this.parcela_1_resumo = resposta["Parcela1"];
            this.bloquear_entrada = true;
            //this.bloquear_entrada_botoes = true;
          }

          if (resposta["Parcela2"] === undefined) {
            this.parcela_2 = 36;
          } else {
            this.parcela_2 = resposta["Parcela2"];
            this.parcela_2_resumo = resposta["Parcela2"];
          }
          if (resposta["Parcela3"] === undefined) {
            this.parcela_3 = 48;
          } else {
            this.parcela_3 = resposta["Parcela3"];
            this.parcela_3_resumo = resposta["Parcela3"];
          }

          let v_entrada_1 = resposta["Entrada1"];
          let v_entrada_2 = resposta["Entrada2"];
          let v_entrada_3 = resposta["Entrada3"];
          this.entrada_1 = this.currency(v_entrada_1);
          this.entrada_2 = this.currency(v_entrada_2);
          this.entrada_3 = this.currency(v_entrada_3);
          this.adicional = resposta["Valor_Adicional"];
          this.desconto = resposta["Valor_Desconto"];

          if (resposta["incluir_acessorios"] == "1") {
            console.log(
              "Somar Acessorios ---------------------------------------------------------------------------"
            );
            this.incluir_acessorios = true;
          } else {
            this.incluir_acessorios = false;
            console.log(
              "Não Somar Acessorios ---------------------------------------------------------------------------"
            );
          }
          if (resposta["Pmt"] != "") {
            this.btn_gerar_menu = false;
            this.btn_1 = false;
          }
          this.checar_pmt_escolhido();
          console.log("Checando Resposta agora---------------------", resposta);
        });
    },
    async resumo_vista() {
      console.log("Aqui Resumo");
      await fetch(`${process.env.VUE_APP_API_URL}taxas/resumo_vista`, {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          proposta_id: this.id_proposta
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          return data.json();
        })
        .then((resposta) => {
          console.log("Resumo", resposta);
          if (resposta["tipo_veiculo"] == "NOVO") {
            console.log("novo");
            this.Lucro_Bruto = resposta["Lucro_Bruto_Zero"];
            this.Lucro_Operacional = resposta["Lucro_Operacional_Zero"];
            this.Lucro_liquido = resposta["Lucro_liquido_Zero"];
          }
          if (resposta["tipo_veiculo"] == "USADO") {
            this.Lucro_Bruto = resposta["Lucro_Bruto"];
            this.Lucro_Operacional = resposta["Lucro_Operacional"];
            this.Lucro_liquido = resposta["Lucro_liquido"];
          }
          (this.Valor_Sugerido = resposta["Valor_Sugerido"]),
            (this.Valor_Custo_variaveis = resposta["Valor_Custo_variaveis"]),
            (this.Valor_Itens_Acessorios = resposta["Valor_Itens_Acessorios"]);
          this.Valor_Total_Venda = resposta["Valor_Total_Venda"];

          // this.Valor_Avaliado = resposta["Valor_Avaliado"];
          // this.Valor_Itens_Avaliacao_db = resposta["Valor_Itens_Avaliacao_db"];
          // this.Valor_Itens_Avaliacao_cr = resposta["Valor_Itens_Avaliacao_cr"];
          // this.Valor_Avaliacao_Final = resposta["Valor_Avaliacao_Final"];
          this.Valor_Avaliacao_Final = this.currency(this.valor_avaliacao);

          this.Valor_Resultado_Financiamento =
            resposta["Valor_Resultado_Financiamento"];

          this.Valor_Entrada = resposta["Valor_Entrada"];
          this.Valor_Financiado = resposta["Valor_Financiado"];
          this.Quantidade_Meses = resposta["Quantidade_Meses"];

          this.Valor_Entrada_1 = resposta["Valor_Entrada_1"];
          this.Entrada_Total_1 = resposta["Entrada_Total_1"];
          this.Valor_Financiado_1 = resposta["Valor_Financiado_1"];
          this.Quantidade_Meses_1 = resposta["Quantidade_Meses_1"];

          this.Valor_Entrada_2 = resposta["Valor_Entrada_2"];
          this.Entrada_Total_2 = resposta["Entrada_Total_2"];
          this.Valor_Financiado_2 = resposta["Valor_Financiado_2"];
          this.Quantidade_Meses_2 = resposta["Quantidade_Meses_2"];

          this.Valor_Entrada_3 = resposta["Valor_Entrada_3"];
          this.Entrada_Total_3 = resposta["Entrada_Total_3"];
          this.Valor_Financiado_3 = resposta["Valor_Financiado_3"];
          this.Quantidade_Meses_3 = resposta["Quantidade_Meses_3"];

          this.Pmt = resposta["Pmt"];
          this.parcela_1_1 = resposta["Pmt_1"];
          this.parcela_2_1 = resposta["Pmt_2"];
          this.parcela_3_1 = resposta["Pmt_3"];
          this.parcela_1_2 = resposta["Pmt_4"];
          this.parcela_2_2 = resposta["Pmt_5"];
          this.parcela_3_2 = resposta["Pmt_6"];
          this.parcela_1_3 = resposta["Pmt_7"];
          this.parcela_2_3 = resposta["Pmt_8"];
          this.parcela_3_3 = resposta["Pmt_9"];
          if (resposta["Parcela1"]) {
            console.log("Existe uma parcela");
            this.parcela_1 = resposta["Parcela1"];
            this.bloquear_entrada = true;
          }

          if (resposta["Parcela2"] === undefined) {
            this.parcela_2 = 36;
          } else {
            this.parcela_2 = resposta["Parcela2"];
          }
          if (resposta["Parcela3"] === undefined) {
            this.parcela_3 = 48;
          } else {
            this.parcela_3 = resposta["Parcela3"];
          }

          let v_entrada_1 = resposta["Entrada1"];
          let v_entrada_2 = resposta["Entrada2"];
          let v_entrada_3 = resposta["Entrada3"];
          this.entrada_1 = this.currency(v_entrada_1);
          this.entrada_2 = this.currency(v_entrada_2);
          this.entrada_3 = this.currency(v_entrada_3);
          this.adicional = resposta["Valor_Adicional"];
          this.desconto = resposta["Valor_Desconto"];

          if (resposta["incluir_acessorios"] == "1") {
            console.log(
              "Somar Acessorios ---------------------------------------------------------------------------"
            );
            this.incluir_acessorios = true;
          } else {
            this.incluir_acessorios = false;
            console.log(
              "Não Somar Acessorios ---------------------------------------------------------------------------"
            );
          }
          if (resposta["Pmt"] != "") {
            this.btn_gerar_menu = false;
            this.btn_1 = false;
          }
          this.checar_pmt_escolhido();
          console.log("Checando Resposta agora---------------------", resposta);
        });
    },

    /**Função 0006 */
    async checar_pmt_escolhido() {
      const pmt_escolhido = await axios.get(
        `${process.env.VUE_APP_API_URL}pmt_escolhido`,
        {
          params: { id: this.id_proposta }
        }
      );
      console.log(
        "Resultado da consulta ----",
        pmt_escolhido.data.data.rows[0].pmt_escolhido
      );

      if (pmt_escolhido.data.data.rows[0].pmt_escolhido != null) {
        this.btn_finalizar_venda = false;
      }
    },
    async validar_just_perdida() {
      if (this.just_venda_perdida.length < 30) {
        this.abrir_modal = true;
        this.msg = "A justificativa de ter mais que 30 caracteres!";
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },
    /**Função 0007 */
    getRequestParamsTrocaVendedor(
      tipo_vendedor,
      empresa_id,
      justificativa_vendedor
    ) {
      let params = {};
      if (tipo_vendedor) {
        params["id_vend"] = tipo_vendedor;
      }
      if (empresa_id) {
        params["empresa_id"] = empresa_id;
      }
      if (justificativa_vendedor) {
        params["justificativa_vendedor"] = justificativa_vendedor;
      }
      return params;
    },
    async retrieveVendedorDispo() {
      try {
        console.log("troca de vendedor");
        const params = this.getRequestParamsTrocaVendedor(
          this.tipo_vendedor,
          this.company_id,
          this.justificativa_vendedor
        );
        userService
          .getVendedorOrdenado(params)
          .then((response) => {
            const { users } = response.data;
            this.troca_vendedor = users;
            let dados_vendedor = [];
            let ven = [];
            let tipo_vend = "";
            let status_vend = "";
            console.log(response.data);
            users.forEach(function (item) {
              if (item.tipo_vendedor == 2) {
                tipo_vend = "Ambos";
              }

              // if (item.tipo_vendedor == 1) {
              //   tipo_vend = "Novos";
              // }
              // if (item.tipo_vendedor == 2) {
              //   tipo_vend = "Usados";
              // }
              if (item.status_vendedor == 1) {
                status_vend = "Disponível";
              }
              if (item.status_vendedor == 0) {
                status_vend = "Indisponível";
              }

              dados_vendedor = {
                id: item.id,
                username: item.username,
                tipo_vendedor: tipo_vend,
                status_vendedor: status_vend
              };

              ven.push(dados_vendedor);
            });

            console.log("Aqui dados do Ven-------------------------------");
            console.log(response.data);

            this.troca_vendedor = ven;
            this.vendedor_troca = ven[0]["id"];
            this.vend_ini = users[0]["id"];
            this.status_vendedor = ven[0]["status_vendedor"];
            console.log(this.status_vendedor);
            console.log(this.vend_ini);
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.abrir_modal = true;
              this.msg = error.response.data.message;
            }
          });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },
    async validar_vendedor() {
      if (!this.justificativa_vendedor) {
        this.check_vend = true;
        this.abrir_modal = true;
        this.msg = "O campo justificativa é obrigatório";
        setTimeout(() => (this.abrir_modal = false), 4000);
      } else if (this.justificativa_vendedor.length < 10) {
        this.check_vend = true;
        this.abrir_modal = true;
        this.msg = "A justificativa de ter mais que 10 caracteres!";
        setTimeout(() => (this.abrir_modal = false), 4000);
      } else {
        this.check_vend = false;
      }
    },
    async validar_midia() {
      if (!this.justificativa_midia) {
        this.check_midia = true;
        this.abrir_modal = true;
        this.msg = "O campo justificativa é obrigatório";
        setTimeout(() => (this.abrir_modal = false), 4000);
      } else if (this.justificativa_midia.length < 10) {
        this.check_midia = true;
        this.abrir_modal = true;
        this.msg = "A justificativa de ter mais que 10 caracteres!";
        setTimeout(() => (this.abrir_modal = false), 4000);
      } else {
        this.check_midia = false;
      }
    },
    async onSubmitTrocaVendedor() {
      const id = this.id_proposta;
      const justificativa = this.justificativa_vendedor;
      const id_vendedor_trocado = this.vendedor_troca;

      await fetch(
        `${process.env.VUE_APP_API_URL}proposta_troca_vendedor/${id}`,
        {
          method: "PUT",

          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: id,
            just_troca_vendedor: justificativa,
            vendedor_id: id_vendedor_trocado
          })
        }
      )
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          return data.json();
        })
        .then((resposta) => {
          this.justificativa_vendedor = "";
          this.abrir_modal = true;
          this.msg = resposta.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
          window.location.reload();
        });
    },
    async onSubmitTrocaMidia() {
      const id = this.id_proposta;
      //const justificativa = this.justificativa_midia;
      const id_midia_trocada = this.midia_id;

      await fetch(`${process.env.VUE_APP_API_URL}proposta_troca_midia/${id}`, {
        method: "PUT",

        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: id,
          // just_troca_vendedor: justificativa,
          midia_id: id_midia_trocada
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          return data.json();
        })
        .then((resposta) => {
          this.abrir_modal = true;
          this.msg = resposta.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
          window.location.reload();
        });
    },

    /**Função 0008 */

    async retrieveCidade() {
      try {
        const params = this.getRequestParams(
          this.searchTitle,
          this.page,
          this.pageSize
        );
        userService.getCidades(params).then((response) => {
          const { cidade } = response.data;
          this.cidades = cidade;
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      }
    },

    formatarData(data) {
      // Verificar se data é null, undefined, vazia ou inválida
      if (!data || data === "null" || data === "undefined") {
        return ""; // Retorna string vazia para campos não obrigatórios
      }

      // Se data for um objeto Date válido
      if (data instanceof Date && !isNaN(data)) {
        const ano = data.getFullYear();
        const mes = String(data.getMonth() + 1).padStart(2, "0");
        const dia = String(data.getDate()).padStart(2, "0");
        return `${ano}-${mes}-${dia}`;
      }

      // Se data for uma string
      if (typeof data === "string") {
        try {
          // Verificar se é uma data no formato ISO (com 'T')
          if (data.includes("T")) {
            const partesData = data.split("T")[0].split("-");
            const ano = parseInt(partesData[0], 10);
            const mes = parseInt(partesData[1], 10) - 1; // O mês começa em 0 no JavaScript
            const dia = parseInt(partesData[2], 10);

            const dataObj = new Date(ano, mes, dia);

            // Validar se a data é válida
            if (isNaN(dataObj.getTime())) {
              return "";
            }

            const ano1 = dataObj.getFullYear();
            const mes1 = String(dataObj.getMonth() + 1).padStart(2, "0");
            const dia1 = String(dataObj.getDate()).padStart(2, "0");
            return `${ano1}-${mes1}-${dia1}`;
          }

          // Se já estiver no formato "YYYY-MM-DD"
          if (/^\d{4}-\d{2}-\d{2}$/.test(data)) {
            return data;
          }

          // Tentar parsear como data geral
          const dataObj = new Date(data);
          if (!isNaN(dataObj.getTime())) {
            const ano = dataObj.getFullYear();
            const mes = String(dataObj.getMonth() + 1).padStart(2, "0");
            const dia = String(dataObj.getDate()).padStart(2, "0");
            return `${ano}-${mes}-${dia}`;
          }

          return ""; // Se não conseguir parsear, retorna vazio
        } catch (error) {
          console.warn("Erro ao formatar data:", error, "Data:", data);
          return "";
        }
      }

      // Para qualquer outro tipo, retorna vazio
      return "";
    },
    formatarDataBR(data) {
      if (!data) return "";

      const dataObj = new Date(data);
      if (isNaN(dataObj.getTime())) return "";

      const dia = String(dataObj.getDate()).padStart(2, "0");
      const mes = String(dataObj.getMonth() + 1).padStart(2, "0");
      const ano = dataObj.getFullYear();

      return `${dia}/${mes}/${ano}`;
    },
    habilitar_cadastro() {
      console.log("Habilitando cadastro");
      this.input_cliente = false;
      this.modal_cpfcnpj = "";
      // Defina aqui a lógica para mudar as cores das bordas dos campos
      this.nomeBorderColor = "green"; // Por exemplo, a cor verde indica que o campo está habilitado
      this.emailBorderColor = "green";
      this.telBorderColor = "green";
      this.celBorderColor = "green";

      this.cnpjBorderColor = "green";
      this.dataNascimentoBorderColor = "green";
      this.enderecoBorderColor = "green";
      this.complementoBorderColor = "green";
      this.ufBorderColor = "green";
      this.cidadeBorderColor = "green";
      this.bairroBorderColor = "green";
      this.cepBorderColor = "green";
    },

    async select_familia() {
      console.log("Chamando familia", this.venda_futura);
      if (this.venda_futura == true) {
        console.log("Habilitado");
        this.inserir_veiculo = false;

        (this.chassi_proposta = ""),
          (this.marca_proposta = ""),
          (this.modelo_proposta = ""),
          (this.cor_proposta = ""),
          (this.anoFabricacao_proposta = ""),
          (this.anoModelo_proposta = ""),
          (this.combustivel_proposta = ""),
          (this.selected_familia_veiculo_escolhido = ""),
          (this.selected_modelo_veiculo_escolhido = "");
      }
      if (this.venda_futura == false) {
        console.log("Desabilitado");
        this.inserir_veiculo = true;
      }

      console.log(this.venda_futura);
      try {
        const params = this.getRequestParams(
          this.searchTitle,
          this.page,
          this.pageSize,
          this.company_id
        );
        console.log(params);
        userService.getFamilia_futura(params).then((response) => {
          const { familia_veiculo, totalPages } = response.data;
          this.familia_veiculo_escolhido = familia_veiculo;
          this.totalPages = totalPages;
          console.log(response.data);
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      }
    },
    async vendaFutura() {
      //Tratar dados quando for venda futura
      //Carregar Familia e Modelo que atendam venda futura
      console.log("Cliquei aqui");
      //Carregar apenas estoque de venda futura
      if (this.familia_veiculo_escolhido) {
        await axios
          .get(`${process.env.VUE_APP_API_URL}modelos`, {
            params: {
              familiaVeiculoId: this.selected_familia_veiculo_escolhido
            }
          })
          .then((response) => {
            this.modelo_veiculo_escolhido = response.data.rows;
            console.log(response.data.rows);
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.abrir_modal = true;
              this.msg = error.response.data.message;
              setTimeout(() => (this.abrir_modal = false), 4000);
            }
          });
      } else {
        this.modelo_veiculo_escolhido = [];
      }
    },
    async cor_modelo() {
      try {
        await axios
          .get(`${process.env.VUE_APP_API_URL}cor_modelo`, {
            params: {}
          })
          .then((response) => {
            this.cor_veiculo_escolhido = response.data;
            console.log("listando as cores");
            console.log(response.data);
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.abrir_modal = true;
              this.msg = error.response.data.message;
              setTimeout(() => (this.abrir_modal = false), 4000);
            }
          });
      } catch (error) {
        this.abrir_modal = true;
        this.msg = error.message;
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },

    generatePdfAvista() {
      const element = this.$refs.contentToPrint2;

      // Primeiro, faça um clone do elemento para evitar alterar o DOM original
      const clonedElement = element.cloneNode(true);

      // Aplique estilos temporários apenas para o PDF
      clonedElement.style.width = "297mm";
      clonedElement.style.height = "210mm";
      clonedElement.style.margin = "0";
      clonedElement.style.padding = "5mm";
      clonedElement.style.boxSizing = "border-box";

      // Ajuste os tamanhos de fonte para o PDF
      clonedElement.querySelectorAll(".rf_texto_pdf").forEach((el) => {
        el.style.fontSize = "8px";
      });
      clonedElement.querySelectorAll(".rf_titulo_pdf").forEach((el) => {
        el.style.fontSize = "12px";
      });
      clonedElement
        .querySelectorAll(".rf_titulo_destaque_pdf")
        .forEach((el) => {
          el.style.fontSize = "12px";
        });

      // Configurações otimizadas para html2pdf
      const options = {
        margin: 0,
        filename: "proposta-comercial.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          letterRendering: true,
          allowTaint: true
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "landscape",
          compress: true
        },
        pagebreak: {
          avoid: ".avoid-break",
          before: ".page-break-before",
          after: ".page-break-after"
        }
      };

      // Adicione temporariamente o elemento clonado ao corpo
      document.body.appendChild(clonedElement);

      // Gere o PDF
      html2pdf()
        .from(clonedElement)
        .set(options)
        .save()
        .then(() => {
          // Remova o elemento clonado após a geração
          document.body.removeChild(clonedElement);
        });
    },
    generatePdf() {
      const element = this.$refs.contentToPrint;

      // Primeiro, faça um clone do elemento para evitar alterar o DOM original
      const clonedElement = element.cloneNode(true);

      // Aplique estilos temporários apenas para o PDF
      clonedElement.style.width = "297mm";
      clonedElement.style.height = "210mm";
      clonedElement.style.margin = "0";
      clonedElement.style.padding = "5mm";
      clonedElement.style.boxSizing = "border-box";

      // Ajuste os tamanhos de fonte para o PDF
      clonedElement.querySelectorAll(".rf_texto_pdf").forEach((el) => {
        el.style.fontSize = "8px";
      });
      clonedElement.querySelectorAll(".rf_titulo_pdf").forEach((el) => {
        el.style.fontSize = "12px";
      });
      clonedElement
        .querySelectorAll(".rf_titulo_destaque_pdf")
        .forEach((el) => {
          el.style.fontSize = "12px";
        });

      // Configurações otimizadas para html2pdf
      const options = {
        margin: 0,
        filename: "proposta-comercial.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          letterRendering: true,
          allowTaint: true
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "landscape",
          compress: true
        },
        pagebreak: {
          avoid: ".avoid-break",
          before: ".page-break-before",
          after: ".page-break-after"
        }
      };

      // Adicione temporariamente o elemento clonado ao corpo
      document.body.appendChild(clonedElement);

      // Gere o PDF
      html2pdf()
        .from(clonedElement)
        .set(options)
        .save()
        .then(() => {
          // Remova o elemento clonado após a geração
          document.body.removeChild(clonedElement);
        });
    },

    async carregarDadosMenu() {
      try {
        const id = this.id_proposta;

        const response = await fetch(
          `${process.env.VUE_APP_API_URL}gerar_menu/${id}`,
          {
            method: "post",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: id
            })
          }
        );

        if (!response.ok) {
          throw Error(response.status);
        }
        const data = await response.json();
        const createdAt = data?.data?.rows[0]?.createdAt;

        console.log("Dados para gerar o menu", data);
        this.limpar_pagamento_vista();
        this.metodo_pagamento = "Financiamento";
        const cliente = data?.data?.rows[0]?.clientes || {};
        const veiculo = data?.data?.rows[0]?.proposta_veiculo || {};
        const veiculoAvaliacao = data?.data?.rows[0]?.veiculos_usados || {};

        // Informações do Cliente
        this.g_menu_cliente = cliente.nome ?? "";
        this.g_menu_cpfCnpj = cliente.cpfCnpj ?? "";
        this.g_menu_fone = cliente.tel ?? "";
        this.g_menu_fone2 = cliente.cel ?? "";
        this.g_menu_email = cliente.email ?? "";

        // Informações da Proposta
        this.g_menu_gerente = data?.data?.rows[0]?.gerentes?.username ?? "";
        this.g_menu_vendedor =
          data?.data?.rows[0]?.proposta_vendedores?.username ?? "";
        this.g_menu_negociacao = data?.data?.rows[0]?.id ?? "";
        this.g_menu_data_negociacao = createdAt
          ? new Date(createdAt).toLocaleDateString("pt-BR")
          : "";

        // Opções de Compra
        this.g_menu_val_sugerido = this.currency(
          parseFloat(data?.data?.rows[0]?.proposta_veiculo.valor_veiculo ?? 0) +
            parseFloat(data?.data?.rows[0]?.custos_variaveis ?? 0) +
            parseFloat(data?.data?.rows[0]?.adicional ?? 0)
        );
        this.g_menu_val_desconto = this.currency(
          data?.data?.rows[0]?.desconto ?? 0
        );
        // this.g_menu_val_veiculo = this.currency(
        //   parseFloat(data?.data?.rows[0]?.val_sugerido_venda ?? 0) +
        //   parseFloat(data?.data?.rows[0]?.custos_variaveis ?? 0) +
        //   parseFloat(data?.data?.rows[0]?.acessorios ?? 0) +
        //   parseFloat(data?.data?.rows[0]?.adicional ?? 0)
        // );
        this.g_menu_val_veiculo = this.currency(
          parseFloat(data?.data?.rows[0]?.proposta_veiculo.valor_veiculo ?? 0) +
            parseFloat(data?.data?.rows[0]?.custos_variaveis ?? 0) +
            parseFloat(data?.data?.rows[0]?.adicional ?? 0) -
            parseFloat(data?.data?.rows[0]?.desconto ?? 0)
        );
        this.g_menu_total_financiado = this.currency(
          parseFloat(data?.data?.rows[0]?.val_financiamento ?? 0) +
            parseFloat(data?.data?.rows[0]?.val_entrada_financiamento ?? 0)
        );

        // Dados veiculo compra
        this.g_menu_marca = veiculo.marca ?? "";
        this.g_menu_modelo = veiculo.modelo_veiculo ?? "";
        this.g_menu_cor = veiculo.cor ?? "";
        this.g_menu_chassi = veiculo.chassis ?? "";
        this.g_menu_ano_modelo = veiculo.ano_modelo ?? "";
        this.g_menu_ano_fab = veiculo.ano_fabricacao ?? "";
        this.g_menu_placa = veiculo.placa ?? "";

        // Dados veiculo troca
        this.g_menu_marca_avaliacao =
          veiculoAvaliacao.modeloVeiculo?.familiaVeiculo?.marcaVeiculo
            ?.descricao ?? "";
        this.g_menu_placa_avaliacao = veiculoAvaliacao.placa ?? "";
        this.g_menu_modelo_avaliacao =
          veiculoAvaliacao.modeloVeiculo?.descricao ?? "";
        this.g_menu_ano_modelo_avaliacao = veiculoAvaliacao.anoModelo ?? "";
        this.g_menu_valor_avaliado = this.Valor_Avaliado ?? 0;
        this.g_menu_itens_avaliacao_db = this.Valor_Itens_Avaliacao_db ?? 0;
        this.g_menu_itens_avaliacao_cr = this.Valor_Itens_Avaliacao_cr ?? 0;
        this.g_menu_valor_avaliacao_final = this.Valor_Avaliacao_Final ?? 0;
        this.calcular_entrada_gerar_menu();
        // Acessorios
        this.g_menu_total_acessorios = this.Valor_Itens_Acessorios;
        this.itens_acessorios = data?.data?.rows[0]?.acessorios_proposta ?? [];

        if (this.incluir_acessorios == true) {
          this.msg = "Valor incluso no financiamento!";
        } else {
          this.msg = "Valor não incluso no financiamento!";
        }
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      }
    },
    async carregarDadosMenuVista() {
      try {
        const id = this.id_proposta;

        const response = await fetch(
          `${process.env.VUE_APP_API_URL}gerar_menu/${id}`,
          {
            method: "post",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: id
            })
          }
        );

        if (!response.ok) {
          throw Error(response.status);
        }

        const data = await response.json();
        const createdAt = data?.data?.rows[0]?.createdAt;

        console.log("Dados Menu a Vista", data);

        //this.limpar_financiamento();
        const cliente = data?.data?.rows[0]?.clientes || {};
        const veiculo = data?.data?.rows[0]?.proposta_veiculo || {};
        const veiculoAvaliacao = data?.data?.rows[0]?.veiculos_usados || {};

        // Informações do Cliente
        this.g_menu_cliente = cliente.nome ?? "";
        this.g_menu_cpfCnpj = cliente.cpfCnpj ?? "";
        this.g_menu_fone = cliente.tel ?? "";
        this.g_menu_fone2 = cliente.cel ?? "";
        this.g_menu_email = cliente.email ?? "";

        // Informações da Proposta
        this.g_menu_gerente = data?.data?.rows[0]?.gerentes?.username ?? "";
        this.g_menu_vendedor =
          data?.data?.rows[0]?.proposta_vendedores?.username ?? "";
        this.g_menu_negociacao = data?.data?.rows[0]?.id ?? "";
        this.g_menu_data_negociacao = createdAt
          ? new Date(createdAt).toLocaleDateString("pt-BR")
          : "";

        // Opções de Compra
        this.g_menu_val_sugerido = this.currency(
          parseFloat(data?.data?.rows[0]?.proposta_veiculo.valor_veiculo ?? 0) +
            parseFloat(data?.data?.rows[0]?.custos_variaveis ?? 0) +
            parseFloat(data?.data?.rows[0]?.adicional ?? 0)
        );
        this.g_menu_val_desconto = this.currency(
          data?.data?.rows[0]?.desconto ?? 0
        );
        // this.g_menu_val_veiculo = this.currency(
        //   parseFloat(data?.data?.rows[0]?.val_sugerido_venda ?? 0) +
        //   parseFloat(data?.data?.rows[0]?.custos_variaveis ?? 0) +
        //   parseFloat(data?.data?.rows[0]?.acessorios ?? 0) +
        //   parseFloat(data?.data?.rows[0]?.adicional ?? 0)
        // );
        this.g_menu_val_veiculo = this.currency(
          parseFloat(data?.data?.rows[0]?.proposta_veiculo.valor_veiculo ?? 0) +
            parseFloat(data?.data?.rows[0]?.custos_variaveis ?? 0) +
            parseFloat(data?.data?.rows[0]?.adicional ?? 0) -
            parseFloat(data?.data?.rows[0]?.desconto ?? 0)
        );
        this.g_menu_total_financiado = this.currency(
          parseFloat(data?.data?.rows[0]?.val_financiamento ?? 0) +
            parseFloat(data?.data?.rows[0]?.val_entrada_financiamento ?? 0)
        );

        // Dados veiculo compra
        this.g_menu_marca = veiculo.marca ?? "";
        this.g_menu_modelo = veiculo.modelo_veiculo ?? "";
        this.g_menu_cor = veiculo.cor ?? "";
        this.g_menu_chassi = veiculo.chassis ?? "";
        this.g_menu_ano_modelo = veiculo.ano_modelo ?? "";
        this.g_menu_ano_fab = veiculo.ano_fabricacao ?? "";
        this.g_menu_placa = veiculo.placa ?? "";

        // Dados veiculo troca
        this.g_menu_marca_avaliacao =
          veiculoAvaliacao.modeloVeiculo?.familiaVeiculo?.marcaVeiculo
            ?.descricao ?? "";
        this.g_menu_placa_avaliacao = veiculoAvaliacao.placa ?? "";
        this.g_menu_modelo_avaliacao =
          veiculoAvaliacao.modeloVeiculo?.descricao ?? "";
        this.g_menu_ano_modelo_avaliacao = veiculoAvaliacao.anoModelo ?? "";
        this.g_menu_valor_avaliado = this.Valor_Avaliado ?? 0;
        this.g_menu_itens_avaliacao_db = this.Valor_Itens_Avaliacao_db ?? 0;
        this.g_menu_itens_avaliacao_cr = this.Valor_Itens_Avaliacao_cr ?? 0;
        this.g_menu_valor_avaliacao_final = this.Valor_Avaliacao_Final ?? 0;
        this.calcular_entrada_gerar_menu();
        // Acessorios
        this.g_menu_total_acessorios = this.Valor_Itens_Acessorios;
        this.itens_acessorios = data?.data?.rows[0]?.acessorios_proposta ?? [];

        if (this.incluir_acessorios == true) {
          this.msg = "Valor incluso no financiamento!";
        } else {
          this.msg = "Valor não incluso no financiamento!";
        }
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      }
    },

    formatarValor(valor) {
      console.log("Valor obtido");

      this.entrada_1_original = this.entrada_1;
      this.entrada_2_original = this.entrada_2;
      this.entrada_3_original = this.entrada_3;

      if (!valor) return "";
      valor = valor.toString().replace(/\D/g, "");
      valor = (valor / 100).toFixed(2).replace(".", ",");
      valor = valor.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      return valor;
    },
    formatarKM(numero) {
      // Converter para string e remover quaisquer caracteres não numéricos
      const numeroString = numero.toString().replace(/\D/g, "");

      // Adicionar ponto a cada três dígitos, começando da direita
      const numeroFormatado = numeroString.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        "."
      );

      return numeroFormatado;
    },
    calcular_perc_1() {
      let calc_entrada1 = this.entrada_1_perc / 100;
      //let valor_original = this.valor_sugerido_original;
      let valor_original = this.Valor_Total_Venda
        ? parseFloat(
            this.Valor_Total_Venda.replace(/[^\d,]+/g, "").replace(",", ".")
          )
        : 0;
      this.entrada_1 = this.currency(valor_original * calc_entrada1);
    },
    calcular_perc_2() {
      let calc_entrada2 = this.entrada_2_perc / 100;
      let valor_original = this.Valor_Total_Venda
        ? parseFloat(
            this.Valor_Total_Venda.replace(/[^\d,]+/g, "").replace(",", ".")
          )
        : 0;
      this.entrada_2 = this.currency(valor_original * calc_entrada2);
    },
    calcular_perc_3() {
      let calc_entrada3 = this.entrada_3_perc / 100;
      let valor_original = this.Valor_Total_Venda
        ? parseFloat(
            this.Valor_Total_Venda.replace(/[^\d,]+/g, "").replace(",", ".")
          )
        : 0;
      this.entrada_3 = this.currency(valor_original * calc_entrada3);
    },
    calcular_real_1() {
      // Garante que entrada_1_perc sempre terá um valor válido
      this.entrada_1_perc = "0.00";

      if (this.entrada_1 && this.entrada_1.trim() !== "") {
        try {
          // Converte valores com tratamento de erros
          const parseValor = (valor) => {
            if (!valor) return 0;
            const cleaned = String(valor)
              .replace(/[^\d,]+/g, "")
              .replace(",", ".");
            return isNaN(parseFloat(cleaned)) ? 0 : parseFloat(cleaned);
          };

          const valor_original = parseValor(this.Valor_Total_Venda);
          const valor_numerico = parseValor(this.entrada_1);
          const valor_avaliacao = parseValor(this.valor_avaliacao);

          // Evita divisão por zero
          const divisor = valor_original || 1; // Se valor_original for 0, usa 1 para evitar NaN

          const entrada_perc =
            ((valor_numerico + valor_avaliacao) / divisor) * 100;

          // Garante que o resultado seja um número válido
          this.entrada_1_perc = isNaN(entrada_perc)
            ? "0.00"
            : Math.max(0, parseFloat(entrada_perc.toFixed(2))); // Não permite valores negativos

          this.entrada_perc_1_padronizada = this.configurar_taxas(
            parseFloat(this.entrada_1_perc),
            "entrada_1",
            "entrada_1_perc"
          );
        } catch (e) {
          console.error("Erro no cálculo:", e);
          this.entrada_1_perc = "0.00";
        }
      }
    },
    calcular_real_2() {
      this.entrada_2_perc = "0.00";

      if (this.entrada_2 && this.entrada_2.trim() !== "") {
        try {
          // Converte valores com tratamento de erros
          const parseValor = (valor) => {
            if (!valor) return 0;
            const cleaned = String(valor)
              .replace(/[^\d,]+/g, "")
              .replace(",", ".");
            return isNaN(parseFloat(cleaned)) ? 0 : parseFloat(cleaned);
          };

          const valor_original = parseValor(this.Valor_Total_Venda);
          const valor_numerico = parseValor(this.entrada_2);
          const valor_avaliacao = parseValor(this.valor_avaliacao);

          // Evita divisão por zero
          const divisor = valor_original || 1; // Se valor_original for 0, usa 1 para evitar NaN

          const entrada_perc =
            ((valor_numerico + valor_avaliacao) / divisor) * 100;

          // Garante que o resultado seja um número válido
          this.entrada_2_perc = isNaN(entrada_perc)
            ? "0.00"
            : Math.max(0, parseFloat(entrada_perc.toFixed(2))); // Não permite valores negativos

          this.entrada_perc_2_padronizada = this.configurar_taxas(
            parseFloat(this.entrada_2_perc),
            "entrada_2",
            "entrada_2_perc"
          );
        } catch (e) {
          console.error("Erro no cálculo:", e);
          this.entrada_1_perc = "0.00";
        }
      }
    },
    calcular_real_3() {
      this.entrada_3_perc = "0.00";

      if (this.entrada_3 && this.entrada_3.trim() !== "") {
        try {
          // Converte valores com tratamento de erros
          const parseValor = (valor) => {
            if (!valor) return 0;
            const cleaned = String(valor)
              .replace(/[^\d,]+/g, "")
              .replace(",", ".");
            return isNaN(parseFloat(cleaned)) ? 0 : parseFloat(cleaned);
          };

          const valor_original = parseValor(this.Valor_Total_Venda);
          const valor_numerico = parseValor(this.entrada_3);
          const valor_avaliacao = parseValor(this.valor_avaliacao);

          // Evita divisão por zero
          const divisor = valor_original || 1; // Se valor_original for 0, usa 1 para evitar NaN

          const entrada_perc =
            ((valor_numerico + valor_avaliacao) / divisor) * 100;

          // Garante que o resultado seja um número válido
          this.entrada_3_perc = isNaN(entrada_perc)
            ? "0.00"
            : Math.max(0, parseFloat(entrada_perc.toFixed(2))); // Não permite valores negativos

          this.entrada_perc_3_padronizada = this.configurar_taxas(
            parseFloat(this.entrada_3_perc),
            "entrada_3",
            "entrada_3_perc"
          );
        } catch (e) {
          console.error("Erro no cálculo:", e);
          this.entrada_1_perc = "0.00";
        }
      }
    },

    calcular_entrada_gerar_menu() {
      let valor_original = this.Valor_Entrada
        ? parseFloat(
            this.Valor_Entrada.replace(/[^\d,]+/g, "").replace(",", ".")
          )
        : 0;
      let valor_numerico = this.g_menu_valor_avaliacao_final
        ? parseFloat(
            this.g_menu_valor_avaliacao_final
              .replace(/[^\d,]+/g, "")
              .replace(",", ".")
          )
        : 0;

      let entrada_perc = valor_original - valor_numerico;

      this.entrada_escolhida = parseFloat(entrada_perc).toFixed(2);
    },

    async grava_info_adicional() {
      const id = this.id_proposta;
      await fetch(
        `${process.env.VUE_APP_API_URL}proposta_info_adicionais/${id}`,
        {
          method: "PUT",

          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: id,
            info_adicional: this.info_adicionais
          })
        }
      )
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          return data.json();
        })
        .then((resposta) => {
          if (resposta.StatusOk == 200) {
            this.abrir_modal = true;
            this.msg = resposta.message;
            setTimeout(() => (this.abrir_modal = false), 4000);
          }
        });
    },
    async atualizar_cliente() {
      const id = this.id_cliente;
      // Crie um objeto para armazenar mensagens de erro
      const erros = {};

      // Verifique cada campo obrigatório
      if (!this.cliente) {
        erros.cliente = "Campo 'Cliente' é obrigatório.";
      }
      if (!this.cpfCnpj) {
        erros.cpfCnpj = "Campo 'CPF/CNPJ' é obrigatório.";
      }
      if (!this.endereco) {
        erros.endereco = "Campo 'Endereço' é obrigatório.";
      }
      if (!this.uf) {
        erros.uf = "Campo 'UF' é obrigatório.";
      }
      if (!this.cidade) {
        erros.cidade = "Campo 'Cidade' é obrigatório.";
      }
      if (!this.bairro) {
        erros.bairro = "Campo 'Bairro' é obrigatório.";
      }
      if (!this.cep) {
        erros.cep = "Campo 'CEP' é obrigatório.";
      }
      if (!this.tel) {
        erros.tel = "Campo 'Telefone' é obrigatório.";
      }

      // Verifique se há erros
      if (Object.keys(erros).length > 0) {
        this.abrir_modal = true;
        this.msg = "Por favor, preencha os campos obrigatórios:";

        // Construa a mensagem de erro com detalhes
        for (const campo in erros) {
          this.msg += `\n${erros[campo]}`;
        }

        setTimeout(() => (this.abrir_modal = false), 4000);
        return;
      }

      await fetch(`${process.env.VUE_APP_API_URL}cliente_proposta/${id}`, {
        method: "PUT",

        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: id,
          nome: this.cliente,
          cpfCnpj: this.cpfCnpj,
          nascimento: this.dataNascimento,
          email: this.email,
          endereco: this.endereco,
          complemento: this.complemento,
          uf: this.uf,
          cidade: this.cidade,
          bairro: this.bairro,
          cep: this.cep,
          tel: this.tel,
          cel: this.cel
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          return data.json();
        })
        .then((resposta) => {
          if (resposta.StatusOk == 200) {
            this.abrir_modal = true;
            this.msg = resposta.message;
            setTimeout(() => (this.abrir_modal = false), 4000);
          }
        });
    },

    validando_tempo() {
      let hour = 0;
      let minute = 0;
      let second = 0;
      let tempo_atendimento;
      let tempo_espera;
      let avaliacao;

      setInterval(() => {
        var array_h_1 = [];
        var array_h_2 = [];
        let horas_chegada;
        let minutos_chegada;
        let segundos_chegada;
        let horas_atendimento;
        let minutos_atendimento;
        let segundos_atendimento;

        for (var i = 0; i < this.propostas_at.length; i++) {
          if (
            this.propostas_at[i]["status"] == "Atendimento" ||
            this.propostas_at[i]["status"] == "Atendimento Excedido"
          ) {
            horas_atendimento = this.propostas_at[i]["horas_atendimento"];
            minutos_atendimento = this.propostas_at[i]["minutos_atendimento"];
            segundos_atendimento = second;

            horas_atendimento = parseInt(horas_atendimento) + parseInt(hour);

            minutos_atendimento =
              parseInt(minutos_atendimento) + parseInt(minute);

            horas_atendimento =
              horas_atendimento < 10
                ? "0" + horas_atendimento
                : horas_atendimento;
            minutos_atendimento =
              minutos_atendimento < 10
                ? "0" + minutos_atendimento
                : minutos_atendimento;
            segundos_atendimento =
              segundos_atendimento < 10
                ? "0" + segundos_atendimento
                : segundos_atendimento;
            tempo_espera = "00:00";

            tempo_atendimento = horas_atendimento + ":" + minutos_atendimento;
          }
          if (this.propostas_at[i]["status"] == "Aguardando Atendimento") {
            horas_chegada = this.propostas_at[i]["horas_chegada"];
            minutos_chegada = this.propostas_at[i]["minutos_chegada"];
            segundos_chegada = second;
            horas_chegada = parseInt(horas_chegada) + parseInt(hour);
            minutos_chegada = parseInt(minutos_chegada) + parseInt(minute);
            horas_chegada =
              horas_chegada < 10 ? "0" + horas_chegada : horas_chegada;
            minutos_chegada =
              minutos_chegada < 10 ? "0" + minutos_chegada : minutos_chegada;
            segundos_chegada =
              segundos_chegada < 10 ? "0" + segundos_chegada : segundos_chegada;

            tempo_espera = horas_chegada + ":" + minutos_chegada;
            tempo_atendimento = "00:00";
          }
          if (
            this.propostas_at[i]["status"] == "Venda Finalizada" ||
            this.propostas_at[i]["status"] == "Venda Perdida"
          ) {
            tempo_espera = "00:00";
            tempo_atendimento = "00:00";
            //this.open_proposta = false;
          }
          if (this.propostas_at[i]["avaliacao"] == 0) {
            avaliacao = "Não";
          }
          if (this.propostas_at[i]["avaliacao"] == 1) {
            avaliacao = "Sim";
          }

          array_h_1 = {
            acessorios: this.propostas_at[i]["acessorios"],
            adicional: this.propostas_at[i]["adicional"],
            avaliacao: avaliacao,
            avaliacaoVeiculo_id: this.propostas_at[i]["avaliacaoVeiculo_id"],
            avaliacoes_veiculo: this.propostas_at[i]["avaliacoes_veiculo"],
            cliente_id: this.propostas_at[i]["cliente_id"],
            cliente: this.propostas_at[i]["cliente"],
            cortesia: this.propostas_at[i]["cortesia"],
            custos_variaveis: this.propostas_at[i]["custos_variaveis"],
            desconto: this.propostas_at[i]["desconto"],
            empresa_id: this.propostas_at[i]["empresa_id"],
            gerente_id: this.propostas_at[i]["gerente_id"],
            gerente: this.propostas_at[i]["gerente"],
            id: this.propostas_at[i]["id"],
            id_vendedor_fila: this.propostas_at[i]["id_vendedor_fila"],
            impostos: this.propostas_at[i]["impostos"],
            justificativa: this.propostas_at[i]["justificativa"],
            midia_id: this.propostas_at[i]["midia_id"],
            modelo_id: this.propostas_at[i]["modelo_id"],
            modelo_veiculos: this.propostas_at[i]["modelo_veiculos"],
            obs: this.propostas_at[i]["obs"],
            propostaVeiculo_id: this.propostas_at[i]["propostaVeiculo_id"],
            proposta_veiculo: this.propostas_at[i]["proposta_veiculo"],
            retorno: this.propostas_at[i]["retorno"],
            status: this.propostas_at[i]["status"],
            tipo_pagamento: this.propostas_at[i]["tipo_pagamento"],
            user_id: this.propostas_at[i]["user_id"],
            usuarios: this.propostas_at[i]["usuarios"],
            veiculoUsado_id: this.propostas_at[i]["veiculoUsado_id"],
            veiculos_usados: this.propostas_at[i]["veiculos_usados"],
            vendedor_id: this.propostas_at[i]["vendedor_id"],
            vendedor: this.propostas_at[i]["vendedor"],
            monetario_lucro: this.propostas_at[i]["monetario_lucro"],
            percentual_lucro: this.propostas_at[i]["percentual_lucro"],
            monetario_margem: this.propostas_at[i]["monetario_margem"],
            percentual_margem: this.propostas_at[i]["percentual_margem"],
            modelo: this.propostas_at[i]["modelo"],
            //tempo_espera: this.propostas_at[i]["tempo_espera"],
            //tempo_atendimento: this.propostas_at[i]["tempo_atendimento"],
            gerados: this.propostas_at[i]["gerados"],
            motivo_perda: this.propostas_at[i]["motivo_perda"],
            horas_chegada: this.propostas_at[i]["horas_chegada"],
            minutos_chegada: this.propostas_at[i]["minutos_chegada"],
            segundos_chegada: segundos_chegada,
            horas_atendimento: this.propostas_at[i]["horas_atendimento"],
            minutos_atendimento: this.propostas_at[i]["minutos_atendimento"],
            segundos_atendimento: segundos_atendimento,
            cpfCnpj: this.propostas_at[i]["cpfCnpj"],
            nome: this.propostas_at[i]["nome"],
            email: this.propostas_at[i]["email"],
            tel: this.propostas_at[i]["tel"],
            tempo_espera: tempo_espera,
            tempo_atendimento: tempo_atendimento
          };
          array_h_2.push(array_h_1);
        }
        second++;
        if (second == 60) {
          second = 0;
          minute++;
        }
        if (minute == 60) {
          minute = 0;
          hour++;
        }

        this.propostas_at = array_h_2;
      }, 1000);
    },
    getRequestParams(searchTitle, page, pageSize, empresa_id) {
      let params = {};
      if (searchTitle) {
        params["nome"] = searchTitle;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (empresa_id) {
        params["empresa_id"] = empresa_id;
      }
      return params;
    },

    async retrieveFamilia(id) {
      try {
        const params = this.getRequestParams(
          //this.searchTitle,
          id,
          this.page,
          this.pageSize
        );

        userService.getFamilia(params).then((response) => {
          const { familia_veiculo, totalPages } = response.data;
          this.familia = familia_veiculo;
          this.totalPages = totalPages;

          console.log(
            "Familia ----------------------------------------------------------------------------------------------------------------- 0009"
          );
          console.log(response.data);
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      }
    },

    async retrieveModelo(id) {
      try {
        const params = this.getRequestParams(
          //this.searchTitle,
          id,
          this.page,
          (this.pageSize = 1000)
        );

        userService.getModelo(params).then((response) => {
          const { modelo_veiculo, totalPages } = response.data;
          this.modelo = modelo_veiculo;
          this.totalPages = totalPages;

          console.log(
            "Modelos ----------------------------------------------------------------------------------------------------------------- 0010"
          );
          console.log(response.data);
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      }
    },
    async retrieveMarca() {
      try {
        const params = this.getRequestParams(
          this.searchTitle,
          this.page,
          (this.pageSize = 10000)
        );
        userService.getMarca(params).then((response) => {
          const { marcas, totalPages } = response.data;
          this.marca = marcas;
          this.totalPages = totalPages;
          console.log(
            "Marcas ---------------------------------------------------------------------------------------------------------------------------- 0011"
          );
          console.log(this.marca);
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      }
    },
    habilitar_itens_avaliacao() {
      this.modal_itens_avaliacao = true;
      const modalElement = document.getElementById("ModalVeiculoAvaliacao");
      const modalInstance = new Modal(modalElement); // Use o Modal diretamente
      modalInstance.show();
    },
    fechar_modal_avaliacao() {
      const modalElement = document.getElementById("ModalVeiculoAvaliacao");
      const modalInstance = Modal.getInstance(modalElement); // Use o Modal diretamente
      modalInstance.hide();
    },
    habilitar_historico_cliente() {
      this.modal_historico_cliente = true;
    },

    async historico_cliente(id) {
      try {
        console.log("Buscando histórico do Cliente", id);

        // Iniciar o processo de carregamento
        this.loading = true;
        this.error = null; // Limpar erros prévios

        const historico = await axios.get(
          `${process.env.VUE_APP_API_URL}historico_cliente/${id}`,
          {
            params: { id: id }
          }
        );

        // Armazenar os dados recebidos
        this.hist_cliente = historico.data.propostas;
        console.log(this.hist_cliente);
      } catch (error) {
        if (error.response) {
          switch (error.response.status) {
            case 503:
              this.abrir_modal = true;
              this.msg = `Erro ao conectar ao banco de dados. Detalhes: ${error.response.data.message}`;
              break;
            case 400:
              this.abrir_modal = true;
              this.msg = `Dados inválidos fornecidos. Verifique as entradas. Detalhes: ${error.response.data.message}`;
              break;
            case 500:
              this.abrir_modal = true;
              this.msg = `Erro interno no servidor. Por favor, tente novamente mais tarde. Detalhes: ${error.response.data.message}`;
              break;
            default:
              this.abrir_modal = true;
              this.msg = `Ocorreu um erro inesperado. Código do erro: ${error.response.status}. Detalhes: ${error.response.data.message}`;
          }
          // Exibir o modal por 8 segundos antes de fechá-lo
          setTimeout(() => (this.abrir_modal = false), 8000);
        } else {
          // Tratamento para caso a resposta do servidor não seja recebida
          this.abrir_modal = true;
          this.msg =
            "Erro não identificado, entre em coctato com o administrador do sistema.";
          setTimeout(() => (this.abrir_modal = false), 8000);
        }

        // if (error.response.status == 500) {
        //   this.abrir_modal = true;
        //   this.msg = `Erro ao conectar ao banco de dados. Detalhes: ${error.response.data.message}`;
        //   setTimeout(() => (this.abrir_modal = false), 8000);
        // }

        // if (error.response && error.response.status === 500) {
        //   // Captura a mensagem de erro do backend
        //   const serverMessage = error.response.data.message || "Erro interno no servidor.";

        //   // Define uma mensagem personalizada para o usuário
        //   this.error = `Falha ao conectar ao servidor: ${serverMessage}`;
        // } else {
        //   // Define uma mensagem genérica para outros tipos de erro
        //   this.error = "Ocorreu um erro. Tente novamente mais tarde.";
        // }

        // // Exibe o erro no console para fins de debug
        // console.error("Erro na requisição:", error);
      } finally {
        // Finalizar o processo de carregamento
        this.loading = false;
      }
    },

    async retrieveItensVeiculo() {
      try {
        const id_proposta = this.id_proposta;
        userService.getItensId(id_proposta).then((response) => {
          var itens_av = [];
          var itens_av2 = [];
          const { rows } = response.data;

          for (var i = 0; i < rows.length; i++) {
            var arr_it = {
              id: rows[i]["id"],
              proposta_id: rows[i]["proposta_id"],
              item: rows[i]["item"],
              tipo: rows[i]["tipo"],
              valor: this.currency(rows[i]["valor"]),
              status: rows[i]["status"],
              createdAt: rows[i]["createdAt"],
              updatedAt: rows[i]["updatedAt"]
            };
            itens_av = arr_it;
            itens_av2.push(itens_av);
          }

          this.itens_veiculo = itens_av2;
          console.log(
            " Itens de Avaliação ------------------------------------------------------------------------------------------------------------------ 0012"
          );
          console.log(itens_av2);
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      }
    },
    async retrieveVeiculosAvaliacao() {
      try {
        const id_proposta = this.id_proposta;
        console.log("Veiculos de Avaliação -----------", id_proposta);
        userService.getVeiculosAvaliacaoId(id_proposta).then((response) => {
          var veiculo_av = [];
          var veiculo_av2 = [];
          const { rows } = response.data;
          const TotalAvaliacoes = response.data.totalPrecoAvaliacao;
          this.valor_avaliacao = TotalAvaliacoes;

          for (var i = 0; i < rows.length; i++) {
            var arr_it = {
              marca: rows[i]["veiculo_usado_avaliacao"]["marca"],
              modelo: rows[i]["veiculo_usado_avaliacao"]["modelo"],
              placa: rows[i]["veiculo_usado_avaliacao"]["placa"],
              preco_avaliado: this.currency(rows[i]["precoAvaliacao"]),
              preco_quitacao: this.currency(rows[i]["quitacao"]),
              cor: rows[i]["veiculo_usado_avaliacao"]["cor"],
              kilometragem: rows[i]["veiculo_usado_avaliacao"]["kilometragem"],
              ano_mod: rows[i]["veiculo_usado_avaliacao"]["anoModelo"]
            };
            veiculo_av = arr_it;
            veiculo_av2.push(veiculo_av);
          }

          this.veiculos_avaliados = veiculo_av2;
          console.log("veiculos_avaliados");
          console.log(this.veiculos_avaliados);
          console.log(this.valor_avaliacao);
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      }
    },
    async onSubmitItensAvaliacao() {
      const response = await fetch(
        `${process.env.VUE_APP_API_URL}itens_avaliacao`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            item: this.item_p_avaliacao,
            valor: this.valor_p_avaliacao,
            tipo: this.tipo,
            proposta_id: this.id_proposta
          })
        }
      );

      const resp = JSON.stringify(response.status);
      if (resp == 200) {
        console.log(
          "Metodo para inserir itens de avaliação ------------------------------------------------------------------------------------------------------------------ 0013"
        );
        this.modal = true;
        this.dialog = true;
        // Limpar Fomulário
        this.item_p_avaliacao = "";
        this.valor_p_avaliacao = "";
        this.tipo = "";
        this.abrir_modal = true;
        this.msg = "Item inserido com sucesso!";
        setTimeout(() => (this.abrir_modal = false), 4000);
        this.retrieveItensVeiculo();
      } else {
        this.modal = true;
        this.dialog = true;
        this.item_p_avaliacao = "";
        this.valor_p_avaliacao = "";
        this.tipo = "";
        this.msg = "Erro ao inserir o item";
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },
    async onSubmitVeiculoAvaliacao() {
      try {
        const id_userCad = this.$store.state.auth.user.id;
        // Função para converter string formatada para número
        const parseCurrency = (value) => {
          if (!value) return 0;
          // Remove pontos, converte vírgula em ponto e parse para float
          return parseFloat(value.replace(/\./g, "").replace(",", "."));
        };
        if (this.lastClicked === "insert") {
          if (!this.placa_av) {
            this.placaCorBorda = "red";
            return;
          } else {
            this.placaCorBorda = "green";
          }
          if (!this.marcaSelecionada) {
            this.marcaCorBorda = "red";
            return;
          } else {
            this.marcaCorBorda = "green";
          }
          if (!this.modeloSelecionado) {
            this.modeloCorBorda = "red";
            return;
          } else {
            this.modeloCorBorda = "green";
          }
          if (!this.anoModelo_av) {
            this.anoModeloCorBorda = "red";
            return;
          } else {
            this.anoModeloCorBorda = "green";
          }
          if (!this.cor_av) {
            this.corCorBorda = "red";
            return;
          } else {
            this.corCorBorda = "green";
          }
          if (!this.kilometragem_av) {
            this.kilometragemCorBorda = "red";
            console.log("preencha o km");
            return;
          } else {
            this.kilometragemCorBorda = "green";
          }
          if (!this.valor_av) {
            this.valorAvaliadoCorBorda = "red";
            return;
          } else {
            this.valorAvaliadoCorBorda = "green";
          }
          if (!this.valor_quitacao) {
            this.valorQuitacaoCorBorda = "red";
            return;
          } else {
            this.valorQuitacaoCorBorda = "green";
          }
          // Converter os valores formatados para números
          const valorAv = parseCurrency(this.valor_av);
          const valorQuitacao = parseCurrency(this.valor_quitacao);

          await fetch(`${process.env.VUE_APP_API_URL}veiculo_usado`, {
            method: "POST",

            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              marca: this.marcaSelecionada,
              modelo: this.modeloSelecionado,
              placa: this.placa_av,
              precoAvaliacao: this.currency(valorAv),
              quitacao: this.currency(valorQuitacao),
              kilometragem: this.kilometragem_av,
              anoModelo: this.anoModelo_av,
              avaliador_id: id_userCad,
              veiculoUsado_id: this.veiculoUsado_id,
              proposta_id: this.id_proposta,
              empresa_id: this.company_id,
              cor: this.cor_av,
              obs: this.obs_av,
              status: 1
            })
          })
            .then((response) => {
              if (!response.ok) {
                return response.json().then((error) => {
                  this.abrir_modal = true;
                  this.msg = error.message;
                  setTimeout(() => (this.abrir_modal = false), 4000);
                });
              }
              return response.json();
            })
            .then((data) => {
              this.abrir_modal = true;
              this.msg = data.message;
              setTimeout(() => (this.abrir_modal = false), 4000);
              this.limpar_form_av();
              this.retrieveVeiculosAvaliacao();
              this.inserir_veiculo = false; //Habilita inserir veiculo para compra
              this.inserir_item_avaliacao = false; //Habilita inseir itens para avaliação
              this.fechar_modal_avaliacao();
            })
            .catch((error) => {
              console.error("Erro na requisição:", error);
              this.abrir_modal = true;
              this.msg = "Formmato da Placa está incorreto";
              setTimeout(() => (this.abrir_modal = false), 4000);
            });
        } else if (this.lastClicked === "update") {
          if (!this.placa_av) {
            this.placaCorBorda = "red";
            return;
          } else {
            this.placaCorBorda = "green";
          }
          if (!this.marcaSelecionada) {
            this.marcaCorBorda = "red";
            return;
          } else {
            this.marcaCorBorda = "green";
          }
          if (!this.modeloSelecionado) {
            this.modeloCorBorda = "red";
            return;
          } else {
            this.modeloCorBorda = "green";
          }
          if (!this.anoModelo_av) {
            this.anoModeloCorBorda = "red";
            return;
          } else {
            this.anoModeloCorBorda = "green";
          }
          if (!this.cor_av) {
            this.corCorBorda = "red";
            return;
          } else {
            this.corCorBorda = "green";
          }

          const id = this.id_veiculo;
          console.log("id do veículo", id);
          await fetch(`${process.env.VUE_APP_API_URL}veiculo_usado/${id}`, {
            method: "PUT",

            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: id,
              marca: this.marcaSelecionada,
              modelo: this.modeloSelecionado,
              placa: this.placa_av,
              anoModelo: this.anoModelo_av,
              avaliador_id: id_userCad,
              cor: this.cor_av
            })
          })
            .then((data) => {
              if (!data.ok) {
                throw Error(data.status);
              }
              return data.json();
            })
            .then((resposta) => {
              if (resposta.status === 200) {
                this.abrir_modal = true;
                this.msg = "Veículo Atualizado!";
                setTimeout(() => (this.abrir_modal = false), 4000);
              }
              this.limpar_form_av();
              this.retrieveVeiculosAvaliacao();
              this.fechar_modal_avaliacao();
            });
        }
      } catch (error) {
        this.abrir_modal = true;
        this.msg = error.message;
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },
    limpar_form_av() {
      (this.marcaSelecionada = ""),
        (this.modeloSelecionado = ""),
        (this.placa_av = ""),
        (this.valor_av = ""),
        (this.kilometragem_av = ""),
        (this.anoModelo_av = ""),
        (this.cor_av = ""),
        (this.obs_av = "");
      this.data_av_hst = "";
      this.kilometragem_av_hst = "";
      this.valor_av_hst = "";
      this.empresa_avaliacao = "";
    },
    handleInsert() {
      this.lastClicked = "insert";
    },
    handleUpdate() {
      this.lastClicked = "update";
    },
    async verificar_avaliacao_placa() {
      console.log("Buscando havaliações");
      await fetch(`${process.env.VUE_APP_API_URL}veiculo_usado_avaliacao`, {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          placa: this.placa_av
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }

          return data.json();
        })
        .then((resposta) => {
          console.log(resposta);
          console.log(
            "Avaliações Historico ------------------------------------------------------------------------------------------------------------------------------------- 0014"
          );
          this.historico_avaliacoes = resposta;
          this.ativar_placa = false;
          this.desativar_placa = true;
          this.hab_hist_avaliacao = false;
          if (resposta.status != 1) {
            const ultimaAvaliacao =
              resposta.avaliacoes[resposta.avaliacoes.length - 1];
            console.log("Ultima Avaliação", ultimaAvaliacao);
            (this.marca_avaliacao = resposta.marca),
              (this.modeloSelecionado = resposta.modelo),
              (this.id_veiculo = resposta.id),
              (this.kilometragem = resposta.kilometragem),
              (this.kilometragem_av_hst = this.formatarKM(
                ultimaAvaliacao.kilometragem
              )),
              (this.anoModelo_av = resposta.anoModelo),
              (this.cor_av = resposta.cor_avaliacao),
              (this.data_av_hst = this.formatarDataBR(ultimaAvaliacao.data)),
              (this.marca_av_hst = resposta.marca),
              (this.marcaSelecionada = resposta.marca),
              (this.valor_av_hst = this.currency(
                ultimaAvaliacao.precoAvaliacao
              )),
              (this.empresa_avaliacao = ultimaAvaliacao.empresa),
              // (this.valor_avaliacao = this.currency(
              //   resposta.avaliacoes[0]["precoAvaliacao"]
              // )),
              // (this.avaliacoes = resposta),
              (this.info_avaliacao =
                "Existem avaliações para esse veículo, clique no botão info para visualizar!"),
              (this.inserir_item_avaliacao = false),
              (this.hab_avaliacao = false),
              console.log(
                "Existe avaliação ------------------------------------------------ 0015"
              ),
              console.log(this.avaliacoes);

            //(this.dialog_avaliacao = true);
          } else {
            console.log(
              "Não Existe avaliação ------------------------------------------------ 0016"
            );
            (this.info_avaliacao = "Não existe avaliação para esse veículo!"),
              console.log(this.avaliacoes);
            this.hab_avaliacao = true;
          }
        });
    },

    async verificar_avaliacao_id_proposta() {
      await fetch(`${process.env.VUE_APP_API_URL}veiculo_usado_avaliacao_id`, {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          proposta_id: this.id_proposta
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }

          return data.json();
        })
        .then((resposta) => {
          console.log(
            "Avaliações por ID ------------------------------------------------------------------------------------------------------------------------------------- 0014"
          );
          console.log(resposta);
          // this.ativar_placa = false;
          // this.desativar_placa = true;
          if (resposta.status != 1) {
            (this.placa_avaliacao = resposta.placa),
              (this.marca_avaliacao = resposta.marca),
              (this.modelo_avaliacao = resposta.modelo),
              (this.kilometragem = resposta.kilometragem),
              (this.anoModelo_avaliacao = resposta.anoModelo),
              (this.cor_avaliacao = resposta.cor_avaliacao),
              // (this.valor_avaliacao = this.currency(
              //   resposta.avaliacoes[0]["precoAvaliacao"]
              // )),
              (this.avaliacoes = resposta),
              (this.info_avaliacao =
                "Existem avaliações para esse veículo, clique no botão info para visualizar!"),
              (this.inserir_item_avaliacao = false),
              (this.hab_avaliacao = false),
              console.log(
                "Existe avaliação ------------------------------------------------ 0015"
              ),
              console.log(this.avaliacoes);

            //(this.dialog_avaliacao = true);
          } else {
            this.valor_avaliacao = this.currency(0.0);
            (this.info_avaliacao = "Não existe avaliação para esse veículo!"),
              console.log(this.avaliacoes);
            this.hab_avaliacao = true;
          }
        });
    },
    async verificar_avaliacoes_placa(item) {
      await fetch(`${process.env.VUE_APP_API_URL}veiculo_usado_avaliacoes`, {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          placa: item.placa
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }

          return data.json();
        })
        .then((resposta) => {
          this.historico_avaliacoes = resposta;
          console.log(resposta);
          console.log(
            "Historico de Avaliações ------------------------------------------------------------------------------------------------------------------------------------- 0014"
          );
        });
    },

    //** Fim veículo para troca */

    rowSelect(idx, item, id_parcela, pmt, rentabilidade) {
      if (id_parcela == 1) {
        console.log("checando id da parcela", id_parcela);
        this.linhaSelecionada = item;
        console.log(this.linhaSelecionada);
      }
      this.selecoesTaxas.tabela1 = {
        item: {
          id_taxa: item.id_taxa || item,
          pmt: pmt,
          rentabilidade: rentabilidade
        },
        id_parcela: id_parcela,
        id_linha: 1
      };

      console.log("Tabela 1 selecionada:", this.selecoesTaxas.tabela1);
    },

    rowSelect2(idx, item, id_parcela, pmt, rentabilidade) {
      if (id_parcela == 2) {
        this.linhaSelecionada2 = item;
      }
      this.selecoesTaxas.tabela2 = {
        item: {
          id_taxa: item.id_taxa || item,
          pmt: pmt,
          rentabilidade: rentabilidade
        },
        id_parcela: id_parcela,
        id_linha: 2
      };
      console.log("Tabela 2 selecionada:", this.selecoesTaxas.tabela2);
    },

    rowSelect3(idx, item, id_parcela, pmt, rentabilidade) {
      if (id_parcela == 3) {
        this.linhaSelecionada3 = item;
      }
      this.selecoesTaxas.tabela3 = {
        item: {
          id_taxa: item.id_taxa || item,
          pmt: pmt,
          rentabilidade: rentabilidade
        },
        id_parcela: id_parcela,
        id_linha: 3
      };
      console.log("Tabela 3 selecionada:", this.selecoesTaxas.tabela3);
    },

    async enviarTodasTaxas() {
      // Filtra apenas as seleções que existem
      const taxasParaEnviar = [];

      if (this.selecoesTaxas.tabela1) {
        console.log("ID da coluna no enviar taxas tabela 1", this.id_coluna);
        taxasParaEnviar.push(this.formatarTaxa(this.selecoesTaxas.tabela1, 1));
      }

      if (this.selecoesTaxas.tabela2) {
        console.log("ID da coluna no enviar taxas tabela 2", this.id_coluna);
        taxasParaEnviar.push(this.formatarTaxa(this.selecoesTaxas.tabela2, 2));
      }

      if (this.selecoesTaxas.tabela3) {
        console.log("ID da coluna no enviar taxas tabela 3", this.id_coluna);
        taxasParaEnviar.push(this.formatarTaxa(this.selecoesTaxas.tabela3, 3));
      }

      if (taxasParaEnviar.length === 0) {
        console.log("Nenhuma taxa selecionada");
        return;
      }

      console.log("Enviando taxas:", taxasParaEnviar);

      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}taxas/menu`,
          {
            method: "POST",
            headers: {
              "Content-type": "application/json"
            },
            body: JSON.stringify({
              taxas: taxasParaEnviar
            })
          }
        );

        if (!response.ok) {
          throw Error(response.status);
        }

        const resultado = await response.json();
        console.log("Todas as taxas enviadas com sucesso:", resultado);

        // Limpa as seleções após sucesso
        this.selecoesTaxas = { tabela1: null, tabela2: null, tabela3: null };
        this.fechar_rank();
      } catch (error) {
        console.error("Erro ao enviar taxas:", error);
      }
    },
    formatarTaxa(selecao, numeroTabela) {
      const { entrada, parcela } = this.obterEntradaParcela(
        numeroTabela,
        selecao.id_parcela
      );
      console.log("Valores da seleção de cada tabela", selecao);
      return {
        id: selecao.item.id_taxa,
        proposta_id: this.id_proposta,
        entrada: entrada,
        parcela: parcela,
        id_linha: numeroTabela,
        id_coluna: this.id_coluna,
        incluir_acessorios: this.incluir_acessorios,
        avaliacao: this.valor_avaliacao,
        financiamento_1: this.Valor_Financiado,
        financiamento_2: this.Valor_Financiado_2,
        financiamento_3: this.Valor_Financiado_3,
        pmt: selecao.item.pmt,
        rentabilidade: selecao.item.rentabilidade
      };
    },
    obterEntradaParcela(id_linha) {
      let entrada = 0;
      let parcela = 0;

      if (id_linha == 1) {
        if (this.id_coluna == 1) {
          entrada = this.entrada_1;
          parcela = this.parcela_1;
        }
        if (this.id_coluna == 2) {
          entrada = this.entrada_1;
          parcela = this.parcela_2;
        }
        if (this.id_coluna == 3) {
          entrada = this.entrada_1;
          parcela = this.parcela_3;
        }
      }
      if (id_linha == 2) {
        if (this.id_coluna == 1) {
          entrada = this.entrada_2;
          parcela = this.parcela_1;
        }
        if (this.id_coluna == 2) {
          entrada = this.entrada_2;
          parcela = this.parcela_2;
        }
        if (this.id_coluna == 3) {
          entrada = this.entrada_2;
          parcela = this.parcela_3;
        }
      }
      if (id_linha == 3) {
        if (this.id_coluna == 1) {
          entrada = this.entrada_3;
          parcela = this.parcela_1;
        }
        if (this.id_coluna == 2) {
          entrada = this.entrada_3;
          parcela = this.parcela_2;
        }
        if (this.id_coluna == 3) {
          entrada = this.entrada_3;
          parcela = this.parcela_3;
        }
      }

      return { entrada, parcela };
    },

    async excluir_item_ac(item) {
      const id = item.id;
      await fetch(`${process.env.VUE_APP_API_URL}itens_cortesias/${id}`, {
        method: "DELETE",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify({
          id: id,
          proposta_id: this.id_proposta
        })
      });
      this.retrieveItensCortesia();
      this.inserir_desconto();
    },
    async excluir_todos_item_ac() {
      await fetch(`${process.env.VUE_APP_API_URL}itens_acessorios_todos`, {
        method: "DELETE",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify({
          proposta_id: this.id_proposta
        })
      });
    },
    async excluir_veiculo_av(item) {
      console.log("Dados do Veiculo a ser excluido");
      console.log(item);
      await fetch(`${process.env.VUE_APP_API_URL}remover_veiculo_avaliacao`, {
        method: "PUT",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify({
          placa: item.placa,
          proposta_id: this.id_proposta,
          status: 0
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          return data.json();
        })
        .then((resposta) => {
          console.log(resposta);
          this.abrir_modal = true;
          this.msg = resposta.message;
          setTimeout(() => (this.abrir_modal = false), 2000);
          this.retrieveVeiculosAvaliacao();
        });
    },
    fechar_rank() {
      this.modal_ranqueamento = false;
      //this.resumo();
      location.reload();
    },

    //////////////////////Proposta//////////////////////////////////////////////////////////////////////

    getRequestParamsProposta(
      searchProposta,
      page,
      pageSize,
      empresa_id,
      status_proposta,
      data_ini,
      data_fim
    ) {
      let params = {};
      if (searchProposta) {
        params["nome"] = searchProposta;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (empresa_id) {
        params["empresa_id"] = empresa_id;
      }
      if (status_proposta) {
        params["status_proposta"] = status_proposta;
      }
      if (data_ini) {
        params["data_ini"] = data_ini;
      }
      if (data_fim) {
        params["data_fim"] = data_fim;
      }

      return params;
    },

    async retrievePropostas() {
      try {
        const params = this.getRequestParamsProposta(
          this.searchProposta,
          this.page_4,
          this.pageSize_4,
          this.empresaID,
          this.status_proposta,
          this.data_ini,
          this.data_fim
        );

        userService.getPropostaCliente(params).then((response) => {
          this.status_proposta = "";
          const { propostas, totalPages, totalItems } = response.data;

          this.totalPages_4 = totalPages;
          this.totalItems_4 = totalItems;

          console.log(
            "------------------------------------------------------------------------------------------------------------------ 0021"
          );
          console.log(response.data);

          var array_proposta_1 = [];
          var array_proposta_2 = [];
          let tempo_espera;
          let tempo_atendimento;
          let segundos_chegada;
          let minutos_chegada;
          let horas_chegada;
          let segundos_atendimento;
          let minutos_atendimento;
          let horas_atendimento;
          //let tempo;
          let diferenca_chegada;
          let diferenca_atendimento;
          let gerente;
          let status;

          const now = new Date();
          var hora_server = new Date(
            now.getFullYear() +
              "-" +
              (now.getMonth() + 1) +
              "-" +
              now.getDate() +
              " " +
              now.getHours() +
              ":" +
              now.getMinutes() +
              ":" +
              now.getSeconds()
          );

          //var diferenca = "";
          console.log(
            "Esse é o resultado da consulta dos atendimentos realizado na tabela proposta! ------------------------------------------------------------------------- 0022"
          );
          console.log(propostas);
          for (var i = 0; i < propostas.length; i++) {
            //var data = new Date(propostas[i]["createdAt"]);
            var horario_chegada = new Date(propostas[i]["horario_chegada"]);
            var horario_ini_atendimento = new Date(
              propostas[i]["horario_inicio_atendimento"]
            );

            var hora_inicio = new Date(
              horario_ini_atendimento.getFullYear() +
                "-" +
                (horario_ini_atendimento.getMonth() + 1) +
                "-" +
                horario_ini_atendimento.getUTCDate() +
                " " +
                horario_ini_atendimento.getUTCHours() +
                ":" +
                horario_ini_atendimento.getMinutes() +
                ":" +
                horario_ini_atendimento.getSeconds()
            );
            var hora_chegada = new Date(
              horario_chegada.getFullYear() +
                "-" +
                (horario_chegada.getMonth() + 1) +
                "-" +
                horario_chegada.getUTCDate() +
                " " +
                horario_chegada.getUTCHours() +
                ":" +
                horario_chegada.getMinutes() +
                ":" +
                horario_chegada.getSeconds()
            );
            status = "";

            if (propostas[i]["status_proposta"] == "Atendimento") {
              diferenca_atendimento = Math.abs(
                hora_server.getTime() - hora_inicio.getTime()
              );
              segundos_atendimento = parseInt(
                (diferenca_atendimento / 1000) % 100
              );
              minutos_atendimento = parseInt(
                (diferenca_atendimento / (1000 * 60)) % 60
              );
              horas_atendimento = parseInt(
                diferenca_atendimento / (1000 * 60 * 60)
              );
              horas_atendimento =
                horas_atendimento < 10
                  ? "0" + horas_atendimento
                  : horas_atendimento;
              minutos_atendimento =
                minutos_atendimento < 10
                  ? "0" + minutos_atendimento
                  : minutos_atendimento;
              segundos_atendimento =
                segundos_atendimento < 10
                  ? "0" + segundos_atendimento
                  : segundos_atendimento;

              (tempo_espera = "00:00"),
                (tempo_atendimento =
                  horas_atendimento + ":" + minutos_atendimento);

              if (diferenca_atendimento > 2700000) {
                console.log(
                  "Maior -------------- ------------------------------------------------------------------------------------------------------------------ 0023"
                );
                this.css1 = "cor_atendimento_apos_45min";
                status = "Atendimento Excedido";
              }
              if (diferenca_atendimento < 2700000) {
                console.log(
                  "Menor -------------------- ------------------------------------------------------------------------------------------------------------------ 0024"
                );
                this.css = "cor_atendimento";
                status = "Atendimento";
              }
            }

            if (propostas[i]["status_proposta"] == "Aguardando Atendimento") {
              diferenca_chegada = Math.abs(
                hora_server.getTime() - hora_chegada.getTime()
              );
              segundos_chegada = parseInt((diferenca_chegada / 1000) % 100);
              minutos_chegada = parseInt(
                (diferenca_chegada / (1000 * 60)) % 60
              );
              horas_chegada = parseInt(diferenca_chegada / (1000 * 60 * 60));
              horas_chegada =
                horas_chegada < 10 ? "0" + horas_chegada : horas_chegada;
              minutos_chegada =
                minutos_chegada < 10 ? "0" + minutos_chegada : minutos_chegada;
              segundos_chegada =
                segundos_chegada < 10
                  ? "0" + segundos_chegada
                  : segundos_chegada;

              (tempo_espera = horas_chegada + ":" + minutos_chegada),
                (tempo_atendimento = "00:00");

              this.css2 = "cor_aguardando_atendimento";
              status = "Aguardando Atendimento";
            }
            if (propostas[i]["status_proposta"] == "Venda Finalizada") {
              this.css3 = "cor_venda_finalizada";
              status = "Venda Finalizada";
            }
            if (propostas[i]["status_proposta"] == "Venda Perdida") {
              this.css4 = "cor_venda_perdida";
              status = "Venda Perdida";
            }
            if (propostas[i]["status_proposta"] == "Aprovação") {
              this.css5 = "cor_aprovacao";
              status = "Aguardando Aprovação";
            }
            if (propostas[i]["gerentes"] == null) {
              gerente = this.$store.state.auth.user.id;
            }

            //Armazena o id do vendedor para atualizar quando finalizar a venda
            (this.g_menu_vendedor_id = propostas[i]["vendedor_id"]),
              (array_proposta_1 = {
                acessorios: propostas[i]["acessorios"],
                adicional: propostas[i]["adicional"],
                avaliacao: propostas[i]["avaliacao"],
                avaliacaoVeiculo_id: propostas[i]["avaliacaoVeiculo_id"],
                avaliacoes_veiculo: propostas[i]["avaliacoes_veiculo"],
                cliente_id: propostas[i]["cliente_id"],
                cliente: propostas[i]["clientes"]["nome"],
                cortesia: propostas[i]["cortesia"],
                custos_variaveis: propostas[i]["avaliacao"],
                desconto: propostas[i]["avaliacao"],
                empresa_id: propostas[i]["empresa_id"],
                gerente_id: propostas[i]["gerente_id"],
                gerente: gerente,
                id: propostas[i]["id"],
                info_adicional: propostas[i]["obs"],
                id_vendedor_fila: propostas[i]["id_vendedor_fila"],
                impostos: propostas[i]["impostos"],
                justificativa: propostas[i]["justificativa"],
                midia_id: propostas[i]["midia_id"],
                modelo_id: propostas[i]["modelo_id"],
                modelo_veiculos: propostas[i]["modelo_veiculos"],
                obs: propostas[i]["obs"],
                propostaVeiculo_id: propostas[i]["propostaVeiculo_id"],
                proposta_veiculo: propostas[i]["proposta_veiculo"],
                retorno: propostas[i]["retorno"],
                //status: propostas[i]["status_proposta"],
                status: status,
                tipo_pagamento: propostas[i]["tipo_pagamento"],
                user_id: propostas[i]["user_id"],
                usuarios: propostas[i]["usuarios"],
                veiculoUsado_id: propostas[i]["veiculoUsado_id"],
                veiculos_usados: propostas[i]["veiculos_usados"],
                vendedor_id: propostas[i]["vendedor_id"],
                vendedor: propostas[i]["vendedores"]["username"],
                monetario_lucro: this.currency(
                  propostas[i]["lucro_operacional"]
                ),
                percentual_lucro: parseFloat(
                  (propostas[i]["lucro_operacional"] /
                    propostas[i]["val_sugerido_venda"]) *
                    100
                ).toFixed(2),
                monetario_margem: this.currency(propostas[i]["lucro_final"]),
                percentual_margem: parseFloat(
                  (propostas[i]["lucro_final"] /
                    propostas[i]["val_sugerido_venda"]) *
                    100
                ).toFixed(2),
                modelo: propostas[i].proposta_veiculo
                  ? propostas[i].proposta_veiculo.modelo_veiculo
                  : "N/A",
                tempo_espera: tempo_espera,
                tempo_atendimento: tempo_atendimento,
                gerados: "",
                motivo_perda: "",
                horas_chegada: horas_chegada,
                minutos_chegada: minutos_chegada,
                segundos_chegada: segundos_chegada,
                horas_atendimento: horas_atendimento,
                minutos_atendimento: minutos_atendimento,
                segundos_atendimento: segundos_atendimento,

                cpfCnpj: propostas[i]["clientes"]["cpfCnpj"],
                nome: propostas[i]["clientes"]["nome"],
                email: propostas[i]["clientes"]["email"],
                tel: propostas[i]["clientes"]["tel"]
              });
            array_proposta_2.push(array_proposta_1);
          }
          console.log(array_proposta_2);
          this.propostas_at = array_proposta_2;
          this.validando_tempo();
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.dialog = false), 4000);
        }
      }
    },
    ////////////////////Fim metodos da tabela proposta //////////////////////////////////////////////////
    async alterar_status_proposta() {
      const id = this.id_proposta;
      await fetch(`${process.env.VUE_APP_API_URL}iniciar_atendimento/${id}`, {
        method: "PUT",

        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: id,
          status_proposta: "Atendimento"
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          return data.json();
        })
        .then((resposta) => {
          console.log(resposta);
        });
    },
    async inserir_gerente(id) {
      await fetch(`${process.env.VUE_APP_API_URL}inserir_gerente/${id}`, {
        method: "PUT",

        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: id,
          gerente_id: this.user_log
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          return data.json();
        })
        .then((resposta) => {
          console.log(resposta);
        });
    },

    habilitar_incluir_itens_financiamento() {
      console.log("Incluirr financiamento");
      if (this.incluir_acessorios == true) {
        this.venda_vista = false;
        this.dialog_incluir_acessorios = true;
        this.message_incluir_acessorios =
          "Ao clicar no botão SIM, o total de acessórios será incluso no Financiamento, será necessário RANQUEAR novamente, deseja continuar?";
      }
      if (this.incluir_acessorios == false) {
        this.dialog_incluir_acessorios = true;
        this.message_incluir_acessorios =
          "Ao clicar no botão SIM, o total de acessórios será retirado do Financiamento, será necessário RANQUEAR novamente, deseja continuar?";
      }
    },

    ////Fim Proposta

    ///Estoque/////
    async handlePageChangeVeiculoEstoque(newPage) {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this.retrieveEstoque(newPage);
        this.pageEstoque = newPage;
      } finally {
        this.isLoading = false;
      }
    },

    getRequestParamsEstoque(
      searchTitle,
      searchChassi,
      searchPlaca,
      searchValIni,
      searchValFin,
      searchMarca,
      searchAnoMod,
      searchAnoFab,
      searchCor,
      tipoVeiculo,
      pageVeiculo,
      pageSizeVeiculo,
      company_id
    ) {
      let params = {};
      if (searchMarca) {
        params["marca"] = searchMarca;
      }
      if (searchAnoMod) {
        params["ano_modelo"] = searchAnoMod;
      }
      if (searchAnoFab) {
        params["ano_fabricacao"] = searchAnoFab;
      }
      if (searchCor) {
        params["cor"] = searchCor;
      }
      if (tipoVeiculo) {
        params["tipoVeiculo"] = tipoVeiculo;
      }
      if (searchTitle) {
        params["nome"] = searchTitle;
      }
      if (searchChassi) {
        params["chassi"] = searchChassi;
      }
      if (searchPlaca) {
        params["placa"] = searchPlaca;
      }
      if (searchValIni) {
        params["valor_inicial"] = searchValIni;
      }
      if (searchValFin) {
        params["valor_final"] = searchValFin;
      }

      if (pageVeiculo) {
        params["page"] = pageVeiculo - 1;
      }
      if (pageSizeVeiculo) {
        params["size"] = pageSizeVeiculo;
      }
      if (company_id) {
        params["empresa_id"] = company_id;
      }
      return params;
    },
    async retrieveEstoque(page = this.pageEstoque) {
      try {
        const params = this.getRequestParamsEstoque(
          this.searchTitle,
          this.searchChassi,
          this.searchPlaca,
          this.searchValFin,
          this.searchValIni,
          this.searchMarca,
          this.searchAnoMod,
          this.searchAnoFab,
          this.searchCor,
          this.tipoVeiculo,
          page,
          this.pageSizeEstoque,
          this.company_id
        );

        const response = await userService.getEstoqueVeiculo(params);
        const { veiculoEstoque, totalPages, totalItems } = response.data;
        this.estoque_veiculo = veiculoEstoque;
        this.totalPagesEstoque = totalPages;
        this.totalItemsEstoque = totalItems;
        console.log(response.data);

        userService.getMarcaEstoque().then((response) => {
          this.marcas_estoque = response.data;
        });
        userService.getModeloEstoque().then((response) => {
          this.modelos_estoque = response.data;
        });
        userService.getCorEstoque().then((response) => {
          this.cores_estoque = response.data;
        });
        return true; // Indica sucesso
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },

    habilitar_veiculo() {
      console.log(
        "Aqui habilita o modal estoque e acessa a api para buscar os veiculos em estoque ----- 0036"
      );
      //Criar validação para não mostrar veiculos com atendimento em aberto!
      this.retrieveEstoque();

      this.modal_estoque = true;
    },

    async handlePageChangeEntrada1(newPage) {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this.ranqueamento_entrada_1(newPage);
        this.page_1 = newPage;
      } finally {
        this.isLoading = false;
      }
    },

    getRequestParamsEntrada1(
      filtro_tipo_veiculo,
      filtro_tipo_tabela,
      filtro_spf,
      razao_financiamento,
      plano,
      page_1,
      pageSize_1,
      id_proposta,
      id_coluna,
      sortBy,
      sortDesc,
      parcela,
      Valor_Total_Venda,
      entrada,
      entrada_per_1,
      valor_avaliacao
    ) {
      let params = {};
      if (filtro_tipo_veiculo) {
        params["filtro_tipo_veiculo"] = filtro_tipo_veiculo;
      }
      if (filtro_tipo_tabela) {
        params["filtro_tipo_tabela"] = filtro_tipo_tabela;
      }
      if (filtro_spf) {
        params["filtro_spf"] = filtro_spf;
      }
      if (razao_financiamento) {
        params["razao_financiamento"] = razao_financiamento;
      }
      if (plano) {
        params["plano"] = plano;
      }
      if (page_1) {
        params["page_1"] = page_1 - 1;
      }
      if (pageSize_1) {
        params["size_1"] = pageSize_1;
      }
      if (id_proposta) {
        params["id_proposta"] = id_proposta;
      }
      if (id_coluna) {
        params["id_coluna"] = id_coluna;
      }
      if (sortBy) {
        params["sortBy"] = sortBy;
      }
      if (sortDesc) {
        params["sortDesc"] = sortDesc;
      }
      if (parcela) {
        params["parcela"] = parcela;
      }
      if (Valor_Total_Venda) {
        params["valor_da_venda"] = Valor_Total_Venda;
      }
      if (entrada) {
        params["entrada"] = entrada;
      }
      if (entrada_per_1) {
        params["entrada_per_1"] = entrada_per_1;
      }
      if (valor_avaliacao) {
        params["valor_avaliacao"] = valor_avaliacao;
      }
      return params;
    },
    async retrieveRanqueamentoEntrada1() {
      try {
        const params = this.getRequestParamsEntrada1(
          this.filtro_tipo_veiculo,
          this.filtro_tipo_tabela,
          this.filtro_spf,
          this.razao_financiamento,
          this.plano,
          this.page_1,
          this.pageSize_1,
          this.id_proposta,
          this.id_coluna,
          this.sortBy,
          this.sortDesc,
          this.parcela,
          this.Valor_Total_Venda,
          this.entrada_1,
          this.entrada_perc_1_padronizada,
          this.valor_avaliacao
        );
        const response = await userService.getFiltroTaxas_1(params);
        const { parcelas, totalPages, totalItems } = response.data;
        this.parcelamento_1 = parcelas;
        this.totalPages_1 = totalPages;
        this.totalItems_1 = totalItems;
        console.log(
          "Iniciando consulta as taxas ranqueadas filtro 1 ----------------------0037"
        );
        console.log(response.data);
      } catch (error) {
        if (error.response.status == 400) {
          console.log("erro nos filtro", error);
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 8000);
        }
      }
    },
    /**Após retorno positivo do ranqueamento essa função monta as taxas do primeiro bloco de entrada */
    async ranqueamento_entrada_1(page = this.page_1) {
      try {
        console.log("Buscando ranqueamento 1");
        const resposta = await axios.get(
          `${process.env.VUE_APP_API_URL}taxas/ranqueamento_entrada_1`,
          {
            params: {
              filtro_tipo_veiculo: this.filtro_tipo_veiculo,
              filtro_tipo_tabela: this.filtro_tipo_tabela,
              filtro_spf: this.filtro_spf,
              razao_financiamento: this.razao_financiamento,
              plano: this.plano,
              page_1: page,
              pageSize_1: this.pageSize_1,
              id_proposta: this.id_proposta,
              id_coluna: this.id_coluna,
              sortBy: this.sortBy,
              sortDesc: this.sortDesc,
              parcela: this.parcela,
              Valor_Total_Venda: this.Valor_Total_Venda,
              entrada: this.entrada_1,
              entrada_per_1: this.entrada_perc_1_padronizada,
              valor_avaliacao: this.valor_avaliacao
            }
          }
        );
        console.log("resposta", resposta);
        const { parcelas, totalPages, totalItems } = resposta.data;

        this.parcelamento_1 = parcelas;
        this.totalPages_1 = totalPages;
        this.totalItems_1 = totalItems;

        // // Garante que as parcelas selecionadas são números (como no retorno da API)
        // const parcelasParaFiltrar = [
        //   Number(this.parcela_1),
        //   Number(this.parcela_2),
        //   Number(this.parcela_3),
        // ].filter(parcela => !isNaN(parcela)); // Remove valores não numéricos

        // // Cria objeto dinâmico com as parcelas encontradas
        // const resultado = {};

        // parcelasParaFiltrar.forEach((parcela, index) => {
        //   const chave = `parcela_${index + 1}`;
        //   resultado[chave] = parcelas.filter((p) => p.qtd_parcelas === parcela);

        //   // Atualiza valores financeiros
        //   if (resultado[chave].length > 0) {
        //     this[`Valor_Entrada_${index + 1}`] = this.currency(
        //       resultado[chave][0].total_entrada_1 || 0
        //     );
        //     this[`Valor_Financiado_${index + 1}`] = this.currency(
        //       resultado[chave][0].total_financiado_1 || 0
        //     );
        //   }
        // });

        // console.log("Parcelas filtradas1:", resultado);

        // // console.log("Taxas recuperadas", resposta);

        // this.parcelamento_1 = resultado.parcela_1;
        // this.parcelamento_2 = resultado.parcela_2;
        // this.parcelamento_3 = resultado.parcela_3;
        // // console.log("Parcelas", this.parcelamento_1);
        // this.totalPages_1 = totalPages;
        // this.totalItems_1 = totalItems;

        var ent_1 = parcelas[0]["total_entrada_1"];
        var fin_1 = parcelas[0]["total_financiado_1"];
        var ent_2 = parcelas[0]["total_entrada_2"];
        var fin_2 = parcelas[0]["total_financiado_2"];
        var ent_3 = parcelas[0]["total_entrada_3"];
        var fin_3 = parcelas[0]["total_financiado_3"];

        this.Valor_Entrada = this.currency(ent_1);
        this.Valor_Financiado = this.currency(fin_1);
        this.Valor_Entrada_2 = this.currency(ent_2);
        this.Valor_Financiado_2 = this.currency(fin_2);
        this.Valor_Entrada_3 = this.currency(ent_3);
        this.Valor_Financiado_3 = this.currency(fin_3);
        // //await this.ranqueamento_entrada_2();
      } catch (error) {
        console.error("Erro ao buscar ranqueamento_1:", error);
        this.errorMsg =
          "Erro ao buscar dados de ranqueamento. Tente novamente mais tarde.";
      }
    },

    ranqueamento_1() {
      this.parcela = this.parcela_1;
      this.id_coluna = 1;
      console.log(
        "Botão ranquear 1, armazeno o valor da coluna e quantidade de parcelas escolhida! ------- 0038",
        this.entrada_1
      );
      console.log(
        "Quantidade de parcelas ---- " + this.parcela + " ------------- 0039"
      );
      //this.resumo();
      this.retrieveRanqueamento();
      this.modal_ranqueamento = true;
    },
    ranqueamento_2() {
      this.parcela = this.parcela_2;
      this.id_coluna = 2;

      //this.resumo();
      this.retrieveRanqueamento();
      this.modal_ranqueamento = true;
    },

    //////////////////////////

    //Paginação entrada 2 /////

    async handlePageChangeEntrada2(newPage) {
      if (this.isLoading) return;
      this.isLoading = true;
      try {
        await this.ranqueamento_entrada_2(newPage);
        this.page = newPage;
      } finally {
        this.isLoading = false;
      }
    },

    getRequestParamsEntrada2(
      filtro_tipo_veiculo,
      filtro_tipo_tabela,
      filtro_spf,
      razao_financiamento,
      plano,
      page_2,
      pageSize_2,
      id_proposta,
      id_coluna,
      sortBy_2,
      sortDesc_2,
      parcela,
      Valor_Total_Venda,
      entrada,
      entrada_per_2,
      valor_avaliacao
    ) {
      let params = {};
      if (filtro_tipo_veiculo) {
        params["filtro_tipo_veiculo"] = filtro_tipo_veiculo;
      }
      if (filtro_tipo_tabela) {
        params["filtro_tipo_tabela"] = filtro_tipo_tabela;
      }
      if (filtro_spf) {
        params["filtro_spf"] = filtro_spf;
      }
      if (razao_financiamento) {
        params["razao_financiamento"] = razao_financiamento;
      }
      if (plano) {
        params["plano"] = plano;
      }
      if (page_2) {
        params["page_2"] = page_2 - 1;
      }
      if (pageSize_2) {
        params["size_2"] = pageSize_2;
      }
      if (id_proposta) {
        params["id_proposta"] = id_proposta;
      }
      if (id_coluna) {
        params["id_coluna"] = id_coluna;
      }
      if (sortBy_2) {
        params["sortBy_2"] = sortBy_2;
      }
      if (sortDesc_2) {
        params["sortDesc_2"] = sortDesc_2;
      }
      if (parcela) {
        params["parcela"] = parcela;
      }
      if (Valor_Total_Venda) {
        params["valor_da_venda"] = Valor_Total_Venda;
      }
      if (entrada) {
        params["entrada"] = entrada;
      }
      if (entrada_per_2) {
        params["entrada_per_2"] = entrada_per_2;
      }
      if (valor_avaliacao) {
        params["valor_avaliacao"] = valor_avaliacao;
      }
      return params;
    },
    async retrieveRanqueamentoEntrada2() {
      try {
        const params = this.getRequestParamsEntrada2(
          this.filtro_tipo_veiculo,
          this.filtro_tipo_tabela,
          this.filtro_spf,
          this.razao_financiamento,
          this.plano,
          this.page_2,
          this.pageSize_2,
          this.id_proposta,
          this.id_coluna,
          this.sortBy_2,
          this.sortDesc_2,
          this.parcela,
          this.Valor_Total_Venda,
          this.entrada_2,
          this.entrada_perc_2_padronizada,
          this.valor_avaliacao
        );
        const response = await userService.getFiltroTaxas_2(params);
        const { parcelas, totalPages, totalItems } = response.data;
        this.parcelamento_2 = parcelas;
        this.totalPages_2 = totalPages;
        this.totalItems_2 = totalItems;
        console.log("Iniciando consulta as taxas ranqueadas filtro 2 ");
        console.log(response.data);
      } catch (error) {
        if (error.response.status == 400) {
          console.log("erro nos filtro", error);
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 8000);
        }
      }
    },
    async ranqueamento_entrada_2(page = this.page_2) {
      try {
        console.log("Buscando ranqueamento 2");
        const resposta = await axios.get(
          `${process.env.VUE_APP_API_URL}taxas/ranqueamento_entrada_2`,
          {
            params: {
              filtro_tipo_veiculo: this.filtro_tipo_veiculo,
              filtro_tipo_tabela: this.filtro_tipo_tabela,
              filtro_spf: this.filtro_spf,
              razao_financiamento: this.razao_financiamento,
              plano: this.plano,
              page_2: page,
              pageSize_2: this.pageSize_2,
              id_proposta: this.id_proposta,
              id_coluna: this.id_coluna,
              sortBy: this.sortBy,
              sortDesc: this.sortDesc,
              parcela: this.parcela,
              Valor_Total_Venda: this.Valor_Total_Venda,
              entrada: this.entrada_2,
              entrada_per_2: this.entrada_perc_2_padronizada,
              valor_avaliacao: this.valor_avaliacao
            }
          }
        );

        const { parcelas, totalPages, totalItems } = resposta.data;

        this.parcelamento_2 = parcelas;
        this.totalPages_2 = totalPages;
        this.totalItems_2 = totalItems;
        //  // Garante que as parcelas selecionadas são números (como no retorno da API)
        // const parcelasParaFiltrar = [
        //   Number(this.parcela_1),
        //   Number(this.parcela_2),
        //   Number(this.parcela_3),
        // ].filter(parcela => !isNaN(parcela)); // Remove valores não numéricos

        // // Cria objeto dinâmico com as parcelas encontradas
        // const resultado = {};

        // parcelasParaFiltrar.forEach((parcela, index) => {
        //   const chave = `parcela_${index + 1}`;
        //   resultado[chave] = parcelas.filter((p) => p.qtd_parcelas === parcela);

        //   // Atualiza valores financeiros
        //   if (resultado[chave].length > 0) {
        //     this[`Valor_Entrada_${index + 1}`] = this.currency(
        //       resultado[chave][0].total_entrada_2 || 0
        //     );
        //     this[`Valor_Financiado_${index + 1}`] = this.currency(
        //       resultado[chave][0].total_financiado_2 || 0
        //     );
        //   }
        // });

        // console.log("Parcelas filtradas2:", resultado);

        // // console.log("Taxas recuperadas", resposta);

        // this.parcelamento_1 = resultado.parcela_1;
        // this.parcelamento_2 = resultado.parcela_2;
        // this.parcelamento_3 = resultado.parcela_3;
        // // console.log("Parcelas", this.parcelamento_1);
        // this.totalPages_2 = totalPages;
        // this.totalItems_2= totalItems;

        // var ent_1 = parcelas[0]["total_entrada_1"];
        // var fin_1 = parcelas[0]["total_financiado_1"];
        // var ent_2 = parcelas[0]["total_entrada_2"];
        // var fin_2 = parcelas[0]["total_financiado_2"];
        // var ent_3 = parcelas[0]["total_entrada_3"];
        // var fin_3 = parcelas[0]["total_financiado_3"];

        // this.Valor_Entrada = this.currency(ent_1);
        // this.Valor_Financiado = this.currency(fin_1);
        // this.Valor_Entrada_2 = this.currency(ent_2);
        // this.Valor_Financiado_2 = this.currency(fin_2);
        // this.Valor_Entrada_3 = this.currency(ent_3);
        // this.Valor_Financiado_3 = this.currency(fin_3);
        // //await this.ranqueamento_entrada_2();
      } catch (error) {
        console.error("Erro ao buscar ranqueamento_1:", error);
        this.errorMsg =
          "Erro ao buscar dados de ranqueamento. Tente novamente mais tarde.";
      }
    },

    //Paginação entrada 3 /////

    handlePageChangeEntrada3(value) {
      this.page_3 = value;
      //this.retrieveRanqueamentoEntrada3();
      this.ranqueamento_entrada_3();
    },

    getRequestParamsEntrada3(
      filtro_tipo_veiculo,
      filtro_tipo_tabela,
      filtro_spf,
      razao_financiamento,
      plano,
      page_3,
      pageSize_3,
      id_proposta,
      id_coluna,
      sortBy_3,
      sortDesc_3,
      parcela,
      Valor_Total_Venda,
      entrada,
      entrada_per_3,
      valor_avaliacao
    ) {
      let params = {};
      if (filtro_tipo_veiculo) {
        params["filtro_tipo_veiculo"] = filtro_tipo_veiculo;
      }
      if (filtro_tipo_tabela) {
        params["filtro_tipo_tabela"] = filtro_tipo_tabela;
      }
      if (filtro_spf) {
        params["filtro_spf"] = filtro_spf;
      }
      if (razao_financiamento) {
        params["razao_financiamento"] = razao_financiamento;
      }
      if (plano) {
        params["plano"] = plano;
      }
      if (page_3) {
        params["page_3"] = page_3 - 1;
      }
      if (pageSize_3) {
        params["size_3"] = pageSize_3;
      }
      if (id_proposta) {
        params["id_proposta"] = id_proposta;
      }
      if (id_coluna) {
        params["id_coluna"] = id_coluna;
      }
      if (sortBy_3) {
        params["sortBy_3"] = sortBy_3;
      }
      if (sortDesc_3) {
        params["sortDesc_3"] = sortDesc_3;
      }
      if (parcela) {
        params["parcela"] = parcela;
      }
      if (Valor_Total_Venda) {
        params["valor_da_venda"] = Valor_Total_Venda;
      }
      if (entrada) {
        params["entrada"] = entrada;
      }
      if (entrada_per_3) {
        params["entrada_per_3"] = entrada_per_3;
      }
      if (valor_avaliacao) {
        params["valor_avaliacao"] = valor_avaliacao;
      }
      return params;
    },
    async retrieveRanqueamentoEntrada3() {
      try {
        const params = this.getRequestParamsEntrada3(
          this.filtro_tipo_veiculo,
          this.filtro_tipo_tabela,
          this.filtro_spf,
          this.razao_financiamento,
          this.plano,
          this.page_3,
          this.pageSize_3,
          this.id_proposta,
          this.id_coluna,
          this.sortBy_3,
          this.sortDesc_3,
          this.parcela,
          this.Valor_Total_Venda,
          this.entrada_3,
          this.entrada_perc_3_padronizada,
          this.valor_avaliacao
        );
        const response = await userService.getFiltroTaxas_3(params);
        const { parcelas, totalPages, totalItems } = response.data;
        this.parcelamento_3 = parcelas;
        this.totalPages_3 = totalPages;
        this.totalItems_3 = totalItems;
        console.log(
          "Iniciando consulta as taxas ranqueadas filtro 3 ----------------------0037"
        );
        console.log(response.data);
      } catch (error) {
        if (error.response.status == 400) {
          console.log("erro nos filtro", error);
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 8000);
        }
      }
    },
    async ranqueamento_entrada_3(page = this.page_3) {
      try {
        const ranqueamento_coluna_3 = await axios.get(
          `${process.env.VUE_APP_API_URL}taxas/ranqueamento_entrada_3`,
          {
            params: {
              filtro_tipo_veiculo: this.filtro_tipo_veiculo,
              filtro_tipo_tabela: this.filtro_tipo_tabela,
              filtro_spf: this.filtro_spf,
              razao_financiamento: this.razao_financiamento,
              plano: this.plano,
              page_3: page,
              pageSize_3: this.pageSize_3,
              id_proposta: this.id_proposta,
              id_coluna: this.id_coluna,
              sortBy: this.sortBy,
              sortDesc: this.sortDesc,
              parcela: this.parcela,
              Valor_Total_Venda: this.Valor_Total_Venda,
              entrada: this.entrada_3,
              entrada_per_3: this.entrada_perc_3_padronizada,
              valor_avaliacao: this.valor_avaliacao
            }
          }
        );
        const { parcelas, totalPages, totalItems } = ranqueamento_coluna_3.data;
        this.parcelamento_3 = parcelas;
        console.log("Parcelas 3 ", this.parcelamento_3);
        this.totalPages_3 = totalPages;
        this.totalItems_3 = totalItems;
      } catch (error) {
        console.error("Erro ao buscar ranqueamento_3:", error);
        this.errorMsg =
          "Erro ao buscar dados de ranqueamento. Tente novamente mais tarde.";
      }
    },
    ranqueamento_3() {
      this.parcela = this.parcela_3;
      this.id_coluna = 3;
      console.log(
        "Botão ranquear 3, armazeno o valor da coluna e quantidade de parcelas escolhida! ------- 0041"
      );
      console.log(
        "Quantidade de parcelas ---- " + this.parcela + " ------------- 0042"
      );

      this.retrieveRanqueamento();
      this.modal_ranqueamento = true;
    },
    //////////////////////////

    ///Taxas//////////////////
    getRequestParamsTaxas(
      parcela,
      entrada_1,
      entrada_2,
      entrada_3,
      entrada_per_1,
      entrada_per_2,
      entrada_per_3,
      page,
      pageSize,
      id_proposta,
      id_coluna,
      incluir_acessorios,
      empresa_id,
      entrada_avaliacao
    ) {
      let params = {};
      if (parcela) {
        params["parcela"] = parcela;
      }
      if (entrada_1) {
        params["entrada_1"] = entrada_1;
      }
      if (entrada_2) {
        params["entrada_2"] = entrada_2;
      }
      if (entrada_3) {
        params["entrada_3"] = entrada_3;
      }
      if (entrada_per_1) {
        params["entrada_per_1"] = entrada_per_1;
      }
      if (entrada_per_2) {
        params["entrada_per_2"] = entrada_per_2;
      }
      if (entrada_per_3) {
        params["entrada_per_3"] = entrada_per_3;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (id_proposta) {
        params["id_proposta"] = id_proposta;
      }
      if (id_coluna) {
        params["id_coluna"] = id_coluna;
      }
      if (incluir_acessorios) {
        params["incluir_acessorios"] = incluir_acessorios;
      }
      if (empresa_id) {
        params["empresa_id"] = empresa_id;
      }
      if (entrada_avaliacao) {
        params["entrada_avaliacao"] = entrada_avaliacao;
      }
      return params;
    },
    getRequestParamsFiltroTaxas(
      parcela,
      filtro_tipo_veiculo,
      filtro_tipo_tabela,
      filtro_spf,
      razao_financiamento,
      plano,
      page,
      pageSize,
      id_proposta,
      id_coluna
    ) {
      let params = {};
      if (parcela) {
        params["parcela"] = parcela;
      }
      if (filtro_tipo_veiculo) {
        params["filtro_tipo_veiculo"] = filtro_tipo_veiculo;
      }
      if (filtro_tipo_tabela) {
        params["filtro_tipo_tabela"] = filtro_tipo_tabela;
      }
      if (filtro_spf) {
        params["filtro_spf"] = filtro_spf;
      }
      if (razao_financiamento) {
        params["razao_financiamento"] = razao_financiamento;
      }
      if (plano) {
        params["plano"] = plano;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (id_proposta) {
        params["id_proposta"] = id_proposta;
      }
      if (id_coluna) {
        params["id_coluna"] = id_coluna;
      }
      return params;
    },

    async retrieveRanqueamento() {
      try {
        const rank = await axios.get(
          `${process.env.VUE_APP_API_URL}taxas/ranqueamento`,
          {
            params: {
              parcela: this.parcela,
              entrada_1: this.entrada_1,
              entrada_2: this.entrada_2,
              entrada_3: this.entrada_3,
              entrada_per_1: this.entrada_perc_1_padronizada,
              entrada_per_2: this.entrada_perc_2_padronizada,
              entrada_per_3: this.entrada_perc_3_padronizada,
              page: this.page,
              pageSize: this.pageSize,
              id_proposta: this.id_proposta,
              id_coluna: this.id_coluna,
              incluir_acessorios: this.incluir_acessorios,
              empresa_id: this.company_id,
              entrada_avaliacao: this.valor_avaliacao
            }
          }
        );

        console.log("Resultado do ranqueamento nova tabela");
        console.log(rank.data.dados);

        if (rank.status === 200) {
          this.parcelamento_1 = rank.data.dados.resumo_taxas.entrada_1.parcelas;
          this.totalPages_1 = rank.data.dados.resumo_taxas.entrada_1.totalPages;
          this.totalItems_1 = rank.data.dados.resumo_taxas.entrada_1.totalItems;

          console.log(
            "Taxa encontrada - 1",
            rank.data.dados.resumo_taxas.entrada_1.parcelas.length
          );
          if (rank.data.dados.resumo_taxas.entrada_1.parcelas.length === 0) {
            this.mensagemErro_1 =
              "Nenhuma taxa encontrada para os critérios informados para primeira entrada";
          }
          if (rank.data.dados.resumo_taxas.entrada_2.parcelas.length === 0) {
            this.mensagemErro_2 =
              "Nenhuma taxa encontrada para os critérios informados para segunda entrada";
          }
          if (rank.data.dados.resumo_taxas.entrada_3.parcelas.length === 0) {
            this.mensagemErro_3 =
              "Nenhuma taxa encontrada para os critérios informados para terceira entrada";
          }

          this.parcelamento_2 = rank.data.dados.resumo_taxas.entrada_2.parcelas;
          this.totalPages_2 = rank.data.dados.resumo_taxas.entrada_2.totalPages;
          this.totalItems_2 = rank.data.dados.resumo_taxas.entrada_2.totalItems;

          this.parcelamento_3 = rank.data.dados.resumo_taxas.entrada_3.parcelas;
          this.totalPages_3 = rank.data.dados.resumo_taxas.entrada_3.totalPages;
          this.totalItems_3 = rank.data.dados.resumo_taxas.entrada_3.totalItems;

          this.Valor_Entrada = this.currency(
            rank.data.dados.resumo_financeiro.total_entradas.entrada_1
          );
          this.Valor_Financiado = this.currency(
            rank.data.dados.resumo_financeiro.total_entradas.total_financiado_1
          );
          this.Valor_Entrada_2 = this.currency(
            rank.data.dados.resumo_financeiro.total_entradas.entrada_2
          );
          this.Valor_Financiado_2 = this.currency(
            rank.data.dados.resumo_financeiro.total_entradas.total_financiado_2
          );
          this.Valor_Entrada_3 = this.currency(
            rank.data.dados.resumo_financeiro.total_entradas.entrada_3
          );
          this.Valor_Financiado_3 = this.currency(
            rank.data.dados.resumo_financeiro.total_entradas.total_financiado_3
          );

          console.log(
            "Chamar metodos de ranqueamento",
            this.parcelamento_1.length
          );
        }
      } catch (error) {
        // Trata erros 404 e outros
        if (error.response) {
          // O servidor respondeu com um status de erro
          if (error.response.status === 404) {
            console.log("Nenhuma taxa encontrada");
            console.log("Mensagem do backend:", error.response.data.mensagem);

            // Aqui você pode limpar os dados da tabela ou mostrar uma mensagem para o usuário
            this.limparDadosTabela();
            this.mostrarMensagemNenhumaTaxa();
          } else {
            console.error("Erro no servidor:", error.response.status);
            console.error("Detalhes:", error.response.data);
          }
        } else if (error.request) {
          // A requisição foi feita mas não houve resposta
          console.error("Sem resposta do servidor");
        } else {
          // Algo aconteceu na configuração da requisição
          console.error("Erro na requisição:", error.message);
        }
      }
    },

    // Métodos auxiliares para limpar dados e mostrar mensagens
    limparDadosTabela() {
      this.parcelamento_1 = [];
      this.totalPages_1 = 0;
      this.totalItems_1 = 0;

      this.parcelamento_2 = [];
      this.totalPages_2 = 0;
      this.totalItems_2 = 0;

      this.parcelamento_3 = [];
      this.totalPages_3 = 0;
      this.totalItems_3 = 0;

      this.Valor_Entrada = 0;
      this.Valor_Financiado = 0;
      this.Valor_Entrada_2 = 0;
      this.Valor_Financiado_2 = 0;
      this.Valor_Entrada_3 = 0;
      this.Valor_Financiado_3 = 0;
    },

    mostrarMensagemNenhumaTaxa() {
      // Aqui você pode implementar uma notificação para o usuário
      // Exemplo: usando um toast, alert ou atualizando uma propriedade de mensagem
      this.mensagemErro =
        "Nenhuma taxa encontrada para os critérios informados";
      // Ou usar uma biblioteca de notificações como Vue Toastification
    },
    async retrieveFiltroRanqueamento() {
      const params = this.getRequestParamsFiltroTaxas(
        this.parcela,
        this.filtro_tipo_veiculo,
        this.filtro_tipo_tabela,
        this.filtro_spf,
        this.razao_financiamento,
        this.plano,
        this.page,
        this.pageSize,
        this.id_proposta,
        this.id_coluna
      );
      userService.getFiltroTaxas(params).then((response) => {
        const { parcelas_1, parcelas_2, parcelas_3, totalPages } =
          response.data;
        this.parcelamento_1 = parcelas_1;
        this.parcelamento_2 = parcelas_2;
        this.parcelamento_3 = parcelas_3;
        this.totalPages_1 = totalPages;
        this.totalPages_2 = totalPages;
        this.totalPages_3 = totalPages;
      });
    },
    async select_parcela(id_linha, item) {
      //Variaveis
      var entrada = 0;
      var parcela = 0;
      var id_coluna = 0;
      var id_proposta = 0;
      const pmt = item.pmt;
      const rentabilidade = item.rentabilidade;
      const id_taxa = item.id_taxa;
      console.log("Selecionando a parcela", id_linha, item);

      if (id_linha == 1) {
        if (this.id_coluna == 1) {
          //Variaveis
          entrada = this.entrada_1;
          parcela = this.parcela_1;
          id_coluna = this.id_coluna;
          id_proposta = this.id_proposta;
        }
        if (this.id_coluna == 2) {
          //Variaveis
          entrada = this.entrada_1;
          parcela = this.parcela_2;
          id_coluna = this.id_coluna;
          id_proposta = this.id_proposta;
        }
        if (this.id_coluna == 3) {
          //Variaveis
          entrada = this.entrada_1;
          parcela = this.parcela_3;
          id_coluna = this.id_coluna;
          id_proposta = this.id_proposta;
        }
      }
      if (id_linha == 2) {
        if (this.id_coluna == 1) {
          //Variaveis
          entrada = this.entrada_2;
          parcela = this.parcela_1;
          id_coluna = this.id_coluna;
          id_proposta = this.id_proposta;
        }
        if (this.id_coluna == 2) {
          //Variaveis
          entrada = this.entrada_2;
          parcela = this.parcela_2;
          id_coluna = this.id_coluna;
          id_proposta = this.id_proposta;
        }
        if (this.id_coluna == 3) {
          //Variaveis
          entrada = this.entrada_2;
          parcela = this.parcela_3;
          id_coluna = this.id_coluna;
          id_proposta = this.id_proposta;
        }
      }
      if (id_linha == 3) {
        if (this.id_coluna == 1) {
          //Variaveis
          entrada = this.entrada_3;
          parcela = this.parcela_1;
          id_coluna = this.id_coluna;
          id_proposta = this.id_proposta;
        }
        if (this.id_coluna == 2) {
          //Variaveis
          entrada = this.entrada_3;
          parcela = this.parcela_2;
          id_coluna = this.id_coluna;
          id_proposta = this.id_proposta;
        }
        if (this.id_coluna == 3) {
          //Variaveis
          entrada = this.entrada_3;
          parcela = this.parcela_3;
          id_coluna = this.id_coluna;
          id_proposta = this.id_proposta;
        }
      }
      await fetch(`${process.env.VUE_APP_API_URL}taxas/menu`, {
        method: "POST",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify({
          id: id_taxa,
          proposta_id: id_proposta,
          entrada: entrada,
          parcela: parcela,
          id_linha: id_linha,
          id_coluna: id_coluna,
          incluir_acessorios: this.incluir_acessorios,
          avaliacao: this.valor_avaliacao,
          financiamento_1: this.Valor_Financiado,
          financiamento_2: this.Valor_Financiado_2,
          financiamento_3: this.Valor_Financiado_3,
          pmt: pmt,
          rentabilidade: rentabilidade
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          return data.json();
        })
        .then((resposta) => {
          console.log("Parcela inserida com sucesso ------ " + resposta);
        });
    },

    //// Ranqueamento
    handlePageChangeFiltro(value) {
      this.page = value;
      this.retrieveFiltroRanqueamento();
    },
    handlePageSizeChangeFiltro(size) {
      this.pageSize = size;
      this.page = 1;
      this.retrieveFiltroRanqueamento();
    },
    async limpar_financiamento() {
      console.log("Limpar Ranqueamento!");
      const id = this.id_proposta;
      try {
        await fetch(
          `${process.env.VUE_APP_API_URL}proposta_limpar_entradas/${id}`,
          {
            method: "PUT",

            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: id
            })
          }
        )
          .then((data) => {
            if (!data.ok) {
              throw Error(data.status);
            }
            return data.json();
          })
          .then((resposta) => {
            console.log(resposta);
            window.location.reload();
            // if (resposta.StatusOk == 200) {
            //   this.excluir_todos_item_ac();
            //   window.location.reload();
            // }
          });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
        window.location.reload();
      }
    },

    ///Acessorios
    getRequestParamsAcessorios(
      searchCodigo,
      searchDescricao,
      page_acc,
      pageSize_acc
    ) {
      let params = {};
      if (searchCodigo) {
        params["codigo"] = searchCodigo;
      }
      if (searchDescricao) {
        params["descricao"] = searchDescricao;
      }
      if (page_acc) {
        params["page"] = page_acc - 1;
      }
      if (pageSize_acc) {
        params["size"] = pageSize_acc;
      }
      return params;
    },
    async handlePageChangeItemAcessorio(newPage) {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this.retrieveCliente(newPage);
        this.page_acc = newPage;
      } finally {
        this.isLoading = false;
      }
    },
    handlePageSizeChangeItemAcessorio(size) {
      this.pageSize_acc = size;
      this.page_acc = 1;
      this.retrieveCortesias();
    },

    habilitar_itens_acessorios() {
      this.retrieveCortesias();
      this.modal_itens_acessorios = true;
      this.btn_ranquear = false;
    },
    async retrieveCortesias(page = this.page_acc) {
      try {
        const params = this.getRequestParamsAcessorios(
          this.searchCodigo,
          this.searchDescricao,
          page,
          this.pageSize_acc
        );

        const response = await userService.getCortesias(params);
        const { cortesias, totalPages, totalItems } = response.data;

        this.cortesias = cortesias;
        this.totalPages = totalPages;
        this.totalItems_acc = totalItems;

        console.log("Itens Cortesias");
        console.log(this.cortesias);
        return true; // Indica sucesso
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
        if (error.response?.status === 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
        return false; // Indica falha
      }
    },
    async retrieveItensCortesia() {
      try {
        const id_proposta = this.id_proposta;
        userService.getItensCortesiaId(id_proposta).then((response) => {
          var itens_ac = [];
          var itens_ac2 = [];
          const { rows } = response.data;
          console.log("Todos os itens --------");
          console.log(rows);
          // Soma os valores de todos os itens retornados
          const somaTotal = rows.reduce((total, item) => {
            // Converte o valor para número (tratando casos de valor inválido)
            const valor = Number(item.valor) || 0;
            return total + valor;
          }, 0);

          this.Valor_Itens_Acessorios = this.currency(somaTotal);

          console.log("Soma dos itens cortesia:", somaTotal);

          for (var i = 0; i < rows.length; i++) {
            var arr_ac = {
              id: rows[i]["id"],
              proposta_id: rows[i]["proposta_id"],
              custo: this.currency(rows[i]["custo"]),
              valor: this.currency(rows[i]["valor"]),
              descricao: rows[i]["descricao"],
              createdAt: rows[i]["createdAt"],
              updatedAt: rows[i]["updatedAt"]
            };
            itens_ac = arr_ac;
            itens_ac2.push(itens_ac);
          }

          this.itens_cortesias = itens_ac2;
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },
    inserirAcessorios(item) {
      (this.descricaoAcessorio = item.descricao),
        (this.valorAcessorio = item.preco_venda),
        (this.custoAcessorio = item.preco_base_peca);
      this.itensAcessorios();
    },
    async itensAcessorios() {
      const response = await fetch(
        `${process.env.VUE_APP_API_URL}itens_cortesias`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            descricao: this.descricaoAcessorio,
            valor: this.valorAcessorio,
            custo: this.custoAcessorio,
            proposta_id: this.id_proposta
          })
        }
      );
      const resp = JSON.stringify(response.status);
      if (resp == 200) {
        this.modal = true;
        this.dialog = true;
        // Limpar Fomulário
        this.modal_itens_acessorios = false;
        this.message = "Item inserido com sucesso!";
        setTimeout(() => (this.dialog = false), 4000);
        this.retrieveItensCortesia();
      } else {
        this.modal = true;
        this.dialog = true;
        this.message = "Erro ao inserir o item";
        setTimeout(() => (this.dialog = false), 4000);
      }
      this.inserir_desconto();
    },
    ///Resumo

    getRequestParamsPMT(id, ordem, entrada_total, financiamento_total) {
      let params = {};
      if (id) {
        params["id_proposta"] = id;
      }
      if (ordem) {
        params["ordem"] = ordem;
      }
      if (entrada_total) {
        params["entrada_total"] = entrada_total;
      }
      if (financiamento_total) {
        params["financiamento_total"] = financiamento_total;
      }

      return params;
    },
    select_pmt(value, ordem) {
      this.Pmt = value;
      this.pmtSelected = ordem;
      const id = this.id_proposta;
      //Primeira Linha
      if (ordem == 11) {
        this.Valor_Entrada = this.Valor_Entrada_1;
        this.Valor_Financiado = this.Valor_Financiado_1;
        this.Quantidade_Meses = this.Quantidade_Meses_1; //12
        const params = this.getRequestParamsPMT(
          id,
          ordem,
          this.Valor_Entrada,
          this.valor_avaliacao
        );
        userService.getProposta_pmt(params).then((response) => {
          console.log(response.data);
        });
      }
      if (ordem == 12) {
        this.Valor_Entrada = this.Valor_Entrada_1;
        this.Valor_Financiado = this.Valor_Financiado_1;
        this.Quantidade_Meses = this.Quantidade_Meses_2; //24
        const params = this.getRequestParamsPMT(
          id,
          ordem,
          this.Valor_Entrada,
          this.valor_avaliacao
        );
        userService.getProposta_pmt(params).then((response) => {
          console.log(response.data);
        });
      }
      if (ordem == 13) {
        this.Valor_Entrada = this.Valor_Entrada_1;
        this.Valor_Financiado = this.Valor_Financiado_1;
        this.Quantidade_Meses = this.Quantidade_Meses_3; //36
        const params = this.getRequestParamsPMT(
          id,
          ordem,
          this.Valor_Entrada,
          this.valor_avaliacao
        );
        userService.getProposta_pmt(params).then((response) => {
          console.log(response.data);
        });
      }
      //Segunda Linda
      if (ordem == 21) {
        this.Valor_Entrada = this.Valor_Entrada_2;
        this.Valor_Financiado = this.Valor_Financiado_2;
        this.Quantidade_Meses = this.Quantidade_Meses_1;
        const params = this.getRequestParamsPMT(
          id,
          ordem,
          this.Valor_Entrada,
          this.valor_avaliacao
        );
        userService.getProposta_pmt(params).then((response) => {
          console.log(response.data);
        });
      }
      if (ordem == 22) {
        this.Valor_Entrada = this.Valor_Entrada_2;
        this.Valor_Financiado = this.Valor_Financiado_2;
        this.Quantidade_Meses = this.Quantidade_Meses_2;
        const params = this.getRequestParamsPMT(
          id,
          ordem,
          this.Valor_Entrada,
          this.valor_avaliacao
        );
        userService.getProposta_pmt(params).then((response) => {
          console.log(response.data);
        });
      }
      if (ordem == 23) {
        this.Valor_Entrada = this.Valor_Entrada_2;
        this.Valor_Financiado = this.Valor_Financiado_2;
        this.Quantidade_Meses = this.Quantidade_Meses_3;
        const params = this.getRequestParamsPMT(
          id,
          ordem,
          this.Valor_Entrada,
          this.valor_avaliacao
        );
        userService.getProposta_pmt(params).then((response) => {
          console.log(response.data);
        });
      }
      //Terceira Linha
      if (ordem == 31) {
        this.Valor_Entrada = this.Valor_Entrada_3;
        this.Valor_Financiado = this.Valor_Financiado_3;
        this.Quantidade_Meses = this.Quantidade_Meses_1;
        const params = this.getRequestParamsPMT(
          id,
          ordem,
          this.Valor_Entrada,
          this.valor_avaliacao
        );
        userService.getProposta_pmt(params).then((response) => {
          console.log(response.data);
        });
      }
      if (ordem == 32) {
        this.Valor_Entrada = this.Valor_Entrada_3;
        this.Valor_Financiado = this.Valor_Financiado_3;
        this.Quantidade_Meses = this.Quantidade_Meses_2;
        const params = this.getRequestParamsPMT(
          id,
          ordem,
          this.Valor_Entrada,
          this.valor_avaliacao
        );
        userService.getProposta_pmt(params).then((response) => {
          console.log(response.data);
        });
      }
      if (ordem == 33) {
        this.Valor_Entrada = this.Valor_Entrada_3;
        this.Valor_Financiado = this.Valor_Financiado_3;
        this.Quantidade_Meses = this.Quantidade_Meses_3;
        const params = this.getRequestParamsPMT(
          id,
          ordem,
          this.Valor_Entrada,
          this.valor_avaliacao
        );
        userService.getProposta_pmt(params).then((response) => {
          console.log(response.data);
        });
      }
      //window.location.reload();
      //this.resumo()
      this.checar_pmt_escolhido();
      this.habilitar_proposta();
    },

    preparar_dados_menu() {
      const id = this.id_proposta;
      const dados = {
        id: id,
        val_sugerido_venda: this.Valor_Sugerido,
        custos_variaveis: this.Valor_Custo_variaveis,
        acessorios: this.Valor_Itens_Acessorios,
        val_entrada_veiculo: this.Valor_Avaliacao_Final,
        val_entrada_financiamento: this.Valor_Entrada,
        val_financiamento: this.Valor_Financiado,
        lucro_operacional: this.Lucro_Bruto,
        lucro_gerencial: this.Lucro_Operacional,
        lucro_financiamento: this.Valor_Resultado_Financiamento,
        lucro_final: this.Lucro_liquido
      };

      this.dados_menu = dados;
    },

    async solicitar_aprovacao() {
      const id = this.id_proposta;
      const lucro_bruto = this.Lucro_Bruto;
      const lucro_gerencial = this.Lucro_Operacional;
      const lucro_liquido = this.Lucro_liquido;
      const val_entrada_financiamento = this.Valor_Entrada;
      const val_financiamento = this.Valor_Financiado;
      const tipo_pagamento = this.forma_pagamento;
      const erros = {};

      // Verifique cada campo obrigatório
      if (!this.cliente) {
        erros.cliente = "Campo 'Cliente' é obrigatório.";
      }
      if (!this.cpfCnpj) {
        erros.cpfCnpj = "Campo 'CPF/CNPJ' é obrigatório.";
      }
      if (!this.endereco) {
        erros.endereco = "Campo 'Endereço' é obrigatório.";
      }
      if (!this.uf) {
        erros.uf = "Campo 'UF' é obrigatório.";
      }
      if (!this.cidade) {
        erros.cidade = "Campo 'Cidade' é obrigatório.";
      }
      if (!this.bairro) {
        erros.bairro = "Campo 'Bairro' é obrigatório.";
      }
      if (!this.cep) {
        erros.cep = "Campo 'CEP' é obrigatório.";
      }
      if (!this.tel) {
        erros.tel = "Campo 'Telefone' é obrigatório.";
      }
      if (!this.previsao_faturamento) {
        erros.previsao_faturamento =
          "Campo 'Previsão de Faturamento' é obrigatório.";
      }

      // Verifique se há erros
      if (Object.keys(erros).length > 0) {
        this.abrir_modal = true;
        this.hab_avista = true;
        this.msg =
          "Antes de solicitar aprovação de venda, preencha os campos obrigatórios!";

        // Construa a mensagem de erro com detalhes
        for (const campo in erros) {
          this.msg += `\n${erros[campo]}`;
        }

        setTimeout(() => (this.abrir_modal = false), 4000);
        return;
      }

      await fetch(
        `${process.env.VUE_APP_API_URL}solicitar_venda_finalizada/${id}`,
        {
          method: "PUT",

          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: id,
            status_proposta: "Aprovação",
            lucro_operacional: lucro_bruto,
            lucro_gerencial: lucro_gerencial,
            lucro_final: lucro_liquido,
            val_entrada_financiamento: val_entrada_financiamento,
            val_financiamento: val_financiamento,
            tipo_pagamento: tipo_pagamento,
            empresa_id: this.company_id,
            previsao_faturamento: this.previsao_faturamento,
            vendedor_id: this.user_log,
            qtd_meses: this.Quantidade_Meses
          })
        }
      )
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          this.update_dispo(this.g_menu_vendedor_id);
          return data.json();
        })
        .then((resposta) => {
          router.push({
            path: "/desk/index",
            query: { empresa_id: encodeURIComponent(this.empresaID) }
          });
          console.log(resposta);
        });
    },
    async solicitar_venda_perdida() {
      const id = this.id_proposta;
      if (!this.modelo_proposta) {
        this.abrir_modal = true;
        this.msg =
          "Para finalizar como venda perdida é necessário inserir um veículo!";
        setTimeout(() => (this.abrir_modal = false), 4000);
        return;
      }
      if (this.just_venda_perdida < 30) {
        this.abrir_modal = true;
        this.msg =
          "Para finalizar como venda perdida é necessário preencher o campo informações Adicionais! Obrigatório o mínimo de 30 caracteres!";
        setTimeout(() => (this.abrir_modal = false), 4000);
        return;
      }

      await fetch(`${process.env.VUE_APP_API_URL}venda_perdida/${id}`, {
        method: "PUT",

        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: id,
          status_proposta: "Venda Perdida",
          motivo_venda_perdida: this.just_venda_perdida,
          gerente_id_alteracao: this.$store.state.auth.user.id
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          this.update_dispo(this.g_menu_vendedor_id);
          return data.json();
        })
        .then((resposta) => {
          router.push({
            path: "/desk/indexGerente",
            query: { empresa_id: encodeURIComponent(this.empresaID) }
          });
          console.log(resposta);
        });
    },
    async finalizar_venda() {
      console.log("Nenhum veículo encontrado");
      const id = this.id_proposta;
      const lucro_bruto = this.Lucro_Bruto;
      const lucro_gerencial = this.Lucro_Operacional;
      const lucro_liquido = this.Lucro_liquido;
      const val_entrada_financiamento = this.Valor_Entrada;
      const val_financiamento = this.Valor_Financiado;
      const tipo_pagamento = this.forma_pagamento;
      const erros = {};

      // Verifique cada campo obrigatório
      if (!this.cliente) {
        erros.cliente = "Campo 'Cliente' é obrigatório.";
      }
      if (!this.cpfCnpj) {
        erros.cpfCnpj = "Campo 'CPF/CNPJ' é obrigatório.";
      }
      if (!this.endereco) {
        erros.endereco = "Campo 'Endereço' é obrigatório.";
      }
      if (!this.uf) {
        erros.uf = "Campo 'UF' é obrigatório.";
      }
      if (!this.cidade) {
        erros.cidade = "Campo 'Cidade' é obrigatório.";
      }
      if (!this.bairro) {
        erros.bairro = "Campo 'Bairro' é obrigatório.";
      }
      if (!this.cep) {
        erros.cep = "Campo 'CEP' é obrigatório.";
      }
      if (!this.tel) {
        erros.tel = "Campo 'Telefone' é obrigatório.";
      }
      if (!this.previsao_faturamento) {
        erros.previsao_faturamento =
          "Campo 'Previsão de Faturamento' é obrigatório.";
      }

      // Verifique se há erros
      if (Object.keys(erros).length > 0) {
        this.abrir_modal = true;
        this.hab_avista = true;
        this.msg =
          "Antes de finzalizar a venda preencha os campos obrigatórios!";

        // Construa a mensagem de erro com detalhes
        for (const campo in erros) {
          this.msg += `\n${erros[campo]}`;
        }

        setTimeout(() => (this.abrir_modal = false), 4000);
        return;
      }

      await fetch(`${process.env.VUE_APP_API_URL}venda_finalizada/${id}`, {
        method: "PUT",

        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: id,
          status_proposta: "Venda Finalizada",
          lucro_operacional: lucro_bruto,
          lucro_gerencial: lucro_gerencial,
          lucro_final: lucro_liquido,
          val_entrada_financiamento: val_entrada_financiamento,
          val_financiamento: val_financiamento,
          tipo_pagamento: tipo_pagamento,
          empresa_id: this.company_id,
          previsao_faturamento: this.previsao_faturamento
        })
      })
        .then((data) => {
          if (!data.ok) {
            throw Error(data.status);
          }
          this.update_dispo(this.g_menu_vendedor_id);
          return data.json();
        })
        .then((resposta) => {
          router.push({
            path: "/desk/indexGerente",
            query: { empresa_id: encodeURIComponent(this.empresaID) }
          });
          console.log(resposta);
        });
    },

    async update_dispo(item) {
      const id = item;
      const response = await fetch(
        `${process.env.VUE_APP_API_URL}status_vendedor/${id}`,
        {
          method: "PUT",

          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            status_vendedor: 1
          })
        }
      );
      const resp = JSON.stringify(response.status);
      console.log(resp);
      if (resp == 200) {
        this.dialog = true;
        this.message = "Vendedor se tornou Indisponível!";
      }
    },

    numberToReal(numb) {
      var numero = numb.toFixed(0).split(".");
      numero[0] = numb[0].split(/(?=(?:...)*$)/).join(".");
      return numero.join(".");
    },
    currency(number) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      }).format(number);
    },
    ParseFloat(str, val) {
      str = str.toString();
      str = str.slice(0, str.indexOf(".") + val + 1);
      return Number(str);
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "";

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    openClienteFoundByCpfCnpjModal() {
      const modalElement = document.getElementById(
        "clienteFoundByCpfCnpjModal"
      );
      this.clienteFoundByCpfCnpjModal = new Modal(modalElement);
      this.clienteFoundByCpfCnpjModal.show();
    },
    closeClienteFoundByCpfCnpjModal() {
      this.clienteFoundByCpfCnpjModal?.hide();
      this.clienteFoundByCpfCnpjModal = null;
    },
    vData() {
      const cpf_cnpj = this.cpfCnpj.replace(/[^0-9]/g, "");

      if (this.formata_cpf_cnpj(cpf_cnpj) == false) {
        this.abrir_modal = true;
        this.msg = "CPF/CNPJ inválido";
        this.cpfCnpj = "";
        setTimeout(() => (this.abrir_modal = false), 4000);
      } else {
        this.cpfCnpj = this.formata_cpf_cnpj(cpf_cnpj);

        if (this.initialCpfCnpj === cpf_cnpj) {
          this.cliente_update_disabled = false;
          return;
        }

        userService.getClienteByCpfCnpj(cpf_cnpj).then(({ data }) => {
          if (!data) {
            this.cliente_update_disabled = false;
            return;
          }
          this.modal_cliente_id = data.id;
          this.modal_cliente = data.nome;
          this.modal_cpfCnpj = this.formata_cpf_cnpj(data.cpfCnpj) || "";
          this.modal_dataNascimento = this.formatDate(data.nascimento);
          this.modal_email = data.email;
          this.modal_endereco = data.endereco;
          this.modal_complemento = data.complemento;
          this.modal_uf = data.uf;
          this.modal_cidade = data.cidade;
          this.modal_bairro = data.bairro;
          this.modal_cep = data.cep;
          this.modal_tel = data.tel;
          this.modal_cel = data.cel;
          this.cliente_update_disabled = true;
          this.openClienteFoundByCpfCnpjModal();
        });
      }
    },
    acceptClienteFoundByCpfCnpjInfo() {
      const id = this.id_proposta;
      fetch(`${process.env.VUE_APP_API_URL}proposta_troca_cliente/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          cliente_id: this.modal_cliente_id,
          cliente_id_antigo: this.id_cliente
        })
      }).then(() => {
        this.id_cliente = this.modal_cliente_id;
        this.cliente_id = this.modal_cliente_id;
        this.cliente = this.modal_cliente;
        this.cpfCnpj = this.modal_cpfCnpj;
        this.initialCpfCnpj = this.modal_cpfCnpj;
        this.dataNascimento = this.modal_dataNascimento;
        this.email = this.modal_email;
        this.endereco = this.modal_endereco;
        this.complemento = this.modal_complemento;
        this.uf = this.modal_uf;
        this.cidade = this.modal_cidade;
        this.bairro = this.modal_bairro;
        this.cep = this.modal_cep;
        this.tel = this.modal_tel;
        this.cel = this.modal_cel;
        this.cliente_update_disabled = false;
        this.closeClienteFoundByCpfCnpjModal();
      });
    },
    vTel() {
      var telefone = this.tel;
      this.tel = this.tel.replace(/\D/g, "");
      if (this.tel.length >= 10 && this.tel.length <= 11) {
        this.tel = this.formata_tel(telefone);
      } else {
        this.tel = "";
        this.abrir_modal = true;
        this.msg = "Número de telefone incorreto";
        setTimeout(() => (this.abrir_modal = false), 4000);
      }

      //this.tel = this.formata_tel(telefone);

      // const edit_tel = this.edit_telefone;
      // this.edit_telefone = this.formata_tel(edit_tel);
    },
    vTel2() {
      var telefone2 = this.cel;
      this.cel = this.cel.replace(/\D/g, "");
      if (this.cel.length >= 10 && this.cel.length <= 11) {
        this.cel = this.formata_tel(telefone2);
        if (this.tel == this.cel) {
          this.abrir_modal = true;
          this.msg = "Telefones não podem ser iguais!";
          this.cel = "";
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      } else {
        this.cel = "";
        this.abrir_modal = true;
        this.msg = "Número de telefone incorreto";
        setTimeout(() => (this.abrir_modal = false), 4000);
      }

      //this.tel = this.formata_tel(telefone);

      // const edit_tel = this.edit_telefone;
      // this.edit_telefone = this.formata_tel(edit_tel);
    },
    validateEmail(email) {
      console.log("Testando email");
      console.log(email);
      var re = /\S+@\S+\.\S+/;
      if (re.test(email) == false) {
        this.abrir_modal = true;
        this.email = "";
        this.msg = "Digite um email válido, ex: email@email.com!";
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },
    verifica_tel(valor) {
      valor = valor.toString();
      valor = valor.replace(/[^0-9]/g, "");
      if (valor.length === 10) {
        return "TELEFONE";
      } else if (valor.length === 11) {
        return "CELULAR";
      } else {
        return false;
      }
    },
    formata_tel(valor) {
      var formatado = false;
      var valida = this.verifica_tel(valor);
      valor = valor.toString();
      valor = valor.replace(/[^0-9]/g, "");
      if (valida === "TELEFONE") {
        formatado = valor.substr(0, 2) + " ";
        formatado += valor.substr(2, 4) + "-";
        formatado += valor.substr(6, 4) + "";
      } else if (valida === "CELULAR") {
        formatado = valor.substr(0, 2) + " ";
        formatado += valor.substr(2, 5) + "-";
        formatado += valor.substr(7, 4) + "";
      } else {
        formatado = valor;
      }
      return formatado;
    },
    verifica_cpf_cnpj(valor) {
      valor = valor.toString();
      valor = valor.replace(/[^0-9]/g, "");
      if (valor.length === 11) {
        return "CPF";
      } else if (valor.length === 14) {
        return "CNPJ";
      } else {
        return false;
      }
    },
    calc_digitos_posicoes(digitos, posicoes = 10, soma_digitos = 0) {
      digitos = digitos.toString();
      for (var i = 0; i < digitos.length; i++) {
        soma_digitos = soma_digitos + digitos[i] * posicoes;
        posicoes--;
        if (posicoes < 2) {
          posicoes = 9;
        }
      }
      soma_digitos = soma_digitos % 11;
      if (soma_digitos < 2) {
        soma_digitos = 0;
      } else {
        soma_digitos = 11 - soma_digitos;
      }
      var cpf = digitos + soma_digitos;
      return cpf;
    },
    valida_cpf(valor) {
      valor = valor.toString();
      valor = valor.replace(/[^0-9]/g, "");
      var digitos = valor.substr(0, 9);
      var novo_cpf = this.calc_digitos_posicoes(digitos);
      novo_cpf = this.calc_digitos_posicoes(novo_cpf, 11);
      if (novo_cpf === valor) {
        return true;
      } else {
        return false;
      }
    },
    valida_cnpj(valor) {
      valor = valor.toString();
      valor = valor.replace(/[^0-9]/g, "");
      var cnpj_original = valor;
      var primeiros_numeros_cnpj = valor.substr(0, 12);
      var primeiro_calculo = this.calc_digitos_posicoes(
        primeiros_numeros_cnpj,
        5
      );
      var segundo_calculo = this.calc_digitos_posicoes(primeiro_calculo, 6);
      var cnpj = segundo_calculo;
      if (cnpj === cnpj_original) {
        return true;
      }
      return false;
    },
    valida_cpf_cnpj(valor) {
      var valida = this.verifica_cpf_cnpj(valor);
      valor = valor.toString();
      valor = valor.replace(/[^0-9]/g, "");
      if (valida === "CPF") {
        return this.valida_cpf(valor);
      } else if (valida === "CNPJ") {
        return this.valida_cnpj(valor);
      } else {
        return false;
      }
    },

    configurar_taxas(valor, campoEntrada, campoEntradaPer) {
      let input = null;
      var taxaMinima = 20;
      var taxaMaxima = 40; // Modificar para buscar no banco de dados
      const incremento = 10;

      // Certifique-se de que a taxaMinima e a taxaMaxima são múltiplos do incremento
      const min = Math.floor(taxaMinima / incremento) * incremento;
      const max = Math.floor(taxaMaxima / incremento) * incremento;

      // Caso o valor seja menor que a taxa mínima, retorna a taxa mínima
      if (valor < min) {
        input = min;
        this.habilitar_ranquear();
      } else {
        // Verifica cada intervalo de incremento até a taxa máxima permitida
        for (let taxa = min; taxa <= max; taxa += incremento) {
          if (valor >= taxa && valor < taxa + incremento) {
            input = taxa;
            this.habilitar_ranquear();
            break;
          }
        }

        // Caso o valor seja maior ou igual à taxa máxima configurada
        if (valor >= max) {
          input = max;
          if (valor > 98) {
            console.log("Entrada maior que o permitido");

            // Apaga o valor do campo correspondente
            this[campoEntrada] = "";
            this[campoEntradaPer] = "";

            this.hab_ranquear = true;
            this.hab_financiamento = true;

            this.msg = "Valor da entrada ultrapassou o máximo permitido";
            this.abrir_modal = true;

            // Fecha a mensagem após 8 segundos
            setTimeout(() => {
              this.hab_financiamento = false;
              this.abrir_modal = false;
            }, 5000);
          }
        }
      }

      return input;
    },

    habilitar_ranquear() {
      if (
        this.entrada_1_perc !== "" &&
        this.entrada_1_perc <= 98 &&
        this.entrada_2_perc !== "" &&
        this.entrada_2_perc <= 98 &&
        this.entrada_3_perc !== "" &&
        this.entrada_3_perc <= 98
      ) {
        this.hab_ranquear = false;
        console.log("habilitar");
      } else {
        this.hab_ranquear = true;
        console.log("Desabilitar");
      }
    },
    formata_cpf_cnpj(valor) {
      var formatado = false;
      var valida = this.verifica_cpf_cnpj(valor);
      valor = valor.toString();
      valor = valor.replace(/[^0-9]/g, "");
      if (valida === "CPF") {
        if (this.valida_cpf(valor)) {
          formatado = valor.substr(0, 3) + ".";
          formatado += valor.substr(3, 3) + ".";
          formatado += valor.substr(6, 3) + "-";
          formatado += valor.substr(9, 2) + "";
        }
      } else if (valida === "CNPJ") {
        if (this.valida_cnpj(valor)) {
          formatado = valor.substr(0, 2) + ".";
          formatado += valor.substr(2, 3) + ".";
          formatado += valor.substr(5, 3) + "/";
          formatado += valor.substr(8, 4) + "-";
          formatado += valor.substr(12, 14) + "";
        }
      }
      return formatado;
    }
  },
  created() {
    // Adicione ouvintes de eventos para reiniciar o temporizador quando houver interação do usuário
    window.addEventListener("mousemove", this.resetTimer);
    window.addEventListener("keydown", this.resetTimer);
  },
  beforeUnmount() {
    // Remova os ouvintes de eventos ao destruir o componente
    window.removeEventListener("mousemove", this.resetTimer);
    window.removeEventListener("keydown", this.resetTimer);
  },

  //Avaliação
  updateSelectedOption() {
    const selectedOption = this.marcas.find(
      (option) => option.descricao === this.selectedOption.descricao
    );
    if (selectedOption) {
      this.selectedOption = {
        id: selectedOption.id,
        descricao: selectedOption.descricao
      };
    } else {
      this.selectedOption = { id: null, descricao: "" };
    }
  }
};
</script>
<style scoped>
/* Grid container */
.pagamento-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 0;
  border: 1px solid #dee2e6;
}

/* Cada item do pagamento */
.pagamento-item {
  border: 1px solid #dee2e6;
  padding: 6px 4px;
  text-align: center;
  background: #fff;
}

/* Cabeçalho do grid */
.pagamento-grid-header {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  background: #f8f9fa;
  font-weight: bold;
  border-bottom: 2px solid #dee2e6;
}

.pagamento-grid-header div {
  border-right: 1px solid #dee2e6;
  padding: 6px 4px;
  text-align: center;
  font-size: 11px;
}

/* Para PDF */
@media print {
  .pagamento-grid {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  }

  .pagamento-item {
    font-size: 9px;
  }
}
</style>
